webpackJsonp([14943580662024],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"data":{"allSitePage":{"edges":[{"node":{"id":"SitePage /dev-404-page/","path":"/dev-404-page/","context":null}},{"node":{"id":"SitePage /educacion/1/1","path":"/educacion/1/1","context":{"slug":"educacion/1/1","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"1","card":"¿Cómo funcionan las escuelas en Estados Unidos?","text":"<p>La educación en Estados Unidos está <b>descentralizada</b> y las mayoría de reglas varían dependiendo del estado y el distrito escolar. </p><p>Un distrito escolar es la <b>unidad geográfica</b> para administrar escuelas, que puede ser un condado, una parte de este o una colección de condados. </p><p> En la mayoría de los estados las leyes exigen que todos los niños entre los <b>6 y los 16 años</b> vayan a la escuela. </p><p>En muchos estados es posible educar a los hijos en casa, lo que se conoce como <a href=\"http://www.univision.com/estilo-de-vida/papas-y-mamas/el-homeschooling-o-la-educacion-en-casa-algunos-puntos-de-vista\"><i>home schooling</i>.</a></p><p> Tus hijos pueden entrar a una escuela pública, privada, magnet o charter. <br></p>","url":"https://www.univision.com/noticias/educacion/como-funcionan-las-escuelas-en-estados-unidos","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/2","path":"/educacion/1/2","context":{"slug":"educacion/1/2","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"2","card":"¿Cuál es la diferencia entre una escuela pública y una privada?","text":"<p>En EEUU hay escuelas públicas y privadas. Cada estado decide lo que se enseña en las escuelas públicas, aunque en los últimos años se han estandarizado cada vez más los currículos (con <a href=\"http://www.univision.com/noticias/estandares-academicos/que-son-los-estandares-academicos-o-common-core-standards\">un programa llamado <i>Common Core</i>). </a></p><p>Las escuelas públicas son gratuitas y en ellas no debería haber instrucción religiosa. El dinero para pagar las escuelas públicas proviene de los impuestos a la propiedad.</p> <p>Las escuelas privadas cobran una matrícula conocida como <i>tuition</i>, y casi el 70% son administradas por grupos religiosos.</p>","url":"https://www.univision.com/noticias/educacion/cual-es-la-diferencia-entre-una-escuela-publica-y-una-privada","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/3","path":"/educacion/1/3","context":{"slug":"educacion/1/3","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"3","card":"¿A qué edad tienen que entrar los niños al preescolar?","text":"<p>En general, los niños pueden empezar en un programa preescolar alrededor de los 4 años de edad (en algunos estados desde los 3 años, aquí puedes consultar las edades para entrar en cada estado https://nces.ed.gov/programs/statereform/tab5_3.asp).</p> <p>No todos los distritos escolares ofrecen programas públicos de preescolar y los padres deben recurrir a instituciones privadas (<a href=\"http://www.univision.com/estilo-de-vida/asi-se-vive-mejor-familia/ventajas-y-desventajas-de-dejar-al-bebe-en-el-daycare-fotos\">algunas de las cuales ofrecen servicios de “<i>day care</i></a>”, desde muy temprana edad). </p>","url":"https://www.univision.com/noticias/educacion/a-que-edad-tienen-que-entrar-los-ninos-al-preescolar","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/4","path":"/educacion/1/4","context":{"slug":"educacion/1/4","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"4","card":"¿A qué edad tienen que entrar los niños al kindergarden?","text":"<p>Cuando los niños cumplen 5 años pueden ingresar a un kindergarden (que tampoco son ofrecidos obligatoriamente por todos los distritos).</p><p>Los niños no están obligados a ir al kindergarden, pero es una experiencia muy valiosa y ayuda a preparar al niño para la escuela primaria o <i>elementary school</i>.</p>","url":"https://www.univision.com/noticias/educacion/a-que-edad-tienen-que-entrar-los-ninos-al-kindergarden","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/5","path":"/educacion/1/5","context":{"slug":"educacion/1/5","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"5","card":"¿Cómo sé a qué grado debe entrar mi hijo?","text":"<p>La edad determina el grado en el que debe estar el estudiante.</p> <p>En general, la escuela primaria (<i>elementary school</i>), de primero a quinto grado, acoge a los niños entre los 6 y los 10 años.</p><p>La escuela intermedia (<i>middle school</i>), de sexto a octavo grado, a niños entre 11 y 13 años de edad. También se conoce como junior high school o junior high y en algnos estados es solo séptimo y octavo grado.</p><p>a escuela secundaria (<i>high school</i>), o preparatoria, va del grado noveno al 12, y acoge a niños entre 14 y 18 años.</p><p>En total, los niños tienen que estudiar obligatoriamente 12 años antes de llegar a la educación superior.</p>","url":"https://www.univision.com/noticias/educacion/como-se-a-que-grado-debe-entrar-mi-hijo","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/6","path":"/educacion/1/6","context":{"slug":"educacion/1/6","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"6","card":"¿Dónde matriculo a mi hijo en la escuela pública?","text":"<p>Las escuelas públicas están divididas en <b>distritos escolares. </b></p><p>Por lo general los estudiantes asisten a la escuela del <b>distrito escolar donde viven sus padres. </b></p><p>Por eso es tan importante tener en cuenta la calidad de las escuelas a la hora de <b>elegir el sitio donde vas a vivir.</b></p>","url":"https://www.univision.com/noticias/educacion/donde-matriculo-a-mi-hijo-en-la-escuela-publica","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/7","path":"/educacion/1/7","context":{"slug":"educacion/1/7","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"7","card":"Si los padres están separados, ¿a dónde van a la escuela los hijos?","text":"<p>Si los padres están separados, el estudiante asiste a la escuela del distrito donde vive <b>el padre que tiene la custodia</b> (o con el que pasa la mayor cantidad de tiempo, eso lo determina un juez de familias en una corte). </p><p>Para saber cuál es la escuela a la que deben asistir tus hijos lo mejor es <b>llamar o visitar la oficina principal de su distrito escolar.</b></p>","url":"https://www.univision.com/noticias/educacion/si-los-padres-estan-separados-a-donde-van-a-la-escuela-los-hijos","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/8","path":"/educacion/1/8","context":{"slug":"educacion/1/8","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"8","card":"Si me mudo durante el año escolar, ¿mi hijo tiene que cambiar de colegio?","text":"<p>El estudiante puede quedarse en la escuela <b>durante el resto del semestre</b> o pedir permiso para quedarse todo el año. </p><p>De hecho, un estudiante puede presentar una <b>solicitud para asistir</b> a una escuela pública que esté por <b>fuera de su distrito. </b></p><p>Debe pasar un proceso de <b>autorización</b> de la transferencia y los cupos <b>no siempre</b> están garantizados.</p>","url":"https://www.univision.com/noticias/educacion/si-me-mudo-durante-el-ano-escolar-mi-hijo-tiene-que-cambiar-de-colegio","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/9","path":"/educacion/1/9","context":{"slug":"educacion/1/9","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"9","card":"¿Cómo es la jornada escolar en Estados Unidos?","text":"<p>En casi todos los estados el año escolar comienza en <b>agosto o septiembre</b> y termina en <b>mayo o junio</b> del año siguiente. </p><p>Hay cerca de tres meses de vacaciones de verano de <b>junio a agosto</b>. </p><p>La jornada regular normal va de <b>lunes a viernes</b>, comienza temprano en la mañana y acaba después del mediodía, dura usualmente entre <b>5 y 7 horas</b>. </p><p>La mayoría de estudiantes <b>almuerzan en la escuela</b>, donde ofrecen almuerzo y desayuno <b>gratuito</b> o a un precio muy reducido para los estudiantes que califiquen por tener menos ingresos familiares.</p><p>Si el estudiante tiene que <b>salir temprano</b> (por una cita médica o dental, por ejemplo) es necesario escribir <b>una nota</b> a la escuela que debe ser entregada al comenzar el día. Cuando los padres vayan a recogerlos tienen que ir a la <b>oficina principal</b> y allí la administración contactará al niño.</p>","url":"https://www.univision.com/noticias/educacion/como-es-la-jornada-escolar-en-estados-unidos","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/10","path":"/educacion/1/10","context":{"slug":"educacion/1/10","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"10","card":"¿Qué pasa si mi hijo llega tarde a la escuela?","text":"<p>Los niños están obligados a <b>llegar a tiempo</b> a la escuela. </p><p>Las escuelas le dan mucha importancia a la asistencia de los niños: si un estudiante excede un número de faltas o tardanzas puede ser castigado con <b><i>detention</i> o suspensión</b>. </p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> Si el estudiante va a llegar tarde, un <b>guardián autorizado</b> debe <b>llamar</b> a la administración de la escuela o enviar una<b> nota firmada</b> con el niño explicando el motivo de la tardanza. </span></p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Cada escuela determina cuál es ese número de faltas o tardanzas aceptables. Para algunas, por ejemplo, tres tardanzas equivalen a una ausencia, y tres faltas conllevan a una suspensión. <b>Averigua con la escuela de tu hijo</b> cuál es su sistema.</span></p>","url":"https://www.univision.com/noticias/educacion/que-pasa-si-mi-hijo-llega-tarde-a-la-escuela","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/11","path":"/educacion/1/11","context":{"slug":"educacion/1/11","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"11","card":"¿Cómo hacen los estudiantes para ir y volver de la escuela?","text":"<p>Los niños que viven cerca a su escuela (dependiendo de las condiciones, la seguridad y el clima de la zona) pueden ir <b>caminando</b> o en algún medio como <b>patineta, monopatín o bicicleta</b> (las escuelas suelen tener espacios para aparcarlas). </p><p>Los niños que viven lejos de la escuela pueden tomar el <b>autobús escolar</b> o transporte público como el<b> metro o bus</b>. </p><p>La gran mayoría de las escuelas públicas tienen autobuses que prestan el servicio de manera <b>gratuita</b>, otras cobran una pequeña cuota.</p><p>Los autobuses escolares recogen a los estudiantes y los dejan en una <b>parada cerca de su casa</b>.</p><p>Cuando un autobús escolar está detenido recogiendo o dejando a los estudiantes, los demás automovilistas tienen que respetar las señales de '<b>Pare' o '<i>Stop</i>' </b>pegadas a los lados del bus. </p><p>Si tu hijo toma un autobús escolar, es bueno tener <b>el número del autobús</b>, el <b>lugar y la hora</b> donde se sube y se baja. Para averiguar si el estudiante tiene derecho a utilizar el autobús escolar puedes <b>llamar a tu escuela o distrito escolar</b>.</p>","url":"https://www.univision.com/noticias/educacion/como-hacen-los-estudiantes-para-ir-y-volver-de-la-escuela","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/12","path":"/educacion/1/12","context":{"slug":"educacion/1/12","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"12","card":"¿Qué pasa si mi día de trabajo termina más tarde que la jornada escolar y no hay quién recoja al estudiante?","text":"<p>Muchas escuelas públicas tienen programas para después de la escuela (“<i><b>after school programs</b></i>”) creados para evitar que los niños permanezcan sin guía después de la escuela y puedan aprovechar el tiempo para adelantar sus <b>tareas escolares</b> o participar en una actividad <b>artística o un deporte</b>. </p><p>La mayoría de programas son gratuitos, pero algunos piden una contribución. </p><p>Estos programas son un gran <b>apoyo para los padres</b> trabajadores y mantienen a los niños en ambientes seguros (en la misma escuela u otras instalaciones) y ayudan a <b>evitar la deserción escolar</b>.</p><p>Las escuelas pueden ser estrictas con el <b>cumplimiento</b> de los horarios (cobrando incluso multas por retrasos al recoger a los estudiantes). <a href=\"http://www.afterschoolalliance.org/policyStateMap.cfm\"><i>Afterschool Alliance</i> ofrece información sobre estos programas a nivel <b>nacional</b>.</a></p>","url":"https://www.univision.com/noticias/educacion/que-pasa-si-mi-dia-de-trabajo-termina-mas-tarde-que-la-jornada-escolar-y-no-hay-quien-recoja-al-estudiante","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/13","path":"/educacion/1/13","context":{"slug":"educacion/1/13","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"13","card":"¿Tengo que pagar algo por la educación de mi hijo?","text":"<p>Las escuelas públicas son <b>gratuitas</b>. Pero los <b>impuestos que se cobran por la propiedad</b> cubren el costo de las escuelas.<br></p><p> Usualmente la escuela facilita los <b>libros</b> que se necesitan, pero si el estudiante los pierde o los daña, tiene que <b>pagar</b> por ellos. </p><p>Otros posibles gastos:</p><li>Cuota por actividades <b>extraescolares</b>, como música o deportes.</li><li>Tarifa básica por los <b>almuerzos</b> escolares (los padres de bajos ingresos pueden ser eximidos de este cobro).</li><li><b>Excursiones</b> a museos, zoológicos y otros lugares. </li>","url":"https://www.univision.com/noticias/educacion/tengo-que-pagar-algo-por-la-educacion-de-mi-hijo","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/14","path":"/educacion/1/14","context":{"slug":"educacion/1/14","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"14","card":"¿Todas las escuelas públicas son iguales?","text":"<p>No. </p><p>Hay algunas que ofrecen programas con <b>enfoques especiales</b> y en las que el ingreso está determinado por los <b>méritos</b> de los estudiantes y no por el lugar de <b>residencia</b>. </p><p>Hay dos tipos de escuelas en esta categoría: las escuelas '<b><i>magnet</i></b>' y las escuelas '<b><i>charter</i></b>'.<br></p>","url":"https://www.univision.com/noticias/educacion/todas-las-escuelas-publicas-son-iguales","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/15","path":"/educacion/1/15","context":{"slug":"educacion/1/15","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"15","card":"¿Qué es una escuela magnet?","text":"<p>Las <b><i>magnet</i></b> son escuelas <b>públicas</b> competitivas con <b>altos estándares</b> académicos, que se centran en un tipo particular de estudio, como las <b>artes</b> o las <b>ciencias</b>.</p><p>Tienen <b>alta demanda</b> y muchas veces el ingreso se hace por <b>sorteo</b>.</p><p> Por lo general tratan de fomentar la <b>diversidad</b> racial, étnica y/o económica de los estudiantes.</p><p> Estas escuelas también son <b>gratuitas</b>.</p>","url":"https://www.univision.com/noticias/educacion/que-es-una-escuela-magnet","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/16","path":"/educacion/1/16","context":{"slug":"educacion/1/16","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"16","card":"¿Qué es una escuela charter?","text":"<p>Las <i>charter</i> también son <b>escuelas públicas</b> que cuentan con aprobación y <b>financiamiento</b> del estado, pero son administradas por<b> grupos comunitarios o compañías privadas.</b> </p><p>Tienen clases más <b>pequeñas</b> y estándares académicos <b>más altos</b> que las escuelas públicas tradicionales. </p><p>Las <i>charter</i> están libres de algunas de las <b>regulaciones</b> de las escuelas públicas, pero también deben <b>rendir cuentas </b>a una junta escolar local o estatal. </p><p>Estas escuelas también son <b>gratuitas</b>.</p>","url":"https://www.univision.com/noticias/educacion/que-es-una-escuela-charter","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/17","path":"/educacion/1/17","context":{"slug":"educacion/1/17","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"17","card":"¿Qué pasa si mi hijo no puede terminar el high school?","text":"<p>Los niños tienen que completar los grados del <b>1 al 12</b>, o el equivalente, para poder obtener un <b>diploma</b> de escuela secundaria.</p><p><a href=\"http://www.pewhispanic.org/2013/05/09/iii-young-hispanics-dropping-out-of-high-school/\">Los niveles de deserción entre los latinos</a> son los <b>más altos</b> del país, pero para quienes abandonan la escuela por razones mayores hay <b>opciones</b>.<br></p><p> Algunos <i>high schools</i> tienen <b>clases nocturnas</b> y que permiten obtener el diploma de secundaria.</p><p>Existen, además, clases diurnas y nocturnas (algunas en español) para pasar la prueba del equivalente de<i> high school, </i>el HSE o <b>GED</b>. </p><p>La mayoría de las universidades y empleadores <b>aceptan</b> estos diplomas. Muchas <b>bibliotecas públicas</b> ofrecen información sobre este tipo de clases y cómo tomarlas. <a href=\"http://www.univision.com/noticias/educacion-secundaria/como-obtener-un-ged\">Aquí puedes averiguar los requisitos.</a></p>","url":"https://www.univision.com/noticias/educacion/que-pasa-si-mi-hijo-no-puede-terminar-el-high-school","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/18","path":"/educacion/1/18","context":{"slug":"educacion/1/18","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"18","card":"¿Quién puede recoger los niños en la escuela?","text":"<p>Los pueden recoger:</p><li>La <b>madre</b></li><li>El <b>padre</b></li><li>Un <b>guardián</b> legal</li><li>Una persona que tiene <b>autorización escrita</b> de la madre o el padre que tiene la custodia física del niño.</li><li>La <b>policía</b> o trabajadores de <b>bienestar infantil</b> que tengan la debida <b>autorización</b>.</li>","url":"https://www.univision.com/noticias/educacion/quien-puede-recoger-los-ninos-en-la-escuela","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/19","path":"/educacion/1/19","context":{"slug":"educacion/1/19","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"19","card":"¿Puede ir mi hijo a una escuela que no este en mi distrito escolar?","text":"<p>Cuántas opciones tienes <b>varía de un distrito escolar</b> a otro y de estado a estado. </p><p>En algunos lugares lo que se conoce como <i><b>school choice</b>, </i>o la libertad de escoger a dónde enviar tus hijos a la escuela, está más integrado en las leyes educativas, como en Florida o Michigan.</p><p>Cada distrito escolar público establece <b>sus propios límites</b> para las escuelas, por eso es mejor consultar con tu <b>distrito local</b> para averiguar a qué escuela asignarán a tu hijo y cuáles son las reglas para asistir a las escuelas <i>charter, magnet</i> u otras escuelas dentro o fuera de tu distrito local. </p><p>Ten en cuenta que los distritos escolares a veces <b>cambian los límites</b> de los vecindario para que las escuelas equilibren su inscripción, así que <b>no asumas</b> que si te mudas al frente de una escuela, tu hijo irá automáticamente a esta.</p>","url":"https://www.univision.com/noticias/educacion/puede-ir-mi-hijo-a-una-escuela-que-no-este-en-mi-distrito-escolar","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/1/20","path":"/educacion/1/20","context":{"slug":"educacion/1/20","node":{"idbaraja":"1","baraja":"¿Cómo funciona el sistema escolar en Estados Unidos?","idcard":"20","card":"¿Qué debo esperar de una reunión con los maestros de mis hijos?","text":"<li>Durante las conversaciones con los maestros, te enterarás sobre el <b>desempeño académico y conducta</b> de tu hijo en clase. </li><li>El maestro de tu hijo te dirá cuáles son sus <b>expectativas</b>. </li><li>Asegúrate de preguntar cómo puedes <b>apoyar su aprendizaje en casa. </b></li><li> También pregunta por recursos <b>gratis</b> en la comunidad, como las <b>bibliotecas públicas</b>, <b>museos, parques, organizaciones gubernamentales</b> o sin ánimo de lucro que ofrezcan eventos u oportunidades para niños. </li><li>Hazle saber al maestro también los <b>antecedentes familiares</b> de tu hijo y otra información que ayude al maestro a conocer mejor sus <b>puntos fuertes y sus dificultades.</b></li>","url":"https://www.univision.com/noticias/educacion/que-debo-esperar-de-una-reunion-con-los-maestros-de-mis-hijos","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/1","path":"/educacion/2/1","context":{"slug":"educacion/2/1","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"1","card":"¿Qué es una escuela ideal?","text":"<p>Antes de empezar a buscar, es importante decidir qué es <b>lo más importante para ti y tus hijos</b>. </p><p>¿La prioridad es estudiar otros <b>idiomas</b>, la fortaleza en <b>artes</b> o <b>ciencias</b>, u otros factores? Una vez que decidas qué es lo más importante, usa la <b>página web</b> del distrito escolar, <b>folletos</b> informativos o <b>visita</b> las escuelas que te interesan en persona para asegurarte de que la escuela candidata <b>ofrece lo que buscas</b>.<br></p><p> Si la zona donde vives tiene varias escuelas, públicas, privadas, <i>magnet</i> o <i>charter</i>, no te limites.</p><p> La manera en que una escuela se financie, tanto si es a través del gobierno o de manera privada, no se correlaciona necesariamente con la <b>calidad</b> de su educación. Investiga <b>online</b>, pide <b>referencias</b>, ve a la <b>oficina principal del distrito</b> de escuelas o asiste a una <b>feria de educación</b> para entender mejor los detalles.</p>","url":"https://www.univision.com/noticias/educacion/que-es-una-escuela-ideal","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/2","path":"/educacion/2/2","context":{"slug":"educacion/2/2","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"2","card":"¿Cómo sé si una escuela es buena?","text":"<p>Cada estado tiene su manera de calificar a las escuelas, ya sea con una calificación <b>numérica</b> o con letras de la<b> A a la F</b>. </p><p>Las escuelas deben tener <b>estadísticas disponibles</b> para los padres que muestren su <b>rendimiento en exámenes</b>, la proporción<b> alumno-profesor</b> y cuántos estudiantes entran después a la <b>universidad</b>.</p><p>Contacta a la oficina principal de la escuela y <b>solicita esta información</b>.</p><p>Para programas públicos, los estados tienen <b>pruebas de rendimiento públicas</b> que cualquiera puede accesar online o contactando al distrito escolar.<br></p><p>Pide <b>recomendaciones</b> a amigos, conocidos y familiares. Pregúntales detalles de cómo son las escuelas de sus hijos. </p><p>Inscribir a tus hijos en la misma escuela les puede ayudar a ambos padres a facilitar la <b>logística</b>, hacer <i><b>car pool</b></i>, ayudarse en proyectos o <b>tareas</b> y a navegar la escuela en general y trabajar junto con los <b>maestros</b>. </p><p> Y sí no es lo que estás buscando, te puedes dar una idea de qué se ofrece para hacer una decisión más <b>informada</b>.</p>","url":"https://www.univision.com/noticias/educacion/como-se-si-una-escuela-es-buena","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/3","path":"/educacion/2/3","context":{"slug":"educacion/2/3","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"3","card":"¿Qué debo hacer durante una visita a una escuela que me interese?","text":"<p>Cuando vayas a la escuela, asegúrate de:</p><li>Hablar con el director</li><li>Conversar con los profesores</li><li>Si es posible, hablar con otros padres. </li><li>Es un buen momento para llevarse una impresión general de qué tipo de personas van a la escuela y decidir si encaja con lo que buscas. </li><li>Mira las aulas y la decoración en las paredes</li><li>Si es posible observa a un profesor en acción para ver qué tipos de interacciones y actividades harían tus hijos.</li><p>Si un colegio no anima a visitas previas a la matriculación, puede ser una señal de alerta para investigar más. Puede significar que no son transparentes sobre sus métodos de enseñanza y podría predecir cómo van a contestar a cualquier duda que tengas en el futuro. </p><p>Elige una escuela que sea transparente para así tener el menor número de preocupaciones.<br></p>","url":"https://www.univision.com/noticias/educacion/que-debo-hacer-durante-una-visita-a-una-escuela-que-me-interese","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/4","path":"/educacion/2/4","context":{"slug":"educacion/2/4","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"4","card":"¿Qué preguntas debo hacer al evaluar una escuela?","text":"<li>¿Qué horarios tienen los niños? Asegúrate que encajan con el tuyo.</li><li>¿Qué tipo de comidas sirven? ¿Cuántas? ¿Son saludables?</li><li>¿Qué idiomas extranjeros ofrecen?</li><li>¿Qué deportes enseñan?</li><li>¿Cómo lidian con el mal comportamiento de los estudiantes?</li><li>¿Ofrecen acomodaciones para necesidades especiales o necesidades de aprendizaje distintas?</li><li>¿Cuál es la tasa de deserción?</li><li>¿Cuál es la tasa de ausencias?</li><li>¿Qué porcentaje de los estudiantes son hispanos?</li><li>¿Qué porcentaje de los maestros son hispanos? </li></br><h3> Asegúrate de preguntar:</h3></br><li>A los profesores de tu hijo por su formación y acreditación.</li><li>Detalles sobre el tipo de deberes que reciben los niños.</li>","url":"https://www.univision.com/noticias/educacion/que-preguntas-debo-hacer-al-evaluar-una-escuela","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/5","path":"/educacion/2/5","context":{"slug":"educacion/2/5","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"5","card":"¿A qué debo poner atención durante la aplicación y la matriculación en una escuela privada?","text":"<li>Investiga cómo es el <b>proceso de admisiones</b></li><li>Averigua el <b>costo</b> de la escuela</li><li>Entérate de qué <b>becas</b> que ofrecen</li><li>Si quieres seguir adelante, puedes necesitar papeleo que verifique la <b>edad, identidad, vacunas y residencia</b> de tu hijo. </li><li>Si no vas a poder recoger esta información, es mejor saberlo de antemano para evitar <b>sorpresas inesperadas</b>.</li>","url":"https://www.univision.com/noticias/educacion/a-que-debo-poner-atencion-durante-la-aplicacion-y-la-matriculacion-en-una-escuela-privada-1","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/6","path":"/educacion/2/6","context":{"slug":"educacion/2/6","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"6","card":"¿Qué pasa si mi hijo no entra a la escuela que quiero?","text":"<p>Incluso si encontraste la escuela de tus sueños, a veces procesos <b>rigurosos de aplicación</b>, o incluso <b>obstáculos financieros</b>. </p><p>Si tu hijo no entró a esta escuela, te podrían poner en una <b>lista de espera</b>. Es decir, si alguien se retracta del proceso, te pueden dar su puesto.</p><p>Asegúrate de tener <b>otras opciones</b> en espera para no tener que mandar a tus hijos a una escuela que no elegiste.<br></p>","url":"https://www.univision.com/noticias/educacion/que-pasa-si-mi-hijo-no-entra-a-la-escuela-que-quiero","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/2/7","path":"/educacion/2/7","context":{"slug":"educacion/2/7","node":{"idbaraja":"2","baraja":"¿Cómo elijo la mejor escuela para mis hijos?","idcard":"7","card":"¿Qué requisitos piden las escuelas para inscribir a un estudiante?","text":"<h3>Las escuelas en general piden:</h3></br><li>Un certificado de <b>nacimiento</b></li><li>Prueba de <b>tutela</b> y / o custodia</li><li>Prueba de <b>residencia</b></li><li>Registro de <b>vacunas</b></li><li><b>Aplicación</b> común</li><li>Formularios de <b>contacto</b> de emergencia</li>","url":"https://www.univision.com/noticias/educacion/que-requisitos-piden-las-escuelas-para-inscribir-a-un-estudiante","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/1","path":"/educacion/3/1","context":{"slug":"educacion/3/1","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"1","card":"¿Qué opciones ofrece la escuela a los estudiantes que no dominan el inglés?","text":"<p>La mayoría de las escuelas ofrecen clases llamadas Inglés como Segundo Idioma (ESL en inglés). A los estudiantes inscritos en estas clases se les conoce como ELL, o <i>English Language Learners</i>. Las clases ESL enseñan a los estudiantes a escuchar, hablar, leer y escribir en inglés.</p> <p>Cuando un estudiante se inscribe en la escuela por primera vez, los distritos usualmente utilizan una encuesta para determinar cuáles estudiantes hablan un idioma nativo que no sea inglés. </p><p>Cada estado lo maneja diferente, <a href=\"http://ecs.force.com/mbdata/mbquestNB2?rep=ELL1403\"> y esta página explica las diferencias</a>. Los estudiantes son evaluados para determinar qué tanto dominio tienen del inglés, y así la escuela los ubica en la clase correcta. Los estudiantes toman una prueba de inglés cada año, hasta que sean competentes en el idioma y puedan 'graduarse' del programa ESL y entrar a clases regulares junto con hablantes del inglés nativos.</p>","url":"https://www.univision.com/noticias/educacion/que-opciones-ofrece-la-escuela-a-los-estudiantes-que-no-dominan-el-ingles","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/2","path":"/educacion/3/2","context":{"slug":"educacion/3/2","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"2","card":"¿Cómo ayudar a mi hijo en comprensión de lectura en un idioma nuevo?","text":"<p>La clave es que <b>practiquen</b>, lo más posible. Los maestros recomiendan que los niños <b>lean en casa</b>. Pueden usar la ayuda de <b>audio o video</b> para que <b>relacionen</b> lo que escuchan con la palabra <b>escrita</b>.<br></p><p> También sugieren que <b>practiquen</b> de vez en cuando con libros un poco <b>más allá del rango de su edad</b> para que se familiaricen con <b>vocabulario nuevo</b> cada vez más avanzado.</p><p>Conseguir un <b>tutor del mismo nivel de tu hijo</b> puede ser muy útil. Por tratarse de alguien más cercano, los niños se pueden <b>identificar</b> y <b>relacionar</b> y así absorber información más <b>cómodamente</b>.</p>","url":"https://www.univision.com/noticias/educacion/como-ayudar-a-mi-hijo-en-comprension-de-lectura-en-un-idioma-nuevo","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/3","path":"/educacion/3/3","context":{"slug":"educacion/3/3","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"3","card":"¿Qué derechos tengo como padre de un estudiante que está aprendiendo inglés?","text":"<li>Se requiere por ley que las escuelas <b>ayuden a los niños que no hablan inglés a aprenderlo</b>, al igual que se requiere que le enseñen<b> el mismo currículo </b>que a los demás alumnos. </li><li>Los estudiantes que están aprendiendo inglés quizá puedan tomar <b>cursos avanzados en su propio idioma</b> para que no se rezaguen. <b>Indaga</b> qué ofrece la escuela. </li><li>Si no hablas inglés, tienes derecho a un <b>intérprete</b> durante tus reuniones con el maestro.</li><li>Puedes pedir que un <b>amigo</b> o vecino esté presente durante esas reuniones.</li><li>Puedes solicitar que la escuela proporcione un <b>traductor</b>. Lo mejor es que alguien que <b>no sea tu hijo</b> sea el intérprete.</li><li>Tienes derecho a que los <b>documentos</b> que te envíen a casa estén <b>traducidos</b>.</li><li>Tienes derecho a reunirte con los <b>maestros</b> de tus hijos y hacerles <b>preguntas</b> sobre su desempeño.</li>","url":"https://www.univision.com/noticias/educacion/que-derechos-tengo-como-padre-de-un-estudiante-que-esta-aprendiendo-ingles","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/4","path":"/educacion/3/4","context":{"slug":"educacion/3/4","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"4","card":"¿Qué debo esperar de una reunión con los maestros de mis hijos?","text":"<li>Durante las conversaciones con los maestros, te enterarás sobre el <b>desempeño académico y conducta</b> de tu hijo en clase. </li><li>El maestro de tu hijo te dirá cuáles son sus <b>expectativas</b>. </li><li>Asegúrate de preguntar cómo puedes <b>apoyar su aprendizaje en casa. </b></li><li> También pregunta por recursos <b>gratis</b> en la comunidad, como las <b>bibliotecas públicas</b>, <b>museos, parques, organizaciones gubernamentales</b> o sin ánimo de lucro que ofrezcan eventos u oportunidades para niños. </li><li>Hazle saber al maestro también los <b>antecedentes familiares</b> de tu hijo y otra información que ayude al maestro a conocer mejor sus <b>puntos fuertes y sus dificultades.</b></li>","url":"https://www.univision.com/noticias/educacion/que-debo-esperar-de-una-reunion-con-los-maestros-de-mis-hijos","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/5","path":"/educacion/3/5","context":{"slug":"educacion/3/5","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"5","card":"¿Qué opciones hay para mi hijo si no habla inglés?","text":"<li>Es posible que la escuela ofrezca <b>cursos en Internet</b> para reforzar ese aprendizaje. Si lo ofrecen, debes hacer de estos cursos en línea una <b>prioridad</b>, pues esto <a href=\"http://ecs.force.com/mbdata/mbquestNB2?rep=ELL1403\"> lo ayudará a ponerse al día o avanzar académicamente</a>. </li><li> Además tu hijo puede accesar esos cursos <b>desde su teléfono</b> en cualquier momento del día.</li><li>Si la escuela no ofrece muchos <b>servicios en español</b>, pregunta si el<b> <b>distrito escolar</b></b> ofrece más. </li><li>Pregunta también si hay un <b>coordinador bilingüe </b>o para estudiantes de inglés en el programa <b>ELL</b>. </li><li> Si no hay uno bilingüe pregunta por el <b><b>coordinador de padres</b>. </b></li><li> Es posible que le tome a tu hijo <b>más de un año</b> alcanzar el nivel académico de los demás estudiantes de su grado, además de <b>terapia</b> u otra ayuda. Consulta con sus <b>maestros</b> e investiga si esta opción es para tu hijo. </li><li>A algunos estudiantes más jóvenes podría resultarles beneficioso <b>repetir el grado</b> (en particular a los estudiantes de tercer grado) para darles más tiempo de aprender.</li>","url":"https://www.univision.com/noticias/educacion/que-opciones-hay-para-mi-hijo-si-no-habla-ingles","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/3/6","path":"/educacion/3/6","context":{"slug":"educacion/3/6","node":{"idbaraja":"3","baraja":"¿Qué pasa si el inglés no es el primer idioma en el hogar?","idcard":"6","card":"¿Cómo puedo apoyar a mi hijo desde casa a aprender inglés?","text":"<li>Averigua sobre <b>talleres o reuniones para padres</b> donde puedas aprender más. </li> <li>Si es posible, es importante tratar de tener una <b>computadora, impresora y acceso a Internet</b> en tu casa. La inversión en estos recursos ayudará a que le vaya bien a tu hijo en la escuela. </li><li>Si no tienes, busca cuál es tu <b>biblioteca pública</b> más cercana. </li><li>Averigua cómo puedes instalar un <b>control parental</b> en los dispositivos que usen ellos para asegurarte de que usen las <b>redes sociales de manera segura.</b></li>","url":"https://www.univision.com/noticias/educacion/como-puedo-apoyar-a-mi-hijo-desde-casa-a-aprender-ingles","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/4/1","path":"/educacion/4/1","context":{"slug":"educacion/4/1","node":{"idbaraja":"4","baraja":"¿Cómo puedo apoyar el aprendizaje de mi hijo desde casa?","idcard":"1","card":"¿Qué hago si mi hijo tiene dificultades académicas?","text":"<li>Primero que nada: Habla con tu hijo para encontrar la <b>raíz del problema</b>, de manera calmada, abierta y cariñosa, nunca acusatoria. Si se siente juzgado se va a asustar y cerrar y no podrás conocer realmente por qué está teniendo dificultades.</li><li>Pregúntale: \"¿Qué de esta tarea es trabajoso?\" en vez de, \"¿Por qué no hiciste la tarea?\"</li><li><b>Habla con sus maestros</b> para identificar exactamente cuál es su dificultad. Puede ser lectura o matemática, un problema con el <b>idioma</b>, o lo que es muy común (y que puede combinarse con otros problemas estrictamente académicos), un problema de <b>autoestima o de comportamiento.</b></li><li>Cuando hables con los maestros, indaguen si quizás es un problema <b>emocional</b>. Puede ser <b>ansiedad</b> de una situación difícil en su vida (una mudanza, llegar a un país nuevo, una situación migratoria inestable). </li><li>Averigua los <b>recursos que la escuela ofrece</b> para superar dificultades tanto académicas como <b>emocionales</b> (terapia, consejería).</li><li>Busca por internet <b>programas de tutoría</b> que suplementen la dificultad particular de tu hijo.</li><li><b>SIEMPRE</b> apoya a tu hijo y hazle saber que lo apoyas. </li><li>Mantente <b>optimista</b> frente a él y dale <b>ánimo</b>. </li><li>Hazle saber que <b>confías</b> en ella o él y que con esfuerzo todos <b>podemos mejorar y aprender más</b>. </li>","url":"https://www.univision.com/noticias/educacion/que-hago-si-mi-hijo-tiene-dificultades-academicas","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/4/2","path":"/educacion/4/2","context":{"slug":"educacion/4/2","node":{"idbaraja":"4","baraja":"¿Cómo puedo apoyar el aprendizaje de mi hijo desde casa?","idcard":"2","card":"¿Cómo ayudar a mi hijo en comprensión de lectura en un idioma nuevo?","text":"<li>La clave es <b>practicar</b>, lo más posible: leer, leer y leer.</li><li>Los maestros recomiendan que los niños <b>lean en casa</b>, con la ayuda de <b>audio</b> o <b>video</b> para que relacionen lo que escuchan con la palabra escrita.</li><li> También sugieren que practiquen de vez en cuando con libros un poco <b>más allá del rango de su edad</b> para que se familiaricen con vocabulario nuevo.</li><li>Conseguir un <b>tutor del mismo nivel de tu hijo</b> puede ser muy útil. Por tratarse de alguien más cercano los niños se pueden <b>identificar</b> y <b>relacionar</b> y así absorber información más <b>cómodamente</b>.</li>","url":"https://www.univision.com/noticias/educacion/como-ayudar-a-mi-hijo-en-comprension-de-lectura-en-un-idioma-nuevo-1","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/4/3","path":"/educacion/4/3","context":{"slug":"educacion/4/3","node":{"idbaraja":"4","baraja":"¿Cómo puedo apoyar el aprendizaje de mi hijo desde casa?","idcard":"3","card":"¿Cómo apoyo el aprendizaje de mi hijo en matemáticas en la vida diaria?","text":"<p><b>Cualquier momento</b> es bueno para enseñarle matemáticas a tu hijo, a <b>cualquier edad. </b></p><p>La <b>cocina</b> es un buen lugar. Algunos ejemplos: </p><ul><li>Puedes <b>contar ingredientes: </b>3 peras, 2 tazas de arroz, una cucharadita (para niños de 0-5 años)</li><li>Pueden <b>hacer conversiones:</b> 2 cucharadas equivalen a 1/4 de taza (5 años en adelante)</li><li>Pueden <b>jugar con las temperaturas y el tiempo</b>: ¿10 minutos a 400 F son equivalentes a 20 minutos a 200 F? (¡La respuesta es no!). Pueden hacerse preguntas y descubrir juntos la respuesta, buscarlo en internet y que tu hija lidere la búsqueda. </li></ul></p><p>Lo mismo puedes aplicar con el auto y sus diferentes partes, o en el jardín con las plantas y flores. </p><p>Fuera de casa, en el parque, la playa, el campo, museos, etc., pueden <b>contar cualquier grupo</b> de objetos, animales o personas y <b>hacer sumas y restas</b>, primero sencillas, y a medida que crecen los niños cada vez más complejas, hasta llegar a la <b>multiplicación y la división</b>. </p><p><ul><li><b>Lo más importante</b> es que integren el uso de los números desde bebés en la vida diaria y de manera <b>natural y divertida</b>, para que no crezcan con miedo a las matemáticas. </li></ul>Aquí, como en todo, <b>la mejor enseñanza será tu ejemplo.</b></p>","url":"https://www.univision.com/noticias/educacion/apoyar-el-aprendizaje-de-mi-hijo-en-matematicas-en-la-vida-diaria","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/1","path":"/educacion/5/1","context":{"slug":"educacion/5/1","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"1","card":"¿Qué es el bullying?","text":"<p>El bullying, <b>acoso</b>, o también conocido como <b>matoneo</b>, es un comportamiento <b>agresivo</b> y no deseado entre niños o jóvenes, donde hay <b>“un desequilibrio de poder real o percibido”</b>, según <a href=\"https://espanol.stopbullying.gov/qu%C3%A9-es-el-acoso/definici%C3%B3n/34nd/\" <=\"\" span=\"\">StopBullying.gov</a>, una página del gobierno que reúne información sobre el acoso de diferentes agencias gubernamentales.<br></p><p>Para que se le considere acoso, el comportamiento debe ser agresivo e incluir:</p><li>Un <b>desequilibrio de poder: </b>los niños que acosan usan su poder (como la <b>fuerza física</b>, el acceso a <b>información desagradable</b> o la <b>popularidad</b>) para controlar o dañar a otros. El desequilibrio de poder puede cambiar con el transcurso del tiempo y en diferentes situaciones, incluso con las mismas personas.</li> <li><b>Repetición</b>: los comportamientos acosadores suceden <b>más de una vez</b>, o tienen el potencial de pasar más de una vez.</li><p> El acoso incluye <b>amenazas</b>, <b>rumores</b>, ataques <b>físicos</b> y <b>verbales</b>, y la <b>exclusión</b> de alguien de un grupo de manera <b>intencional</b>.</p>","url":"https://www.univision.com/noticias/educacion/que-es-el-bullying","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/2","path":"/educacion/5/2","context":{"slug":"educacion/5/2","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"2","card":"¿Dónde y cuándo puede ocurrir el bullying?","text":"<p>El bullying puede manifestarse <b>física o verbalmente</b>, en <b>persona</b> o por <b>internet</b>.<br></p><p> El acoso puede producirse durante el <b>horario escolar o fuera</b> de éste. A pesar de que la mayoría de las situaciones de acoso denunciadas pasan en el espacio escolar, un <b>gran porcentaje</b> también transcurre en lugares como el <b>patio de recreo o el autobús. </b></p><p> También pueden producirse durante el <b>viaje hacia o desde la escuela</b>, caminando en la <b>calle</b> o en el <b>barrio</b> donde vives.</p>","url":"https://www.univision.com/noticias/educacion/donde-y-cuando-puede-ocurrir-el-bullying","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/3","path":"/educacion/5/3","context":{"slug":"educacion/5/3","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"3","card":"¿Cómo sé si mi hijo es víctima de bullying?","text":"<p>Lo más fácil de detectar serán señales de acoso físico como <b>heridas o contusiones</b> que no pueden ser explicadas. Pon atención si tu hijo vuelve del colegio con su <b>ropa rota</b>, o que ha <b>perdido</b> sus libros, prendas o equipo electrónico.</p><p> También debes estar atento a <a href=\"http://www.univision.com/noticias/bullying/uno-de-cada-cuatro-ninos-sufre-de-bullying-cronico-en-las-escuelas-de-eeuu-indica-nuevo-estudio\">cambios de comportamiento en tu hijo</a>, como un menor rendimiento académico, <b>baja autoestima y/o una mayor aversión por la escuela</b>. </p><p>También debes estar atento a síntomas de <a href=\"http://www.univision.com/noticias/bullying/el-bullying-tiene-los-mismos-efectos-negativos-a-largo-plazo-entre-las-victimas-que-el-abuso-fisico-o-sexual\">depresión, ansiedad</a> o cambios de humor drásticos.</p><p>Según expertos, esto se puede manifestar en cambios en ciertas rutinas, <b>pérdida de apetito, de sueño o falta de interés en actividades</b> que tu hijo antes encontraba placenteras. </p><p>Problemas de salud constantes, tales como <b>dolores de cabeza, de estómago o malestar en general</b>, son igualmente señales de que el niño está, o somatizando su angustia, o está tratando de evitar la escuela. </p><p> En casos más extremos de intimidación y de amenazas, la víctima puede mostrar un comportamiento <b>auto-destructivo o suicida</b>. Si estas señales están presentes, dicen los expertos, <b>“es urgente intervenir\":</b> <b>hablar </b><b>con expertos en salud y </b>con el niño, </b>siempre con amor, cariño y paciencia. El hogar y la familia deben ser su refugio.</b></p><p>Habla con tu <b>hijo</b>, sus <b>maestros</b>, el <b>chofer</b> del autobús escolar. El <i>bullying</i> a menudo deja secuelas psicológicas y emocionales a largo plazo que son <b>difíciles</b> (más no imposibles) de curar.</p>","url":"https://www.univision.com/noticias/educacion/como-se-si-mi-hijo-es-victima-de-bullying","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/4","path":"/educacion/5/4","context":{"slug":"educacion/5/4","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"4","card":"¿Cómo lidiar con el bullying de un hijo?","text":"<li>Cuando hayas <b>confirmado</b> que tu hijo es víctima de bullying, primero que todo, <b>notifica a la escuela</b>.</li><li>Reúnete con los <b>maestros</b> de tu hijo para determinar el problema y su <b>magnitud</b>. Determinen si es necesario programar una <b>reunión con los padres de los niños</b> que le están haciendo <i>bullying</i> a tu hija o hijo.</li><li> Uno de los puntos más importantes es mantener una comunicación constante con tu hija. Pregúntale <b>cómo se siente</b>, pero no la empujes demasiado. Hazla sentir <b>cómoda</b>, <b>valorada y apreciada. </b>Comunícale que estás ahí para ella y para <b>apoyarla</b>.</li>","url":"https://www.univision.com/test/lidiar-con-el-bullying-de-un-hijo","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/5","path":"/educacion/5/5","context":{"slug":"educacion/5/5","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"5","card":"¿Cómo preparar a tu hijo para defenderse del bullying?","text":"<p></p><p>Lo <i>más importante</i> es ser <b>una fuente de amor constante.</b> Si tú les pegas o los insultas y humillas ellos aprenderán que es normal y aceptable que otros hagan lo mismo con ellos.</p><p>Luego, es vital también enseñarle a los niños valores positivos para que crezcan para ser personas compasivas, productivas, diestras e independientes.<a href=\"http://www.univision.com/estilo-de-vida/papas-y-mamas/como-educar-a-un-hijo-para-que-no-se-deje-manipular-por-sus-amigos\" para=\"\" esto=\"\" es=\"\" fundamental:<=\"\" a=\"\"></a></p><a href=\"http://www.univision.com/estilo-de-vida/papas-y-mamas/como-educar-a-un-hijo-para-que-no-se-deje-manipular-por-sus-amigos\"> Para esto es fundamental:</a><div><br></div><div><li>Reforzar su autoestima <b>elogiando sus capacidades. </b>Céntrate en las <b>virtudes</b> de tu hijo.</li> <li> No te excedas al regañar o criticar los errores de tu hijo. Esto puede ser precisamente parecido al <i>bullying</i> que sufren en el colegio, y viniendo de una madre o un padre es infinitamente <b>más dañino y doloroso</b>.</li> <li> Enséñale a ser fiel a sí mismo y a no dejarse influir por la opinión de los demás. Hazle ver que solo debe oír críticas que sean justas y constructivas que le ayuden a ser mejor persona.</li> <li> En lugar de prohibirles que se relacionen con determinadas personas, enséñale a hacerse valer y a <b>no depender de los demás para determinar su valor.</b></li> <li> Es fundamental enseñarle a distinguir lo que está bien de lo que está mal.</li> <li> Enséñale a decir “No”, a mantenerse firme en sus convicciones.</li> <li> Confía en tu hijo y <b>dale seguridad.</b></li> <li> Dale a tu hijo r<b>esponsabilidades acordes a su edad.</b></li> <li> Permite que <b>exprese libre y respetuosamente </b>sus opiniones, deseos, necesidades, intereses, preocupaciones, emociones, etc. </li> <li><b> Escucha</b> lo que tu hijo tiene que decirte.</li> <li> Enséñale la importancia de <b>pedir ayuda </b>cuando lo necesite.</li> <li> Utiliza las situaciones de conflicto para inculcarle el valor del <b>respeto y la empatía. </b>Haz el ejercicio con él de <b>pedirle que se ponga en el lugar del otro.</b></li> <li> Ayúdale a hacer amigos yendo a <b>parques</b>, llevándolo a fiestas de <b>cumpleaños</b>, inscribiéndolo en clases extracurriculares <b>deportivas, artísticas, musicales</b>, etc., de acorde con sus intereses. <br></li><br><!-- cierretag --></div>","url":"https://www.univision.com/noticias/educacion/como-preparar-a-tu-hijo-para-defenderse-del-bullying","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/5/6","path":"/educacion/5/6","context":{"slug":"educacion/5/6","node":{"idbaraja":"5","baraja":"¿Cómo ayudo a mi hijo si le están haciendo bullying?","idcard":"6","card":"¿Qué hago si a mi hijo (a) le están haciendo bullying por internet?","text":"<p>Muchas veces los niños no entienden la diferencia entre <b>bromas y <i>bullying</i>.</b> Los niños pueden sentirse <b>avergonzados</b> de hablar del tema con sus padres. Es importante hablar con los niños sobre su comportamiento en internet <b>antes</b> de que comiencen a interactuar con otros a través de su celular, tableta o computadora. </p><p> Si tu hijo es víctima de <i>bullying</i> online puedes tomar estos pasos:</p><li> Mantén apagada la computadora lo más posible sin que interfiera con sus <b>tareas escolares</b>. Trata de que tu hijo <b>ignore</b> los ataques y se aleje del <i>bully</i>.</li><li> Aconséjale a tu hijo que <b>no responda ni se vengue. </b>Si está molesto o dolido, puede decir cosas de las que se arrepienta después. Muchas veces los <i>bullies</i> están buscando precisamente una<b> reacción fuerte.</b></li><li> Pídele a tu hijo que <b>bloquee</b> al <i>bully</i>. Si recibe mensajes malintencionados a través de WhatsApp, Facebook o Twitter, <b>elimínalos de su lista</b> de amigos/seguidores. También puede eliminar los mensajes de los <i>bullies</i> sin leerlos.</li><li> Guarda e imprime los mensajes de los <i>bullies</i>. Si el acoso continúa, <b>guarda la evidencia. </b>Esto puede ser importante para tener una prueba para los padres y maestros si el <i>bullying</i> continúa.</li><li> Aconséjale que <b>hable con un amigo. </b>Cuando alguien le hace sentir mal, puede hacerle bien hablar sobre de eso con alguien cercano y de su edad.</li><li> Sugiérele que lo hable con un adulto de confianza, así <b>esa persona no seas tú. </b>Un adulto de confianza es alguien que tu hijo cree que lo escuchará y que tiene la capacidad, el deseo y la autoridad para ayudarlo. Asegúrale a tu hijo que contarle la situación a un adulto <b>no es chisme</b>, significa que se está ocupando de su <b>bienestar</b>, y aunque ocurra por internet, seguramente su escuela tiene reglas en contra del <i>ciberbullying</i>.</li>","url":"https://www.univision.com/noticias/educacion/que-hago-si-a-mi-hijo-a-le-estan-haciendo-bullying-por-internet","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/6/1","path":"/educacion/6/1","context":{"slug":"educacion/6/1","node":{"idbaraja":"6","baraja":"¿Mi hijo puede ir a la escuela así no tenga documentos?","idcard":"1","card":"¿Los niños indocumentados pueden ir a la escuela?","text":"<p>Sí, así lo manda la ley y la <b>Constitución de Estados Unidos</b>, en particular la cláusula de<b> 'Protección igualitaria'.</b> </p><p> Esta garantiza a todos los estudiantes acceso igualitario a la educación pública de kinder a 12 grado, <b>sin importar el estatus migratorio</b> del estudiante.</p>","url":"https://www.univision.com/noticias/educacion/los-ninos-indocumentados-pueden-ir-a-la-escuela","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/6/2","path":"/educacion/6/2","context":{"slug":"educacion/6/2","node":{"idbaraja":"6","baraja":"¿Mi hijo puede ir a la escuela así no tenga documentos?","idcard":"2","card":"¿Las escuelas pueden preguntar por el estatus migratorio de los estudiantes?","text":"<p>En la escuela de kinder a 12 grado <b>ni los maestros ni funcionarios</b> de a escuela tienen derecho a preguntarle a ningún miembro de la familia, sean los padres o los estudiantes, sobre el <b>estatus migratorio</b> de un estudiante.</p>","url":"https://www.univision.com/noticias/educacion/las-escuelas-pueden-preguntar-por-el-estatus-migratorio-de-los-estudiantes","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/1","path":"/educacion/7/1","context":{"slug":"educacion/7/1","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"1","card":"¿Qué es un GED?","text":"<p>EL GED es <a href=\"https://www.univision.com/noticias/educacion-secundaria/como-obtener-un-ged\">un equivalente del diploma de secundaria (<i>high school</i>) </a>para quienes han <b>interrumpido</b> sus estudios. </p><p> En inglés, el Diploma de Educación General o <b>GED</b> es conocido como <i>General Education Development</i> o <i>Graduate Equivalency Diploma</i>. </p><p> Es muy difícil<b> conseguir un empleo</b> sin un diploma o GED. La mayoría de universidades y escuelas técnicas requieren uno de estos <b>diplomas</b>. </p><p>Quienes tienen un GED o un diploma de secundaria ganan <b>más dinero</b> que quienes no lo tienen.<br></p>","url":"https://www.univision.com/noticias/educacion/que-es-un-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/2","path":"/educacion/7/2","context":{"slug":"educacion/7/2","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"2","card":"¿Quiénes pueden tomar el GED?","text":"<p>Por lo general (pero puede variar por estado o distrito escolar), <b>puedes tomar el examen</b> del GED si: </p><li>No estás estudiando <b>actualmente</b> en una secundaria (<i>high school</i>)</li><li>No te has <b>graduado</b> de la secundaria</li><li>Tienes por lo menos <b>16 años</b> de edad</li>","url":"https://www.univision.com/noticias/educacion/quienes-pueden-tomar-el-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/3","path":"/educacion/7/3","context":{"slug":"educacion/7/3","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"3","card":"¿Qué puntaje necesito para aprobar el examen GED?","text":"<p>El puntaje mínimo para pasar es de <b>145 para cada una</b> de las cuatro materias.</p><p>Asegúrate de <b>consultar con tu universidad local</b> sobre los puntajes requeridos para la admisión, ya que algunas universidades pueden requerir <b>diferentes puntajes. </p>","url":"https://www.univision.com/noticias/educacion/que-puntaje-necesito-para-aprobar-el-examen","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/4","path":"/educacion/7/4","context":{"slug":"educacion/7/4","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"4","card":"¿Cómo es el examen de GED?","text":"<p>El examen de GED tiene <b>cuatro</b> asignaturas: </p><li>Matemáticas</li><li>Ciencias</li><li>Estudios Sociales</li><li>Razonamiento y Lenguaje</li><p>En total, la prueba dura <b>7.5 horas</b>, pero <b>no tienes que terminar todos los módulos en un día.</b> Te pedirán que programes un día por materia. <br></p>","url":"https://www.univision.com/noticias/educacion/como-es-el-examen-de-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/5","path":"/educacion/7/5","context":{"slug":"educacion/7/5","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"5","card":"¿Cómo me registro para tomar el GED?","text":"<li>Crea una cuenta en <a href=\"www.ged.com\">MyGED</a></li><li>Ingresa tu <b>nombre</b> legal (el de tu <b>identificación</b> primaria)</li><li>Asegúrate de tener una dirección de correo electrónico (<b>email</b>) válida</li><li>Responde las <b>preguntas</b> para registrarte</li><li>Proporciona cualquier <b>documentación adicional</b> si es necesario</li><li>Programa <b>el día</b> de tu prueba</li>","url":"https://www.univision.com/noticias/educacion/como-me-registro-para-tomar-el-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/6","path":"/educacion/7/6","context":{"slug":"educacion/7/6","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"6","card":"¿Puedo tomar el GED online?","text":"<p>La prueba <b>no se puede</b> tomar en línea.</p>","url":"https://www.univision.com/noticias/educacion/puedo-tomar-el-ged-online","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/7","path":"/educacion/7/7","context":{"slug":"educacion/7/7","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"7","card":"¿Dónde puedo tomar el GED?","text":"<p>Debes presentarte <b>en persona</b>, en un Centro de pruebas de GED <b>oficial</b> para tomar la prueba.</p><p>Puedes chequear su <b>página de internet, <a href=\"www.ged.com\">www.ged.com</a>,</b> para encontrar el centro más cercano a ti.</p>","url":"https://www.univision.com/noticias/educacion/donde-puedo-tomar-el-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/8","path":"/educacion/7/8","context":{"slug":"educacion/7/8","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"8","card":"¿La prueba se ofrece en otros idiomas además del inglés?","text":"<p>No, solo en inglés.</p>","url":"https://www.univision.com/noticias/educacion/la-prueba-se-ofrece-en-otros-idiomas-ademas-del-ingles","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/7/9","path":"/educacion/7/9","context":{"slug":"educacion/7/9","node":{"idbaraja":"7","baraja":"¿Cómo obtengo un GED?","idcard":"9","card":"¿Puedo entrar a cualquier universidad con un puntaje válido de GED?","text":"<p>Más del <b>98% </b>de <i>colleges</i> y universidades de EEUU aceptan estudiantes que hayan <b>pasado el GED</b> y que cumplan con sus otros <b>requisitos</b> de admisión. </p><p>Universidades en muchos otros países como Nueva Zelanda, Tailandia, Bangladesh, Nepal, Emiratos Árabes Unidos, Sudáfrica, etc. también lo reconocen. <b>Consulta con la institución que te interesa</b> sobre su política de admisión y si aceptan el GED y bajo qué condiciones. </p><p>Puede que requieran que tomes <b>otros exámenes</b> para determinar en qué nivel colocarte o si necesitas cursos adicionales.</p>","url":"https://www.univision.com/noticias/educacion/puedo-entrar-a-cualquier-universidad-con-un-puntaje-valido-de-ged","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/1","path":"/educacion/8/1","context":{"slug":"educacion/8/1","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"1","card":"¿Cómo me preparo para entrar a la universidad?","text":"<li>Mantén un <b>GPA alto </b>(por encima de 3.5) en la escuela secundaria. </li> <li>Toma desde temprano materias <b>avanzadas</b> (<i>honors</i>).</li> <li>Toma <b>cursos AP</b> (<i>Advanced Placement</i>) que te dan crédito para la universidad.</li><li>Prepárate estudiando o tomando <b>cursos</b> para poder sacar un buen puntaje en los exámenes estandarizados del <b>PSAT, SAT o ACT.</b></li><li>Involúcrate en una actividad extracurricular como un <b>deporte</b> en equipo (fútbol, basquetbol), un club <b>artístico</b> (pintura, baile, actuación) o en una organización sin ánimo de lucro como <b>voluntario</b>.</li>","url":null,"sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/2","path":"/educacion/8/2","context":{"slug":"educacion/8/2","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"2","card":"¿Qué debo tener en cuenta a la hora de elegir una universidad?","text":"<li>La guía más importante es los <b>intereses</b> personales del estudiante.</li><li>Mira qué <b>carreras</b> (o <i>majors, </i>en inglés) ofrece la universidad.</li><li>Cómo es el <b>ambiente</b>. Trata de contactar a <b>exalumnos</b> que te cuenten cómo es la experiencia en el campus.</li><li>Qué <b>opciones laborales</b> ofrecen para después de graduarse. Puedes conversar con el <b>consejero</b><i> (counselor)</i> de tu <i>high school</i>. </li><li>Hay diferentes instituciones (incluidos muchos <i>high schools</i>) que ofrecen la oportunidad de conocer las mejores universidades del país <b>viajando hasta ellas y haciendo un tour</b> del campus. Todas las universidades tienen <b>páginas en internet</b>, donde puedes enterarte de qué ofrecen y preguntar por estas oportunidades.</li><li> Aunque existen programas para aplicar gratis a muchas universidades a la vez (<i><b>Common Application</b></i>), por lo general las aplicaciones tienen un <b>costo</b>. Por eso es importante seleccionar un buen portafolio de <i>colleges</i>. Comenzando por el <i>college</i> de tus sueños (haciéndole toda la fuerza y pensando que “sí se puede”).</li><li> Si tus antecedentes académicos no son los mejores, incluye de todas maneras un par de <i><b>reach schools</b></i> (que exigen, en promedio, un poco más de lo que has logrado). Muchos estudiantes que aplican a sus <i>reach schools</i> son aceptados.</li><li> Incluye también algunas <i><b>match schools</b></i> (que están a la altura de tus resultados). </li><li>No dejes de aplicar a una <i><b>safety school</b></i> (en la que estés seguro de que te aceptarán).</li>","url":"https://www.univision.com/noticias/educacion/que-debo-tener-en-cuenta-a-la-hora-de-elegir-una-universidad","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/3","path":"/educacion/8/3","context":{"slug":"educacion/8/3","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"3","card":"¿Qué diferencia hay entre un college y una universidad?","text":"<p>Un college es una institución de educación terciaria que ofrece estudios de pregrado generalmente de <b>cuatro años</b>, y que al final otorga un título de <b>Bachelor.</b></p><p>También están los <b><i>community colleges</i></b>, que otorgan el título de <b>Associate </b>después de <b>dos años</b> de estudios de pregrado.<br></p><p>Aunque los <i>colleges</i> son considerados instituciones universitarias, y aunque las palabras <i>college</i> y 'universidad' suelen ser empleadas intercambiablemente, la universidad es oficialmente una institución que ofrece programas de estudios <b>tanto de pregrado como de posgrado</b>. Por esto, un <i>college</i> puede ser <b>parte</b> de una universidad. </p><p>Medicina, administración empresarial y derecho son algunas carreras que requieren estudios <b>más allá del <i>college</i></b> como entrenamiento.</p>","url":"https://www.univision.com/noticias/educacion/que-diferencia-hay-entre-un-college-y-una-universidad-1","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/4","path":"/educacion/8/4","context":{"slug":"educacion/8/4","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"4","card":"¿Qué se necesita para entrar a la universidad?","text":"<p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Esto <b>varía</b> mucho de universidad a universidad y de la <b>calidad</b> de esta, pero por lo general se necesitan estos <b>documentos claves</b>:</span><br></p><ul> <li>Formulario de <b>aplicación</b> (<i>application form</i>). </li><li>Pagar una <b>tarifa</b> de aplicación (<i>application fee</i>). </li><li><b>Calificaciones</b> (<i><i>academic documents o transcripts</i></i>). Una de las piezas más importantes de todo el paquete de aplicación. Debe tener un carácter <b>oficial</b>, o sea, que la escuela te lo entregue impreso en un papel donde figure el nombre de la escuela. Debe estar firmado por <b>un oficial</b> de la misma (director o semejante) y tiene que estar sellado con el <b>sello oficial</b> de la escuela. </li><li>Calificaciones en los <b>exámenes</b> (SAT, ACT, IELTS, TOEFL). Muchas universidades sólo requieren que tomes el SAT o el ACT si eres un estudiante nacional, los estudiantes internacionales están exentos. </li><li>Un <b>ensayo</b> (<i>essay</i>). </li><li><b>Cartas de recomendación</b> (<i>letters of recommendation</i>). Usualmente las escriben <b>maestros</b>, <b>consejeros</b>, <b>líderes</b> comunitarios o adultos que te conozcan en una capacidad más académica o profesional. </li><li>Formularios de la escuela en la que se ha estudiado el equivalente al <i>high school</i> (<i>school forms</i>). </li><li>Una lista de las actividades <b>extracurriculares <b>en las que has estado envuelto</b></b>. </li><li>Otros materiales (depende de la universidad, pueden ser una <b>entrevista, un portafolio, un video, récords deportivos</b>, etc.). Una universidad puede, por ejemplo, exigir un promedio o GPA de más de 3.0, un número mínimo de <b>horas comunitarias</b>, o un puntaje mínimo en el SAT o en el ACT.</li></ul>","url":"https://www.univision.com/noticias/educacion/que-se-necesita-para-entrar-a-la-universidad","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/5","path":"/educacion/8/5","context":{"slug":"educacion/8/5","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"5","card":"¿Qué actividades extracurriculares son importantes para la aplicación a la universidad?","text":"<p>Algunos ejemplos:</p><li>Pertenecer a un <b>club</b> (literario, o de ciencias, por ejemplo). Tener una posición de <b>liderazgo</b> en un club o fundar uno es todavía mejor.</li> <li>Aunque el <i>high school</i> no ofrezca deportes a nivel competitivo, o el desempeño deportivo no sea el mayor atributo del estudiante, pertenecer a <b>un equipo</b> puede ser muy importante. Ser capitán de un equipo, en cualquier deporte, es otra importante señal de <b>liderazgo</b>.</li> <li>Participar en una <b>“sociedad honoraria”</b> (<i>Honors Society</i>).</li> <li>Tener una amistad con uno o más profesores del área de interés profesional del estudiante puede llegar a ser muy importante a la hora de conseguir una buena carta de <b>recomendación</b>.</li> <li>Los <b>consejeros escolares</b> (<i>school counselors</i>), son muy importantes a la hora de tener claros los pasos que se necesitan para llegar a la universidad. Es importante establecer una buena relación y <b>visitar con frecuencia al consejero/a</b> de la escuela desde el primer año de <i>high school</i>. </li><li>Si no los hay, es bueno buscar ayuda de una de las múltiples <b>organizaciones</b> creadas para brindar ese tipo de asesoría.</li>","url":"https://www.univision.com/noticias/educacion/que-actividades-extracurriculares-son-importantes","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/6","path":"/educacion/8/6","context":{"slug":"educacion/8/6","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"6","card":"¿Cómo se gestionan las horas comunitarias?","text":"<p>Los colleges y las universidades valoran mucho el servicio comunitario a la hora de seleccionar a sus estudiantes y ofrecerles ayudas financieras.<br></p><p>Muchos <i>high schools</i> exigen un mínimo de horas de servicio comunitario. Hay que hacerlas, aún si la escuela no las pide. Mientras más se tengan, mejor. Algunas sociedades académicas (<i>Honors Societies</i>) valoran mucho el servicio comunitario y dan oportunidades para hacer ese trabajo voluntario.</p><p>Algunos colleges, prefieren el llamado <i>service learning</i>, en el que a través del trabajo comunitario el estudiante desarrolla habilidades relacionadas con su área de interés.</p><p>Algunos <i>high schools</i> ayudan a sus estudiantes de último año (<i>seniors</i>) a conseguir una pasantía (<i>internship</i><i>)</i> relacionada con la carrera que hayan elegido para la universidad. Participar en un <i>internship</i>, durante uno o dos veranos, es una forma excelente de desarrollar habilidades académicas, de conocer más sobre un área de estudio y de desarrollar una relación con un supervisor que pueda escribir una carta de recomendación para incluir con los materiales de solicitud de admisión a la universidad.</p>","url":"https://www.univision.com/noticias/educacion/como-se-gestionan-las-horas-comunitarias","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/7","path":"/educacion/8/7","context":{"slug":"educacion/8/7","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"7","card":"¿Cuáles son los errores más comunes a la hora de aplicar a la universidad?","text":"<li>Usar una dirección de correo electrónico demasiado <b>informal</b>, dice Juan García de ACT, uno de los dos exámenes estandarizados para entrar a la universidad. Es <a href=\"http://www.univision.com/noticias/cuales-son-los-errores-mas-comunes-a-la-hora-de-aplicar-a-la-universidad-video#eov\">uno de los errores más comunes</a>. Esto está bien para uso <b>personal</b>, pero todo estudiante debe tener una dirección formal que use para propósitos<b> académicos y profesionales.</b></li><li>Alguien que no es el estudiante llena la aplicación y escribe <b>su propia información</b> en vez de la del estudiante. </li><li><b>Pasarse de las fechas límites</b> que exigen las universidades para entregar los documentos de la aplicación.</li></ul>","url":"https://www.univision.com/noticias/educacion/cuales-son-los-errores-mas-comunes-a-la-hora-de-aplicar-a-la-universidad","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/8/8","path":"/educacion/8/8","context":{"slug":"educacion/8/8","node":{"idbaraja":"8","baraja":"¿Cómo aplico a la universidad?","idcard":"8","card":"¿Puedo ir a una universidad de élite así no pueda pagarla?","text":"<p>Muchos estudiantes no aplican a las universidades más selectivas porque <b>creen que no las pueden pagar</b>. Con las ayudas financieras, sin embargo, su costo puede ser muy bajo.</p><p>Para que los estudiantes que van a ingresar a la universidad tengan una idea de cuánto les pueden costar sus estudios, el gobierno exigió que todas las entidades de educación superior desplieguen en sus páginas de internet una <b>“calculadora de precio neto”.</b></p><p>El <a href=\"http://studentaidhelp.ed.gov/app/answers/detail/a_id/1293/~/que-es-el-costo-de-la-universidad-y-precio-neto\">“precio neto”</a> es la cantidad que <b>deben pagar</b> los estudiantes para atender una institución de educación superior en un año académico después de descontar las <b>ayudas financieras</b> que ofrece la institución y las <b>becas</b> conseguidas por el estudiante, dentro o fuera de la universidad.</p><p>El Departamento de Educación tiene <a href=\"https://collegecost.ed.gov/netpricecenter.aspx\">una página en internet</a> (en inglés) que explica en qué consisten las “calculadoras de precio neto” y te ofrece un buscador para encontrar las <b>calculadoras de las universidades que escojas.</b></p>","url":"https://www.univision.com/noticias/educacion/que-posibilidades-tengo-de-estudiar-en-una-universidad-de-elite","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/9/1","path":"/educacion/9/1","context":{"slug":"educacion/9/1","node":{"idbaraja":"9","baraja":"¿Puedo estudiar en la universidad si soy indocumentado?","idcard":"1","card":"Si soy indocumentado, ¿puedo ir a la universidad?","text":"<p>En general sí, pero eso <b>depende del estado</b> y de la institución donde quieras ingresar.</p><p> <a href=\"https://www.theatlantic.com/politics/archive/2016/03/the-folly-of-under-educating-the-undocumented/473877/\">Tres estados que lo <b>prohíben por ley</b></a> no te permiten inscribirte sin documentación: </p><li>Georgia</li><li>Carolina del Sur</li><li>Alabama</li><p> Sin embargo son la <b>excepción</b>. La mayoría de estados permiten estudiar e incluso ofrecen <b>ayudas financieras</b>.</p><p>La decisión de admitir indocumentados en universidades privadas o públicas es <b>a discreción de la escuela</b>. Investiga las políticas de <b>admisión</b> de las universidades que te interesan.</p>","url":"https://www.univision.com/test/los-indocumentados-y-la-educacion-superior","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/9/2","path":"/educacion/9/2","context":{"slug":"educacion/9/2","node":{"idbaraja":"9","baraja":"¿Puedo estudiar en la universidad si soy indocumentado?","idcard":"2","card":"¿En qué estados es más fácil estudiar como indocumentado?","text":"<p>Hay varios estados, por ejemplo, que les permiten a estudiantes sin documentos <a href=\"http://www.law.uh.edu/ihelg/documents/Statute-TableOne.html\" <=\"\" span=\"\">pagar la matrícula como un residente del estado, </a>lo cual la hace significativamente <b>más barata</b>.</p><p> Estos estados son:</p><ul><li>Texas</li><li>California</li><li>Utah</li><li>Nueva York</li><li>Washington</li><li>Oklahoma</li><li>Illinois</li><li>Kansas</li><li>Nuevo México</li><li>Nebraska</li><li>Maryland</li><li>Connecticut</li><li>Rhode Island</li><li>Oregon</li><li>Colorado</li><li>Hawaii</li><li>Minnesota</li><li>Nueva Jersey</li><li>Florida</li><p>De estos, <a href=\"http://www.univision.com/noticias/universidades/grandes-retos-para-estudiantes-indocumentados\">solo un puñado ofrecen <b>becas para indocumentados</b>:</a></p><li>Texas</li><li>California</li><li>Washington</li><li>Nuevo México</li><li>Oregon</li><li>Colorado</li>","url":"https://www.univision.com/test/los-estados-donde-es-mas-facil-estudiar-como-indocumentado#","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/9/3","path":"/educacion/9/3","context":{"slug":"educacion/9/3","node":{"idbaraja":"9","baraja":"¿Puedo estudiar en la universidad si soy indocumentado?","idcard":"3","card":"¿Qué opciones de ayuda financiera tiene un estudiante indocumentado?","text":"<li>La página <a href=\"https://mydocumentedlife.org/\" <=\"\" span=\"\">Myundocumentedlife.org</a> contiene información útil para personas sin documentos, sobre todo <a href=\"https://mydocumentedlife.org/2016/09/12/scholarships-open-to-undocumented-students/\" <=\"\" span=\"\">una lista de hasta 14 becas distintas disponibles para estudiantes indocumentados.</a></li><p>Estas se especializan en diferentes temas o grupos de personas, como <b>jóvenes latinas</b>, para quienes buscan un <b>doctorado</b>, un diploma en <b>derecho</b>, <b>medicina</b>, etc.br></p><li>Otra página, <a href=\"url\">Maldef.org</a>, tiene una <a href=\"http://www.maldef.org/assets/pdf/2017-2018_MALDEF_Scholarship_List_10.2016.pdf\">lista de más de una docena de becas distintas para indocumentados,</a> disponibles a estudiantes en todo el país. </li><p>Estas páginas web también tienen otros recursos para estudiantes sin documentos: </p><li><a href=\"http://unitedwedream.org/about/projects/education-deep/\">United We Dream</a> </li><li><a href=\"https://www2.ed.gov/about/overview/focus/supporting-undocumented-youth.pdf\">Guía de Recursos del Departamento de Educación</a></li><li> <a href=\"http://www.thedream.us/\">TheDream.Us</a> </li><li><a href=\"http://www.dreamersroadmap.com/\">DREAMer's Roadmap</a> </li><li><a href=\"http://www.univision.com/noticias/universidades/www.nclr.org\">Consejo Nacional de La Raza</a> </li><li><a href=\"http://www.univision.com/noticias/universidades/www.nilc.org\">Centro Nacional de Leyes Migratorias</a> </li><li><a href=\"https://www.collegeboard.org/ \">College Board</a></li><li> <a href=\"http://www.dreamactivist.org/ \">Dream activists</a></li>","url":"https://www.univision.com/test/las-opciones-de-ayuda-financiera-que-tiene-un-estudiante-indocumentado","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/9/4","path":"/educacion/9/4","context":{"slug":"educacion/9/4","node":{"idbaraja":"9","baraja":"¿Puedo estudiar en la universidad si soy indocumentado?","idcard":"4","card":"¿Qué es una universidad santuario?","text":"<p>Al igual que ocurre con <a href=\"http://www.univision.com/noticias/inmigracion/ni-son-ciudades-ni-son-santuarios-el-termino-que-todos-utilizan-y-que-pocos-entienden\">las ciudades o condados santuario</a>, no hay una <b>definición legal</b>, y la que se usa comúnmente es <b>ambigua</b>. </p><p>Cómo se define un campus santuario está directamente relacionado a lo que pidan los estudiantes y hasta qué punto las universidades acceden. Algunos estudiantes piden a las universidades que <b>declaren públicamente su apoyo</b> a los estudiantes indocumentados, <a href=\"http://www.nyu.edu/content/dam/nyu/president/documents/11.29.16-letter-from-andrew-hamilton.pdf\">como ocurrió con la Universidad de Nueva York.</a> </p><p>Otros piden garantías de que la escuela <b>no dará información sobre el estatus migratorio</b> de los estudiantes y que las fuerzas policiales universitarias <b>no se unirán a los federales</b> en las incursiones de <b>deportación</b>, <a href=\"http://columbiaspectator.com/news/2016/11/21/university-provide-sanctuary-financial-support-undocumented-students/\">como es el caso de la Universidad de Columbia.</a></p>","url":"https://www.univision.com/test/las-universidades-santuario","sheet":"Educación"}}}},{"node":{"id":"SitePage /educacion/9/5","path":"/educacion/9/5","context":{"slug":"educacion/9/5","node":{"idbaraja":"9","baraja":"¿Puedo estudiar en la universidad si soy indocumentado?","idcard":"5","card":"¿Qué tipo de protecciones puede ofrecer un campus santuario?","text":"<p>Al aceptar la etiqueta de campus santuario las universidades se pueden comprometer, por ejemplo, <a href=\"http://www.univision.com/noticias/inmigracion/que-debes-hacer-si-eres-indocumentado-y-te-detienen-en-una-redada-migratoria\" <=\"\" span=\"\"></a> <b>ni dejar entrar a los recintos universitarios a agentes</b> en busca de indocumentados.<br></p><p> Otras universidades se pueden comprometer a <b>no compartir información</b> de sus estudiantes con las autoridades. </p><p> Otras, incluso, establecen <b>fondos para ayudar a inmigrantes con sus gastos legales.</b></p><p> Algo concreto con que las universidades pueden cumplir es comprometerse a no dar información a agencias federales <i>voluntariamente</i>. La Universidad Wesleyan, por ejemplo, <a href=\"http://www.univision.com/noticias/citylab-politica/las-dificultades-que-tendrian-los-campus-santuario-para-proteger-a-estudiantes-indocumentados\">una de las primeras en declararse santuario, </a> creó dos cláusulas que explican que <b>no ayudaría</b>, bajo su propia voluntad, con los esfuerzos del gobierno de deportar a estudiantes, profesores ni personal indocumentados.</p>","url":"https://www.univision.com/test/los-tipos-de-protecciones-que-puede-ofrecer-un-campus-santuario","sheet":"Educación"}}}},{"node":{"id":"SitePage /404/","path":"/404/","context":{"slug":null,"node":null}}},{"node":{"id":"SitePage /","path":"/","context":{"slug":null,"node":null}}},{"node":{"id":"SitePage /internal/","path":"/internal/","context":{"slug":null,"node":null}}},{"node":{"id":"SitePage /404.html","path":"/404.html","context":{"slug":null,"node":null}}},{"node":{"id":"SitePage /inmigracion/1/1","path":"/inmigracion/1/1","context":{"slug":"inmigracion/1/1","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"1","card":"¿Qué es una visa? ","text":"<li> Una visa es <b>un sello estampado en un pasaporte</b> que indica la categoría de ingreso con la que el portador es autorizado a entrar al país bajo dos categorías: inmigrante o no inmigrante.</li><li> La visa sellada en un pasaporte no refleja el <b>período de tiempo autorizado al viajero al entrar en el territorio nacional</b>, y no tiene efecto en el estatus no inmigratorio del individuo en Estados Unidos.</li>","url":"https://www.univision.com/noticias/inmigracion/visas-para-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/2","path":"/inmigracion/1/2","context":{"slug":"inmigracion/1/2","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"2","card":"¿Qué significa la expresión 'estatus migratorio'?","text":"<li> Es la situación como inmigrante de un ciudadano extranjero en el país.</li><li> Lo determina el tipo de admisión y el período autorizado de permanencia otorgado por un agente federal de inmigración (CBP) en un puerto de entrada (aéreo, marítimo o terrestre).</li><li> Las personas que no cumplen con el criterio de la visa de admisión, o se quedan más allá del tiempo de permanencia autorizado, son consideradas <b>fuera de estatus</b>.</li><li> A las personas que han ingresado sin autorización o permanecen en el país después de que ha expirado la autorización de entrada y permanencia concedida por el gobierno federal en el puerto de entrada se les considera <b>indocumentadas</b>.</li>","url":"https://www.univision.com/noticias/inmigracion/el-estatus-migratorio-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/3","path":"/inmigracion/1/3","context":{"slug":"inmigracion/1/3","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"3","card":"¿Qué tipo de visa necesito para entrar a Estados Unidos?","text":"<li> Existen cerca de <b>65 clases de visa</b> (divididas en 18 categorías) que utilizan los distintos tipos de visitantes, desde empleados domésticos y turistas hasta hombres de negocios, trabajadores agrícolas, profesionales, estudiantes, ejecutivos e inversores.</li><li> Cada visa tiene características propias, dispone de un reglamento único y se usa con fines distintos, en algunos casos con períodos de validez que van desde unos cuantos días hasta varios años, dependiendo de la nacionalidad de la persona.</li>","url":"https://www.univision.com/noticias/inmigracion/la-visa-para-ingresar-a-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/4","path":"/inmigracion/1/4","context":{"slug":"inmigracion/1/4","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"4","card":"¿Qué diferencia hay entre una visa de inmigrante y una de no inmigrante?","text":"<li> Las visas de inmigrante son las que se conceden a personas que llegan a Estados Unidos con la intención de <b>vivir permanentemente en el país</b>, por haber sido pedidas por un familiar directo o por una empresa que los quiere contratar de manera permanente.</li><li> Las visas de no inmigrante son las que se conceden a personas que vienen al país con la intención de permanecer en él <b>de manera temporal</b>, por motivos de turismo, estudio o trabajo.</li>","url":"https://www.univision.com/noticias/inmigracion/visas-de-inmigrante-y-de-no-inmigrante","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/5","path":"/inmigracion/1/5","context":{"slug":"inmigracion/1/5","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"5","card":"¿Cuáles son las visas más comunes?","text":"<li> El servicio de inmigración registra anualmente <b>entre 170 millones y 180 millones de entradas legales</b>, sea por un puerto fronterizo aéreo, terrestre o marítimo.</li><li> De los 181 millones de entradas legales anuales en promedio (de acuerdo con datos del año fiscal 2017), unos 70 millones (41%) lo hacen bajo la categoría de no inmigrante con las visas B1 o B2, también conocidas como <b>visas de turista</b>.</li>","url":"https://www.univision.com/noticias/inmigracion/las-visas-mas-comunes-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/6","path":"/inmigracion/1/6","context":{"slug":"inmigracion/1/6","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"6","card":"¿Qué tipo de visa se necesita para trabajar en Estados Unidos?","text":"<li> Hay varias categorías de visas relacionadas con el trabajo, pero las más usadas por la comunidad latina son las visas tipo H.</li><li> <b>La categoría H-1B</b> es la principal visa de trabajo profesional. Tiene el objetivo de satisfacer la necesidad de las empresas de contratar trabajadores especializados. Para poder obtenerla, basta con que un empleador en Estados Unidos solicite tu traslado y que el puesto que te ofrece cumpla con uno de los requisitos establecidos por la Ley de Inmigración.</li>","url":"https://www.univision.com/noticias/inmigracion/las-visas-para-trabajar-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/7","path":"/inmigracion/1/7","context":{"slug":"inmigracion/1/7","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"7","card":"¿Qué requisitos se deben cumplir para obtener una visa H-1B?","text":"<li> La posición particular tiene un requisito mínimo de un título universitario o licenciatura, o un equivalente del mismo.</li><li> El puesto tiene un requisito de título de grado que es común en la industria para puestos paralelos en organizaciones similares o, en caso contrario, el puesto es tan complejo y único que requiere un título de grado.</li><li> Tu empleador normalmente exige un título de grado o su equivalente para el puesto.</li><li> El trabajo es tan especializado y complejo que el conocimiento requerido para llevar a cabo los deberes laborales está típicamente asociado con la obtención de, como mínimo, un título universitario o licenciatura, o su equivalente.</li>","url":"https://www.univision.com/noticias/opinion/las-visas-h-1b-y-sus-requisitos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/8","path":"/inmigracion/1/8","context":{"slug":"inmigracion/1/8","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"8","card":"¿Quién decide si me dan una visa?","text":"<li> La Oficina de Ciudadanía y Servicios de Inmigración (US Citizenship and Immigration Services, USCIS), <b>determinará si cumples con los requisitos</b> para obtener ese beneficio.</li><li> Cada solicitud de visa de no inmigrante, al igual que el proceso de inmigrante, tiene sus particulares criterios legales, y será esta oficina la que determinará si cumples con los requisitos de la Ley de Inmigración para que te aprueben (o rechacen) la solicitud o gestión de una visa.</li><li> Una vez aprobada, estarás listo para solicitar la visa en una embajada o consulado estadounidense, done te harán una entrevista para determinar si cumples con los requisitos de la solicitud aprobada por USCIS.</li>","url":"https://www.univision.com/noticias/opinion/de-quien-depende-la-expedicion-de-las-visas","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/9","path":"/inmigracion/1/9","context":{"slug":"inmigracion/1/9","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"9","card":"¿Por qué me pueden negar una visa?","text":"<li> La solicitud o petición está incompleta.</li><li> Hay que cumplir con requisitos adicionales, tales como aranceles, que son específicos del caso, o el consulado necesita más explicación del propósito de tu viaje a Estados Unidos.</li><li> El consulado necesita más respuestas a ciertas preguntas (o necesita ciertas pruebas).</li><li> No contestaste alguna pregunta del formulario para solicitar la visa.</li><li> Existe indicio de fraude o mala representación.</li><li> Viviste de manera ilegal (indocumentado) en Estados Unidos.</li><li> Existe amenaza de que te conviertas en carga pública.</li>","url":"https://www.univision.com/noticias/opinion/razones-para-negar-una-visa","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/10","path":"/inmigracion/1/10","context":{"slug":"inmigracion/1/10","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"10","card":"¿Tener una visa en el pasaporte me garantiza la entrada a Estados Unidos?","text":"<p>• Se cree que la visa impresa en un pasaporte garantiza la entrada a Estados Unidos, pero no es así. Un funcionario de un puerto de entrada puede autorizar o negar el ingreso.</li>","url":"https://www.univision.com/test/la-visa-en-el-pasaporte-y-la-entrada-a-eeuu","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/1/11","path":"/inmigracion/1/11","context":{"slug":"inmigracion/1/11","node":{"idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"11","card":"¿Qué hago si perdí mi visa?","text":"<li> El documento extraviado es la <b>\"tarjeta I-94”</b> que recibes al entrar a Estados Unidos, porque en tu pasaporte está estampado el sello del agente federal que te dio el ingreso al país, con la fecha autorizada para permanecer en EEUU.</li><li> Ese documento <b>lo debes devolver cuando te marchas del país</b>. Puedes obtener una copia en la página web de la Oficina de Aduanas y Protección Fronteriza (CBP) ingresando tus datos personales de identificación.</li>","url":"https://www.univision.com/test/la-perdida-de-la-visa","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/1","path":"/inmigracion/2/1","context":{"slug":"inmigracion/2/1","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"1","card":"¿Cómo se puede obtener una residencia permanente en Estados Unidos?","text":"<li> Por medio de una petición familiar.</li><li> Por medio de una petición de un empleador.</li><li> Por alguna categoría especial de visa de inmigrante que no depende ni de la petición familiar ni de la petición de un empleador (asilo o refugio, o visas T y U para víctimas de tráfico humano y violencia doméstica, por ejemplo).</li>","url":"https://www.univision.com/test/la-residencia-permanente-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/2","path":"/inmigracion/2/2","context":{"slug":"inmigracion/2/2","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"2","card":"¿Quiénes pueden solicitar la residencia de un familiar inmediato para que emigre a Estados Unidos?","text":"<li> Ciudadanos de EEUU.</li><li> Residentes legales permanentes.</li><li> Refugiados (admitida su entrada como tales en los últimos dos años).</li><li> Asilados (recibió asilo en los últimos dos años).</li>","url":"https://www.univision.com/test/la-solicitud-de-un-familiar-inmediato-para-que-emigre-a-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/3","path":"/inmigracion/2/3","context":{"slug":"inmigracion/2/3","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"3","card":"¿Cuáles familiares inmediatos pueden ser pedidos por un ciudadano estadounidense?","text":"<li> La Ley de Inmigración permite a los ciudadanos estadounidenses solicitar la residencia permanente en Estados Unidos para ciertos familiares que cumplan con los requisitos necesarios para residir permanentemente en Estados Unidos.</li><li> Solo los familiares inmediatos (cónyuges e hijos menores de edad y solteros, al igual que padres de ciudadanos mayores de 21 años) reciben una tarjeta de residencia (<i>green card</i>) sin tener que esperar.</li><li> Otros familiares (hijos mayores de 21 años, hijos casados o hermanos) tienen que esperar hasta varios años en ciertos casos.</li>","url":"https://www.univision.com/test/los-familiares-inmediatos-que-puede-pedir-un-ciudadano","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/4","path":"/inmigracion/2/4","context":{"slug":"inmigracion/2/4","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"4","card":"¿Cuáles familiares inmediatos pueden ser pedidos por un residente?","text":"<li> Cónyuge.</li><li> Hijo soltero menor de 21 años.</li><li> Hijo soltero mayor de 21 años.</li>","url":"https://www.univision.com/test/los-familiares-que-pueden-ser-pedidos-por-un-residente","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/5","path":"/inmigracion/2/5","context":{"slug":"inmigracion/2/5","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"5","card":"¿Cuánto tiempo toma recibir una residencia para un familiar?","text":"<li> Con excepción de los familiares inmediatos de los ciudadanos, y debido a la limitada cuota anual de residencias legales permanentes que otorga el Centro Nacional de Visas del Departamento de Estado, y el alto número de peticiones de familiares extranjeros ante la Oficina de Ciudadanía y Servicios de Inmigración (USCIS), todas estas categorías deben esperar a veces años para que el beneficio se te otorgue, aunque éste haya sido aprobado al poco tiempo de haber presentado la solicitud.</li><li> Para saber el tiempo exacto, debes consultar el Boletín de Visas del Departamento de Estado, que se actualiza mensualmente.</li>","url":"https://www.univision.com/test/el-tiempo-que-toma-la-aprobacion-de-una-residencia-para-un-familiar","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/6","path":"/inmigracion/2/6","context":{"slug":"inmigracion/2/6","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"6","card":"¿Cómo se puede obtener una residencia con base en un empleo?","text":"<li> La mayoría de las categorías de visa de no inmigrante sirven como trampolín para obtener la <i>green card</i>.</li><li> En muchos casos, mientras el empleado va escalando y progresando dentro de la empresa que lo contrató, su patrocinador comienza un proceso de residencia con el objetivo de incentivarlo para que no se marche.</li><li> <b>Hay cinco visas de inmigrante basadas en categorías de empleo</b> (EB-1, EB-2, EB-3, EB-4 t EB-5), y cada año fiscal el gobierno federal otorga 140,000 de estas visas.</li>","url":"https://www.univision.com/test/la-obtencion-de-residencia-con-base-en-un-empleo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/7","path":"/inmigracion/2/7","context":{"slug":"inmigracion/2/7","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"7","card":"¿Es posible obtener la residencia permanente por un camino distinto a una petición familiar o al patrocinio de un empleador? ","text":"<li> Sí.</li><li> Hay varias categorías de visas especiales que otorgan el beneficio.</li><li> Entre ellas vale la pena mencionar la visa S (para testigos o informantes del gobierno), la visa T (para víctimas de tráfico de personas) y la visa U (para víctimas de abuso doméstico o infantil).</li>","url":"https://www.univision.com/test/caminos-para-obtener-la-residencia-distintos-a-la-peticion-familiar-y-al-empleo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/8","path":"/inmigracion/2/8","context":{"slug":"inmigracion/2/8","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"8","card":"¿Qué es la lotería de visas y qué derechos concede?","text":"<li> La Ley de Inmigración considera una clase de inmigrantes conocidos como 'inmigrantes diversos', que provienen de países con tasas históricamente bajas de inmigración a EEUU.</li><li> Para ellos fue diseñado el <b>Programa de Visas de Diversidad</b>, que sortea y distribuye 50,000 aprobaciones anuales a través de las cuales se permite a los seleccionados solicitar una residencia permanente.</li><li> El gobierno hace el sorteo entre seis regiones geográficas, y ningún país puede recibir más de 7% de las visas disponibles en cada oportunidad.</li>","url":"https://www.univision.com/test/la-loteria-de-visas-y-los-derechos-que-concede","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/9","path":"/inmigracion/2/9","context":{"slug":"inmigracion/2/9","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"9","card":"¿Qué derechos tengo como residente permanente?","text":"<li> Residir (vivir) permanentemente en cualquier parte del territorio de EEUU.</li><li> Trabajar legalmente en Estados Unidos, pero con ciertas limitaciones.</li><li> Ser propietario de bienes e inmuebles.</li><li> Estudiar en una escuela pública.</li><li> Solicitar una licencia de manejar sin restricciones, en cualquier estado o territorio de Estados Unidos.</li><li> Gestionar y recibir un número de seguro social sin restricciones.</li><li> Después de un tiempo, y si cumples los requisitos, hacerte ciudadano estadounidense. Esto puede realizarse después de tres o cinco años, dependiendo de cómo obtuviste tu residencia permanente.</li><li> Recibir beneficios de Seguro Social o Medicare, si reúnes los requisitos.</li><li> Estar amparado por las leyes de Estados Unidos, del estado donde vives y de las jurisdicciones locales (condados o ciudades).</li><li> Pedir visas de inmigrante para tu cónyuge o hijos solteros, para que te acompañen en Estados Unidos.</li><li> Salir y entrar del país siempre y cuando demuestres lazos e intención de permanencia.</li><li> Estar fuera, no más de seis meses.</li>","url":"https://www.univision.com/test/los-derechos-que-concede-la-residencia-permanente","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/10","path":"/inmigracion/2/10","context":{"slug":"inmigracion/2/10","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"10","card":"¿Qué obligaciones tengo como residente permanente en Estados Unidos?","text":"<li> Obedecer todas las leyes federales, estatales y locales de EEUU.</li><li> Presentar tus contribuciones federales y declarar tus ingresos al IRS y a las autoridades fiscales estatales.</li><li> Apoyar la forma democrática de gobierno y no pretender cambiar el gobierno por medios ilegales.</li><li> Inscribirte en el Sistema de Servicio Selectivo si eres varón y tienes entre 18 y 25 años de edad.</li><li> Mantener tu estado de inmigrante.</li><li> Llevar siempre contigo evidencia de tu residencia legal si eres mayor de 18 años de edad.</li><li> Notificar al gobierno federal cualquier cambio de residencia o domicilio.</li><li> Renovar tu tarjeta de residencia (<i>green card</i> o tarjeta verde) antes de su expiración (generalmente, 10 años).</li><li> Obtener una tarjeta de residencia (<i>green card</i> o tarjeta verde) nueva si tu nombre cambia.</li>","url":"https://www.univision.com/test/las-obligaciones-de-un-residente-permanente","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/11","path":"/inmigracion/2/11","context":{"slug":"inmigracion/2/11","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"11","card":"¿En qué casos puedo perder la residencia permanente en Estados Unidos?","text":"<li> Si te mudas a otro país con la intención de vivir en él de forma permanente.</li><li> Si permaneces fuera de EEUU por más de un año (365 días) sin haber tramitado previamente un permiso de reingreso. Pero recuerda siempre que cualquier ausencia puede ser reconsiderada.</li><li> Si permaneces fuera de EEUU por más de dos años después de haber obtenido un permiso de reingreso.</li><li> Si no presentaste tu declaración de impuestos durante tu residencia en EEUU.</li><li> Si declaras que no eres inmigrante en tu declaración de impuestos.</li><li> Si firmas un documento llamado 'Registro de abandono de estatus de residente permanente legal' y no ejerces tu derecho a presentarte ante un juez de inmigración para que decida tu permanencia legal en EEUU.</li><li> Si un tribunal de inmigración ordena tu deportación.</li>","url":"https://www.univision.com/test/la-residencia-permanente-se-puede-perder","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/2/12","path":"/inmigracion/2/12","context":{"slug":"inmigracion/2/12","node":{"idbaraja":"2","baraja":"¿Cómo obtengo una residencia permanente en EEUU?","idcard":"12","card":"¿Puedo ser deportado siendo residente permanente en Estados Unidos?","text":"<li> EEUU es un país de leyes y todo extranjero, sea inmigrante, no inmigrante o indocumentado, tiene que cumplir con las normas establecidas o arriesgar no solamente un proceso penal, sino también una deportación.</li><li> Aun si eres residente permanente, una condena penal puede tener consecuencias graves en cuanto al derecho de permanecer en el país.<</li><li> Dependiendo del delito, al cumplir una condena y obligaciones bajo el sistema penal, a una persona se le puede detener, deportar y prohibírsele el reingreso al país.</li><li> También se puede perder la residencia legal permanente y el derecho a obtener la ciudadanía por naturalización.</li> ","url":"https://www.univision.com/test/los-residentes-puede-ser-deportados","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/1","path":"/inmigracion/3/1","context":{"slug":"inmigracion/3/1","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"1","card":"¿Quiénes pueden gozar del beneficio de asilo en Estados Unidos? ","text":"<li> Estados Unidos otorga asilo o refugio a personas que se ven obligadas a huir de su país debido a persecución por uno de cinco motivos: raza, religión, nacionalidad, pertenencia a un grupo social en particular u opinión política.</li> <li> En ningún caso se trata de procesos sencillos o fáciles. Cada uno de estos caminos, que están separados entre sí, tiene un proceso complicado y requisitos difíciles de cumplir.</li> <li> Muchas de estas solicitudes son desestimadas porque no cumplen con uno de los cinco motivos de persecución que causaron la huida.</li> ","url":"https://www.univision.com/test/el-beneficio-del-asilo-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/2","path":"/inmigracion/3/2","context":{"slug":"inmigracion/3/2","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"2","card":"¿Qué diferencia hay entre refugio y asilo?","text":"<li> Un refugiado es una persona que ha abandonado su país de nacimiento y no puede regresar debido a persecución por uno de cinco motivos: raza, religión, nacionalidad, pertenencia a un grupo social en particular u opinión política. El estatus de refugiado solo se puede solicitar desde fuera del territorio de Estados Unidos.</li> <li> Un asilado cumple con uno de los cinco posibles motivos de persecución, pero ya se encuentra en territorio de Estados Unidos o ha llegado a un puerto de entrada del país (terrestre, marítimo o aéreo), donde puede pedir asilo.</li> ","url":"https://www.univision.com/test/las-diferencias-entre-el-refugio-y-el-asilo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/3","path":"/inmigracion/3/3","context":{"slug":"inmigracion/3/3","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"3","card":"¿Qué se necesita para calificar como refugiado? ","text":"<li> Estar fuera de Estados Unidos.</li> <li> Ser considerado una persona de interés humanitario para Estados Unidos.</li> <li> Demostrar que ha sido perseguido por causa de su religión, nacionalidad, opinión política o pertenencia a algún grupo en particular.</li> <li> No estar establecido en otro país que no sea el suyo.</li> <li> Reunir los requisitos para que su entrada a Estados Unidos sea admitida.</li> <li> El proceso de solicitud para ser considerado refugiado generalmente comienza con una recomendación de un organismo de las Naciones Unidas. No es un proceso que se pueda solicitar directamente en una embajada de Estados Unidos.</li> ","url":"https://www.univision.com/test/condiciones-para-ser-refugiado","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/4","path":"/inmigracion/3/4","context":{"slug":"inmigracion/3/4","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"4","card":"¿Qué necesita un refugiado para poder trabajar en Estados Unidos? ","text":"<li> Los refugiados pueden trabajar inmediatamente después de entrar al país.</li> <li> En el puerto de entrada reciben un formulario I-94 con un sello de admisión indicando el estatus de refugiado, y se les tramitará una «Solicitud de autorización de empleo»  para que reciban un permiso de trabajo.</li> <li> Mientras el refugiado espera a vuelta de correo su carné para trabajar, puede usar el formulario I-94 como prueba.</li> ","url":"https://www.univision.com/test/los-refugiados-y-el-trabajo-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/5","path":"/inmigracion/3/5","context":{"slug":"inmigracion/3/5","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"5","card":"¿Quiénes son los que más solicitan asilo en Estados Unidos? ","text":"<li> En los últimos años, la mayor cantidad de peticiones de asilo han venido de nacionales de Venezuela, China y México. Y más recientemente, de Guatemala y Honduras.</li> <li> El solicitante tiene que presentar muchas pruebas (sea por una solicitud afirmativa o una solicitud defensiva), y demostrar que tiene miedo creíble de persecución en su país de origen.</li> ","url":"https://www.univision.com/test/los-que-piden-asilo-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/6","path":"/inmigracion/3/6","context":{"slug":"inmigracion/3/6","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"6","card":"¿Qué diferencia hay entre asilo afirmativo y asilo defensivo? ","text":"<li> El asilo afirmativo es aquel que solicitan las personas que buscan la protección del gobierno de Estados Unidos y no se encuentran en proceso de deportación.</li> <li> El asilo defensivo es aquel que solicitan las personas que se encuentran en proceso de deportación. Puede ser personas que se encuentren ya en Estados Unidos o que hayan sido detenidas al tratar de ingresar al país y hayan sido puestas en un proceso expedito de deportación.</li> ","url":"https://www.univision.com/test/el-asilo-afirmativo-y-el-asilo-defensivo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/7","path":"/inmigracion/3/7","context":{"slug":"inmigracion/3/7","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"7","card":"¿Quién toma las decisiones sobre asilo? ","text":"<li> Hecha la petición de asilo, la persona es recibida por un agente de la Oficina de Asilo, que depende de la USCIS, para someterse a una entrevista de miedo creible.</li> <li> Si el funcionario determina que la persona tiene un miedo creíble, al igual que la posibilidad significativa de establecer el criterio para recibir asilo, el caso es referido a una corte de inmigración para que determine la veracidad del caso.</li> <li> En últimas, el caso es resuelto por un juez de inmigración.</li> ","url":"https://www.univision.com/test/las-decisiones-sobre-el-asilo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/8","path":"/inmigracion/3/8","context":{"slug":"inmigracion/3/8","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"8","card":"¿Qué es el miedo creíble?  ","text":"<li> Para garantizar un proceso de asilo que no viole las leyes internacionales y nacionales, el gobierno tiene que tomar en cuenta el miedo de la persona y determinar si es creíble mediante una entrevista, sobre todo si durante el proceso de asilo el peticionario expresa temor de ser perseguido o torturado si es devuelto a su país.</li> <li> El concepto de miedo creíble también se aplica a los ciudadanos extranjeros que han sido deportados y regresan sin autorización a Estados Unidos.</li> <li> Aquellos que han sido condenados por ciertos delitos y están sujetos a ser deportados pero que durante el proceso de expulsión expresan el temor de regresar a su país también pueden argumentar miedo, aunque en esos casos se requiere demostrar miedo razonable, un criterio más elevado y riguroso para demostrar.</li> ","url":"https://www.univision.com/test/el-miedo-creible-en-las-entrevistas-de-asilo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/9","path":"/inmigracion/3/9","context":{"slug":"inmigracion/3/9","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"9","card":"¿Cuánto se tarda un juez de inmigración en resolver una solicitud de asilo y qué tan probable es que la respuesta sea afirmativa? ","text":"<li> De acuerdo con las estadísticas del Departamento de Justicia de Estados Unidos, a finales de enero de 2019 los jueces de inmigración tenían un total de 821,726 casos pendientes de solución.</li> <li> En la actualidad, los jueces reciben cerca de 30,000 casos nuevos por mes, y solo pueden resolver un promedio de 20,000, lo que quiere decir que el acumulado sigue creciendo.</li> <li> Como consecuencia de esto, la solución de cada proceso puede tardar varios años. En el caso de los menores no acompañados (UAC), que tienen prioridad, la tardanza promedio es de 658 días, según el Departamento de Justicia.</li> <li> Solo una de cada 11 solicitudes de asilo es aprobada.</li> ","url":"https://www.univision.com/test/el-tiempo-que-toma-una-solicitud-de-asilo-y-la-probabilidad-de-que-sea-aprobado","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/10","path":"/inmigracion/3/10","context":{"slug":"inmigracion/3/10","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"10","card":"¿Qué es el fraude migratorio y cómo evitarlo? ","text":"<li> El complejo proceso de asilo y la avalancha de casos de los últimos tres años colapsaron las cortes de inmigración. Asimismo, generaron las condiciones propicias para el fraude, un delito que tiene como blanco la comunidad inmigrante en general.</li> <li> Incluso el gobierno federal, a través de la USCIS, advierte sobre las consecuencias de este delito, que les roba a los inmigrantes el derecho de permanencia en Estados Unidos.</li> <li> Si necesitas ayuda legal sobre asuntos de inmigración, asegúrate de que la persona que te ayuda esté autorizada para brindar consejo legal en esos casos.</li> ","url":"https://www.univision.com/test/el-fraude-migratorio-y-las-maneras-de-evitarlo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/3/11","path":"/inmigracion/3/11","context":{"slug":"inmigracion/3/11","node":{"idbaraja":"3","baraja":"¿Cómo pido asilo en EEUU? ","idcard":"11","card":"¿Cuándo puede solicitar la residencia permanente en Estados Unidos una persona a la que le aprueban el asilo? ","text":"<li> Al cumplir un año en el país, contado a partir de la fecha en que la solicitud de asilo es aprobada, el asilado reúne los requisitos para solicitar la residencia legal permanente (green card o tarjeta verde) por medio del formulario I-485.</li> ","url":"https://www.univision.com/test/la-aprobacion-del-asilo-y-la-residencia-permanente","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/1","path":"/inmigracion/4/1","context":{"slug":"inmigracion/4/1","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"1","card":"¿Cómo me hago ciudadano de EEUU?","text":"<p> La ley considera tres maneras a través de las cuales una persona se puede hacer ciudadano estadounidense.</p><li> Ciudadanía por nacimiento. Es la más obvia y está amparada por la 14 Enmienda de la Constitución, que dice que cualquier persona nacida en territorio estadounidense y sujeta a su jurisdicción es ciudadana del país.</li> <li> Ciudadanía derivada o adquirida. Este tipo de ciudadanía es la que adquieren los hijos de ciudadanos estadounidenses que nacen en el extranjero, siempre y cuando cumplan con criterios establecidos por ley.</li> <li> Ciudadanía por naturalización. Todo residente legal permanente, una vez cumplidos los requisitos, podrá solicitar la ciudadanía estadounidense.</li> ","url":"https://www.univision.com/test/la-ciudadania-de-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/2","path":"/inmigracion/4/2","context":{"slug":"inmigracion/4/2","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"2","card":"¿Cuáles son los requisitos para ser ciudadano?","text":"<li> Tener 18 años de edad o más.</li> <li> Tener buen carácter moral.</li> <li> Poder leer, escribir y entender el idioma inglés.</li> <li> Demostrar conocimiento suficiente del gobierno estadounidense y su historia.</li> <li> Ser residente legal permanente por cinco años (excepto en ciertas situaciones donde el requisito es de tres años).</li> <li> Tener residencia continua en Estados Unidos de por lo menos cinco años (excepto en ciertas situaciones).</li> <li> Estar físicamente presente en el país por lo menos la mitad del período de cinco años (excepto en ciertas situaciones).</li> <li> Residir en el lugar de residencia estadounidense por un periodo de, por lo menos, tres meses antes del envío del pedido de ciudadanía.</li> <li> Estar dispuesto a juramentar lealtad a Estados Unidos.</li> ","url":"https://www.univision.com/test/los-requisitos-para-ser-ciudadano","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/3","path":"/inmigracion/4/3","context":{"slug":"inmigracion/4/3","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"3","card":"¿Qué pasos hay que dar para hacerse ciudadano?","text":"<li> Llenar, firmar, revisar y enviar la 'Solicitud de ciudadanía' (N-400).</li> <li> Adjuntar el pago de la tarifa requerida por la USCIS (las personas de bajos ingresos que cumplan con ciertos criterios pueden pedir una excención de este pago).</li> <li> Pagar la tarifa requerida para la toma de huellas digitales electrónicas.</li> <li> Adjuntar una copia de tu tarjeta de residencia permanente (<i>green card</i> o tarjeta verde).</li> <li> Enviar todos estos documentos en un sobre a la dirección que indica el formulario N-400 (zona de instrucciones).</li> <li> Una vez que el gobierno reciba tu solicitud de ciudadanía, recibirás por correo una carta con un recibo que confirma que tu petición está siendo procesada.</li> <li> Algunas semanas después, recibirás una notificación por correo con una cita para que visites un Centro de Atención al Solicitante.</li> <li> Allí te tomarán las huellas digitales, una fotografía y te pedirán tu firma.</li> <li> Después de ese paso, el gobierno probablemente te citará, en el curso de unos meses, para una entrevista en una oficina local de la USCIS. Junto con la cita te llegarán las instrucciones de los documentos que deberás llevar para presentarle al agente que te entrevistará.</li> ","url":"https://www.univision.com/test/los-pasos-para-hacerse-ciudadano","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/4","path":"/inmigracion/4/4","context":{"slug":"inmigracion/4/4","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"4","card":"¿Es necesario hablar inglés para hacerse ciudadano?","text":"<p>Muchas personas que reúnen los requisitos no piden la ciudadanía por miedo a no aprobar el examen de inglés, pero el nivel exigido por el gobierno es básico.</p><p>Durante la entrevista de naturalización un funcionario de USCIS te examina sobre este criterio y te pide:</p><li> Que leas una de tres oraciones.</li> <li> Que escribas una de tres oraciones.</li> <li> Que contestes preguntas sobre el formulario.</li> <li> Que apruebes el examen de ciudadanía.</li> ","url":"https://www.univision.com/test/el-idioma-ingles-y-la-ciudadania","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/5","path":"/inmigracion/4/5","context":{"slug":"inmigracion/4/5","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"5","card":"¿En qué consiste el examen de ciudadanía? ","text":"<li> Es un examen que tienes que aprobar en el momento de hacer la entrevista de naturalización.</li> <li> De <a href= \"https://www.univision.com/noticias/inmigracion/examen-de-ciudadania?f=1\">las 100 preguntas del examen</a> para la ciudadanía, que se enfocan en la historia del país y el sistema de gobierno de Estados Unidos, el agente del servicio de inmigración que dirige la entrevista te hará hasta un máximo de 10 preguntas, de las cuales tendrás que responder y acertar seis.</li> <li> Si tienes más de 65 años de edad y más de 20 como residente legal permanente, el gobierno te dará una consideración especial y solo tendrás que estudiar 20 de las 100 preguntas. En este caso, también te harán 10 preguntas y tendrás que responder acertadamente seis.</li> ","url":"https://www.univision.com/test/el-examen-de-ciudadania","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/6","path":"/inmigracion/4/6","context":{"slug":"inmigracion/4/6","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"6","card":"¿Puedo presentar el examen de ciudadanía en español?","text":"<p>Algunas personas están exentas de tomar el examen de inglés, o incluso pueden tomar el examen en su lengua natal. Estas excepciones son para inmigrantes que:</p><li> Tienen 50 años de edad o más al momento de solicitar la ciudadanía y, además, han vivido como residentes permanentes en Estados Unidos por más de 20 años.</li> <li> Tienen 55 años o más al momento de solicitar la ciudadanía y, además, han vivido como residentes permanentes en Estados Unidos por más de 15 años.</li> ","url":"https://www.univision.com/test/el-examen-de-ciudadania-en-espanol","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/7","path":"/inmigracion/4/7","context":{"slug":"inmigracion/4/7","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"7","card":"¿Cuáles son los beneficios de hacerse ciudadano de Estados Unidos?","text":"<li> Votar y participar activamente en el sistema democrático. El derecho al voto solo pueden ejercerlo los ciudadanos.</li> <li> Solo los ciudadanos pueden ejercer un cargo electo gubernamental.</li> <li> Muchos trabajos y puestos con el gobierno están reservados para ciudadanos.</li> <li> El proceso para pedir a un familiar con una solicitud de inmigrante es mucho más fácil y expedito.</li> <li> Los agentes de inmigración no pueden negarle la entrada al país a un ciudadano de Estados Unidos.</li> <li> El gobierno no puede deportar a un ciudadano de EEUU.</li> <li> Un ciudadano se puede ir a vivir a otro país sin perder la nacionalidad estadounidense.</li> <li> Los ciudadanos de este país tienen pleno derecho a los beneficios gubernamentales, entre estos, la asistencia pública.</li> <li> Adicionalmente, todos los ciudadanos estadounidenses, independientemente de si lo son por nacimiento o por naturalización, están protegidos por el sistema completo de derechos garantizados por la Constitución.</li> ","url":"https://www.univision.com/test/los-beneficios-de-hacerse-ciudadano","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/4/8","path":"/inmigracion/4/8","context":{"slug":"inmigracion/4/8","node":{"idbaraja":"4","baraja":"¿Cómo me hago ciudadano de EEUU?","idcard":"8","card":"¿En qué situaciones no es aconsejable pedir la ciudadanía?","text":"<p>Existen situaciones que al ser evaluadas por el gobierno pueden ponerte en riesgo, y llevarte incluso a la deportación. O, en algunos casos, cuando te haces ciudadano estadounidense, puedes perder derechos en tu país natal.</p><li> Es importante que seas honesto al responder las preguntas de la solicitud de ciudadanía.</li> <li> Si has cometido algún delito, puede que la falta, aunque esta haya sido pagada, te ponga en proceso de deportación. Por ejemplo, si has violado alguna ley de inmigración o abandonaste tu residencia en algún momento, no debes aplicar para la ciudadanía. Pide a un consejero legal que revise tu expediente.</li> <li> Otra razón importante a tener en cuenta antes de pedir la ciudadanía es el hecho de que ciertos países limitan la propiedad a un ciudadano estadounidense.</li> <li> Hay ciertos países que no permiten la doble nacionalidad, lo cual significa que si te haces estadounidense, pierdes beneficios en tu país de origen. Consulta con la embajada o el consulado de tu país si permite la doble nacionalidad.</li> ","url":"https://www.univision.com/test/cuando-la-ciudadania-no-es-aconsejable","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/1","path":"/inmigracion/5/1","context":{"slug":"inmigracion/5/1","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"1","card":"¿Qué es un indocumentado?","text":"<li> Es una persona que ha entrado a Estados Unidos <b>sin autorización</b> o permanece en el país <b>después de que ha expirado la autorización</b> de su entrada y su permanencia concedida por el gobierno federal en un puerto de entrada.</li> ","url":"https://www.univision.com/test/los-indocumentados-en-estados-unidos","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/2","path":"/inmigracion/5/2","context":{"slug":"inmigracion/5/2","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"2","card":"¿Cuál es la posición del gobierno de Trump frente a los indocumentados?","text":"<li> Trump criminalizó la inmigración indocumentada (antes se considereaba una ofensa civil, no criminal) al decretar que “los inmigrantes que entran indocumentados sin inspección o admisión, o dejan vencer sus visas, representan una amenaza significativa para la seguridad nacional y pública”.</li> <li> Eso se materializó en la llamada “política de Tolerancia Cero’, que es la base de la política migratoria del gobierno.</li> ","url":"https://www.univision.com/test/el-gobierno-de-trump-y-los-indocumentados","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/3","path":"/inmigracion/5/3","context":{"slug":"inmigracion/5/3","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"3","card":"¿Cuál es el objetivo de la “política de Tolerancia Cero” del gobierno de Trump?","text":"<li> Frenar la entrada de indocumentados penalizando el ingreso, separando familias y construyendo un muro a lo largo de la frontera con México.</li> <li> Aumentar las redadas y deportaciones, en particular las deportaciones expeditas, con el fin de reducir la población indocumentada.</li> <li> Negar beneficios migratorios a los indocumentados.</li> ","url":"https://www.univision.com/test/los-objetivos-de-la-politica-de-tolerancia-cero","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/4","path":"/inmigracion/5/4","context":{"slug":"inmigracion/5/4","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"4","card":"¿El gobierno puede deportar a cualquier indocumentado?","text":"<li> Trump ordenó a la fiscalía general que tome medidas apropiadas “para establecer pautas de enjuiciamiento” y permitir que los jueces de inmigración concedan “alta prioridad a los enjuiciamientos de los delitos que tengan nexo con la frontera sur”.</li> <li> Es decir, todo indocumentado que haya ingresado por la frontera sur es una “prioridad de deportación”.</li> <li> El gobierno, además, amplió la lista de prioridades de deportación, poniendo a la gran mayoría de los 10.4 millones de indocumentados que hay en el país en el banquillo de las deportaciones.</li> ","url":"https://www.univision.com/test/los-indocumentados-y-la-deportacion","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/5","path":"/inmigracion/5/5","context":{"slug":"inmigracion/5/5","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"5","card":"¿Quiénes están en la lista de prioridades de deportación del gobierno de Trump?","text":"<li> Quienes hayan sido <b>condenados</b> por cualquier delito.</li> <li> Quienes hayan sido acusados de cualquier delito, cuando dicho cargo no haya sido resuelto.</li> <li> Quienes hayan cometido actos que constituyen un delito penal imputable.</li> <li> Quienes hayan incurrido en fraude o tergiversación deliberada en relación con cualquier asunto oficial o solicitud ante un organismo gubernamental.</li> <li> Quienes hayan abusado de cualquier programa relacionado con la recepción de beneficios públicos.</li> <li> Quienes estén sujetos a una orden final de expulsión, pero que no han cumplido con su obligación legal de abandonar Estados Unidos.</li> <li> Quienes a juicio de un funcionario de inmigración supongan un riesgo para la seguridad pública o la seguridad nacional.</li> ","url":"https://www.univision.com/test/las-prioridades-de-deportacion-del-gobierno-de-trump","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/6","path":"/inmigracion/5/6","context":{"slug":"inmigracion/5/6","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"6","card":"¿Además de las deportaciones y el aumento del control en la frontera, qué medidas ha tomado el gobierno de Trump en contra de los indocumentados?","text":"<li> Anuló el asilo por violencia doméstica y de pandillas.</li> <li> Otorgó mayor discrecionalidad a los agentes de inmigración para negar beneficios.</li>  <li> Reabrió unos 350,000 casos de deportación cerrados administrativamente.</li> <li> Exigió a los tribunales de inmigración cancelar cualquier tipo de beneficio que entorpezca o distraiga la deportación de un extranjero.</li> <li> Ordenó revisar mas de 315,000 naturalizaciones por sospecha de fraude en base al dictamen de un solo caso.</li> <li> Eliminó programas humanitarios como DACA y TPS, que por ahora están vigentes por orden de los tribunales de justicia.</li> <li> Pidió eliminar leyes y acuerdos judiciales que protegen a menores de edad de tráfico humano o privación de libertad (Ley PVTRA de 2008 y el Acuerdo Judicial Flores).</li> <li> Aumentó los requisitos para conceder visas.</li> ","url":"https://www.univision.com/test/medidas-del-gobierno-de-trump-contra-los-indocumentados","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/5/7","path":"/inmigracion/5/7","context":{"slug":"inmigracion/5/7","node":{"idbaraja":"5","baraja":"¿Cuál es la política de Estados Unidos hacia los indocumentados?","idcard":"7","card":"Si me deportan, ¿puedo volver a Estados Unidos y arreglar mi estatus migratorio?","text":"<li> La sección 212 de la Ley de Inmigración (INA) establece que las personas que permanecen sin autorización en Estados Unidos por más de 180 días y menos de 365 pueden arreglar su estatus migratorio solo mediante una permanencia fuera del país (sin regresar) por un período de tres años. Transcurrido ese tiempo, pueden tramitar una visa.</li> <li> Si la permanencia no autorizada sobrepasa los 365 días, la sanción aumenta a 10 años. Es lo que llaman la <b>“ley del castigo”</b>.</li> <li> En el caso de una persona que entra sin inspección al país, el reloj comienza a marcar el tiempo a partir del día que entra al territorio estadounidense.</li> ","url":"https://www.univision.com/test/consecuencias-de-la-deportacion","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/6/1","path":"/inmigracion/6/1","context":{"slug":"inmigracion/6/1","node":{"idbaraja":"6","baraja":"¿Qué debo hacer si me veo envuelto en una redada migratoria?","idcard":"1","card":"¿Cómo debo prepararme para una posible redada?","text":"<p>Las órdenes ejecutivas migratorias del presidente Donald Trump han puesto al borde de la deportación a los 11 millones de inmigrantes indocumentados que viven en Estados Unidos.</p><p>Si tu eres uno de ellos, esto es lo que te recomiendan los grupos de derechos civiles y organizaciones de apoyo al inmigrante:</p><li> <b>Selecciona a una persona</b> a la que llamarás por teléfono en caso que seas arrestado durante una redada.  <li> Déjale una <b>carta-poder</b> para que tome decisiones en tu ausencia sobre tus hijos y bienes.<li> Si tienes hijos en edad escolar, comunícate con la escuela y <b>registra el nombre de esa persona</b> para que pueda retirarlos del establecimiento.<li> Trata de que la persona que te ayude no se encuentre indocumentada. Y si no tiene documentos de estadía legal, que no tenga contactos con el servicio de inmigración.","url":"https://www.univision.com/test/preparacion-para-el-caso-de-una-redada","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/6/2","path":"/inmigracion/6/2","context":{"slug":"inmigracion/6/2","node":{"idbaraja":"6","baraja":"¿Qué debo hacer si me veo envuelto en una redada migratoria?","idcard":"2","card":"¿Qué hago si me detienen en una redada?","text":"<p>En caso de una redada en tu comunidad:</p><li> No pierdas la calma, recuerda que tienes derechos en Estados Unidos.</li> <li> Pide <b>hablar con un abogado</b>.</li> <li> No firmes nada hasta que no hables con un abogado.</li> <li> <b>No presentes ni uses documentos falsos</b> de identidad tales como licencia de manejar o número de seguro social. Es un delito grave (felonía) en Estados Unidos.</li> <li> Si usas o entregas información falsa, te levantarán cargos penales. Y si te levantan cargos por usar documentos falsos automáticamente pierde tus derechos de permanencia en el país.</li></br> <p> Si te detienen, tienes derecho a hacer <b>una llamada telefónica</b> en un plazo por lo general de 24 horas.</p>","url":"https://www.univision.com/test/acciones-en-caso-de-una-redada","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/6/3","path":"/inmigracion/6/3","context":{"slug":"inmigracion/6/3","node":{"idbaraja":"6","baraja":"¿Qué debo hacer si me veo envuelto en una redada migratoria?","idcard":"3","card":"¿A quién debo llamar si me detienen en una redada?","text":"<p>Si te detienen, tienes derecho a hacer una llamada telefónica en un plazo por lo general de 24 horas.</p><p>La persona que reciba la llamada puede ser el abogado, un familiar o un amigo (a quien previamente has acordado llamar en caso de ser detenido). Cuando hables con él o ella:</p><li> Dile dónde estás.</li> <li> Pídele que ponga en marcha el plan que acordaron.</li><li> Si no llamaste a tu abogado, asegurate que esa persona llama a tu abogado para que acuda al centro de detención.</li><li> Si no tienes abogado, contacta con uno. <a href=\"https://www.univision.com/noticias/inmigracion/buscador-de-asesoria-legal-para-inmigrantes\">Puedes buscar ayuda legal en esta herramienta de Univision Noticias</a>.</li><li> Pídele que llame al consulado de tu país y que dé los datos de tu detención.</li><li> Puedes pedirle que llame a una organización de ayuda a inmigrantes para solicitar ayuda.</li>","url":"https://www.univision.com/test/contactos-en-caso-de-una-redada","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /inmigracion/6/4","path":"/inmigracion/6/4","context":{"slug":"inmigracion/6/4","node":{"idbaraja":"6","baraja":"¿Qué debo hacer si me veo envuelto en una redada migratoria?","idcard":"4","card":"¿Qué debo hacer si me detienen en una redada en el sitio de trabajo?","text":"<p>Si la redada es en tu trabajo:</p><li> No olvides que tienes derechos.</li><li> No huyas. Mantén la calma.</li><li> Si los agentes buscan a otra persona, es posible que tú puedas abandonar el área del operativo. Hazlo con calma.</li><li> Si no te dejan salir, no contestes ninguna pregunta que te formulen los agentes.</li><li> Tampoco les digas dónde naciste ni cómo entraste a Estados Unidos.</li><li> No firmes nada, ningún documento que te presenten. Pídeles hablar con un abogado, es tu derecho.</li><li> Pero sobre todo, nunca brindes información falsa, y tampoco uses papeles falsos.</li>","url":"https://www.univision.com/test/las-redadas-en-el-sitio-de-trabajo","sheet":"Inmigración"}}}},{"node":{"id":"SitePage /desastres-naturales/1/1","path":"/desastres-naturales/1/1","context":{"slug":"desastres-naturales/1/1","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"1","card":"¿Qué es un huracán?","text":"<p>Los huracanes son sistemas de tormentas de <b>proporciones masivas</b> que se forman sobre el agua y hacen entrada en tierra. </p><p>Las amenazas de los huracanes incluyen:</p><li>Vientos fuertes</li><li>Lluvias torrenciales</li><li>Marejadas ciclónicas</li><li>Inundaciones en zonas costeras e interiores</li><li>Corrientes de resaca</li><li>Tornados</li><p>A estas tormentas grandes se les llama <b>tifones</b> en el Océano Pacífico Norte y <b>ciclones</b> en otras partes del mundo.</p>","url":"https://www.univision.com/noticias/fenomenos-naturales/huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/2","path":"/desastres-naturales/1/2","context":{"slug":"desastres-naturales/1/2","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"2","card":"¿Cuándo es la temporada de huracanes?","text":"<p>La temporada de huracanes del Atlántico va desde el <b>1 de junio hasta el 30 de noviembre.</b></p><p>Su <b>punto máximo</b> ocurre entre mediados de <b>agosto</b> y finales de <b>octubre</b>.</p><p>La temporada de huracanes del Pacífico Oriental comienza el <b>15 de mayo y finaliza el 30 de noviembre.</b></p>","url":"https://www.univision.com/test/la-temporada-de-huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/3","path":"/desastres-naturales/1/3","context":{"slug":"desastres-naturales/1/3","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"3","card":"¿Qué zonas se ven afectadas por huracanes?","text":"<p>Las zonas afectadas incluyen todas las <b>zonas costeras del Atlántico y Caribe</b>, sobre todo:</p><ul><li>Florida</li><li>Puerto Rico</li><li>Georgia</li><li>Carolina del Sur</li><li>Carolina del Norte</li><li>Lousiana</li><li>Mississippi</li><li>Texas</li><li>Alabama</li></ul><p>Aunque en <b>menor intensidad y frecuencia</b>, también se pueden ver afectados:</p><ul><li>Connecticut</li><li>Delaware</li><li>Maine</li><li>Maryland</li><li>Massachusetts</li><li>New Hampshire</li><li>Nueva Jersey</li><li>Nueva York</li><li>Pennsylvania</li><li>Rhode Island</li><li>Virginia</li></ul><p>Así como en el <b>Pacífico</b>:</p><ul><li>Islas Vírgenes</li><li>Hawaii</li><li>Guam</li></ul>","url":"https://www.univision.com/test/las-zonas-afectadas-por-los-huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/4","path":"/desastres-naturales/1/4","context":{"slug":"desastres-naturales/1/4","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"4","card":"¿Cuándo se convierte una tormenta tropical en huracán?","text":"<p>Una tormenta tropical se convierte en un huracán cuando se forma <b>un ojo</b> en el centro de la tormenta y esta <b>empieza a girar</b> alrededor del ojo. </p><p>Se forman anchas <b>bandas de lluvia</b> que alcanzan al menos <b>74 mph</b> o 119 kmh y que contienen tormentas y hasta tornados. </p><p>En este punto, el sistema ya es capaz de causar <b>daños significativos</b>.</p>","url":"https://www.univision.com/test/tormentas-tropicales-y-huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/5","path":"/desastres-naturales/1/5","context":{"slug":"desastres-naturales/1/5","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"5","card":"¿Qué es una advertencia de huracán?","text":"<p>El Servicio del Clima Nacional, o <i>National Weather Service</i> (NWS) emite una advertencia de huracán para una zona cuando las condiciones climáticas de un huracán se esperan en un lapso de <b>36 horas. </b></p><p> Cuando se emita una advertencia, <b>termina</b> tus preparaciones y <b>abandona inmediatamente la zona en peligro</b> si así lo indican los funcionarios locales.<br></p>","url":"https://www.univision.com/test/advertencia-de-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/6","path":"/desastres-naturales/1/6","context":{"slug":"desastres-naturales/1/6","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"6","card":"¿Qué es una advertencia de tormenta tropical?","text":"<p>El Servicio del Clima Nacional, o <i>National Weather Service</i> (NWS) emite una <b>advertencia de tormenta tropical</b> para una zona cuando las condiciones climáticas de una tormenta tropical (<b>vientos entre 39-73 mph</b> o 62-117 kph, entre otros) se esperan en un lapso de <b>36 horas. </b></p><p>Durante una advertencia, termina tus preparaciones y <b>abandona inmediatamente la zona en peligro</b> si así lo indican los funcionarios locales.</p>","url":"https://www.univision.com/test/advertencia-de-tormenta-tropical","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/7","path":"/desastres-naturales/1/7","context":{"slug":"desastres-naturales/1/7","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"7","card":"¿Qué es una alerta de huracán?","text":"<p>El Servicio Nacional del Clima (NWS) emite una alerta de huracán para una zona <b>48 horas antes </b>del momento en que se espera que se materialicen las condiciones de huracán (<b>vientos de 74 mph o 119 kph o más, lluvia, truenos, rayos, tormentas, inundaciones</b>). </p><p>Durante una alerta, sintoniza <b>la radio del tiempo de NOAA</b>, la Administración Nacional Oceánica y Atmosférica, la <b>radio</b> local o las estaciones de <b>televisión</b> para obtener información y prepararte.<br></p>","url":"https://www.univision.com/test/alerta-de-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/8","path":"/desastres-naturales/1/8","context":{"slug":"desastres-naturales/1/8","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"8","card":"¿Qué es una alerta de tormenta tropical?","text":"<p>El Servicio Nacional del Clima (NWS) emite una alerta de tormenta tropical para una zona <b>48 horas</b> antes del momento en que se espera que se materialicen las condiciones de la tormenta tropical (<b>vientos entre 39-73 mph</b> o 62-117 kph, entre otros) .</p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Durante una alerta, sintoniza </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">la radio del tiempo de NOAA</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">, la Administración Nacional Oceánica y Atmosférica, la </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">radio</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> local o las estaciones de </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">televisión</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> para obtener información y prepararte.</span></p>","url":"https://www.univision.com/test/alerta-de-tormenta-tropical","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/9","path":"/desastres-naturales/1/9","context":{"slug":"desastres-naturales/1/9","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"9","card":"¿Cómo funciona la escala de ranking de huracanes?","text":"<p>La escala de huracanes de <b>Saffir-Simpson </b>(<i>Simpson Hurricane Wind Scale</i>) clasifica los huracanes en cinco categorías según:</p><p><ul><li>La velocidad del viento</li><li>La presión central</li><li>El daño potencial del viento</li></ul></p>","url":"https://www.univision.com/test/la-escala-para-medir-la-categoria-los-huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/10","path":"/desastres-naturales/1/10","context":{"slug":"desastres-naturales/1/10","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"10","card":"¿Qué es un huracán Categoría 1?","text":"<li>Vientos de 74 - 95 mph (119 - 153 kmh).</li><li>Vientos muy peligrosos que producen algunos daños en los techos, las tejas, paredes y canaletas.</li><li>Las ramas de los árboles se rompen y los árboles poco arraigados se pueden cae.r</li><li>El daño extenso a las líneas eléctricas y los postes probablemente resulta en cortes de energía que podrían durar de pocos a varios días.</li>","url":"https://www.univision.com/test/huracan-categoria-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/11","path":"/desastres-naturales/1/11","context":{"slug":"desastres-naturales/1/11","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"11","card":"¿Qué es un huracán Categoría 2?","text":"<li>Vientos de <b>96 - 110 mph </b>(154 - 177 kmh)</li><li>Vientos extremadamente peligrosos causan <b>daños extensos</b>: Las viviendas pueden sufrir daños importantes en <b>techos</b> y <b>paredes</b>. </li><li>Muchos árboles poco arraigados son <b>arrancados</b> y <b>bloquean</b> numerosas carreteras. </li><li>Pérdida de <b>energía</b>.</li>","url":"https://www.univision.com/test/huracan-categoria-2","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/12","path":"/desastres-naturales/1/12","context":{"slug":"desastres-naturales/1/12","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"12","card":"¿Qué es un huracán Categoría 3?","text":"<p><ul><li><b>111 - 129 mph</b> (178 - 208 kmh)</li><li>Daños <b>devastadores</b>: Las viviendas pueden sufrir daños <b>mayores</b> o en destrucción de los techos. </li><li>Muchos árboles se parten o son arrancados de raíz y <b>bloquean numerosas carreteras</b>. </li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Pérdida de </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">electricidad y agua.</b></li></ul></p>","url":"https://www.univision.com/test/huracan-categoria-3","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/13","path":"/desastres-naturales/1/13","context":{"slug":"desastres-naturales/1/13","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"13","card":"¿Qué es un huracán Categoría 4?","text":"<li><b>130 - 156 mph</b> (209-251 kmh)</li><li>Daños <b>catastróficos</b>: Las viviendas pueden sufrir daños <b>severos</b>.</li><li>Queda destruída <b>la mayor parte </b>del techo o algunas paredes exteriores. </li><li>La <b>mayoría</b> de los árboles se <b>parten</b> o son <b>arrancados de raíz </b>y los postes de energía son derribados y <b>bloquean las carreteras</b>, <b>aislando las áreas residenciales.</b> </li><li>La mayor parte del área puede ser inhabitable por <b>semanas o meses.</b></li>","url":"https://www.univision.com/test/huracan-categoria-4","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/14","path":"/desastres-naturales/1/14","context":{"slug":"desastres-naturales/1/14","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"14","card":"¿Qué es un huracán Categoría 5?","text":"<li>157 mph o más (252 kmh o más)</li><li><b>Daños catastróficos: </b>La mayoría de viviendas muy probablemente sufren daños severos.</li><li>Alto porcentaje de <b>viviendas destruidas</b>. </li><li>Fallas totales a los techos y <b>colapsan</b> muchas paredes. </li><li>La <b>mayoría</b> de los árboles se parten o son <b>arrancados</b> de raíz y los postes de energía son <b>derribados</b> y bloquean las carreteras, <b>aislando las áreas residenciales</b>. </li><li>Los <b>cortes</b> de energía son más extensos. </li><li>La mayor parte del área será <b>inhabitable</b> por semanas o meses.</li>","url":"https://www.univision.com/test/huracan-categoria-5","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/15","path":"/desastres-naturales/1/15","context":{"slug":"desastres-naturales/1/15","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"15","card":"¿Que puedo hacer antes de un huracán para prepararme?","text":"<li>Determina las rutas de <b>evacuación </b>consultando tus autoridades locales y a nivel de condado. Ten un mapa de ellas a la mano en la casa y el trabajo.</li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Identifica los lugares oficiales de <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">refugio<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> (pueden ser escuelas públicas, hospitales, bibliotecas, estadios, etc).</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Revisa tu equipo de <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">emergencia<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">, como linternas, generadores y equipo operado por baterías, como teléfonos <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">celulares<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> y radios.</spanroboto></broboto></spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Compra comida <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">no perecedera<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> y agua potable.</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Llena la <b>bañera y la lavadora</b> con agua para lavar platos y ropa cuando el agua se vaya.</spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Compra <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">paneles de madera<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> u otro material resistente para proteger tu casa y sobre todo las <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">ventanas<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">.</spanroboto></broboto></spanroboto></broboto></spanroboto></li> <li><broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Poda<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> los árboles y arbustos para que las ramas no vuelen hacia las casas y hagan daños.</spanroboto></broboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Limpia los <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">canales<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> de lluvia y desagües.</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Revisa tu <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">póliza de seguro<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> con tiempo para que puedas llamar a hacer preguntas.</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Si tienes <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">mascotas<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">, busca hoteles que las acepten en tu ruta de evacuación.</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Asegúrate de que las <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">ventanas<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> estén <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">aseguradas<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> y todos los <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">utensilios de cocina<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> o adornos que podrían suponer un riesgo de seguridad estén <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">asegurados<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> o guardados en cajas.</spanroboto></broboto></spanroboto></broboto></spanroboto></broboto></spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Prepara un <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">kit de supervivencia <spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">básico.</spanroboto></broboto></spanroboto></li> <li><broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Mete a tu casa <spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">todas las cosas que estén en el patio o los alrededores y que puedan <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">salir volando<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> durante la tormenta, como bicicletas, sillas, escombros, etc.</spanroboto></broboto></spanroboto></broboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Intenta mantener el <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">tanque de gasolina<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> de tu vehículo lleno para poder evacuar si es necesario.</spanroboto></broboto></spanroboto></li> <li><spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Configura tu refrigerador en la temperatura <broboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">más fría<spanroboto slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> para que tus alimentos soporten el apagón que se avecina.</spanroboto></broboto></spanroboto></li>","url":"https://www.univision.com/test/preparacion-para-un-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/16","path":"/desastres-naturales/1/16","context":{"slug":"desastres-naturales/1/16","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"16","card":"¿Qué debo empacar en un kit de supervivencia?","text":"<li>Asegúrate de que la caja que contiene el kit o botiquín mismo sea <b>impermeable e inflamable</b>. </li><li><b>Agua</b>: Un galón por día por persona o mascota. Calcula para<b> 3 días. </b></li><li><b>Comida</b>: Compra alimentos que no necesiten refrigerarse, como <b>enlatados</b>. </li><li><b>Linternas</b>: Guarda una por persona y compra <b>baterías extra</b>. </li><li><b>Celulares</b>: Cárgalo al 100% todo lo que puedas y ten un <b>cargador inalámbrico</b> extra. </li><li><b>Dinero</b>: Ten <b>efectivo</b> a la mano para cuando no haya luz. </li><li><b>Radio</b>: Asegúrate que funcione con <b>baterías</b>. </li><li><b>Medicinas</b>: Guarda suministros para <b>7 días. </b></li><li><b>Documentos</b>: Saca <b>fotocopias</b> y guarda los originales en bolsas<b> plásticas sellables. </b></li><li><b>Kit de primeros auxilios: </b>Asegúrate que tenga todo lo necesario. Lee la siguiente tarjeta para saber qué debe tener un botiquín completo. </li>","url":"https://www.univision.com/test/el-kit-de-supervivencia","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/17","path":"/desastres-naturales/1/17","context":{"slug":"desastres-naturales/1/17","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"17","card":"¿Qué debe incluir un botiquín de primeros auxilios?","text":"<p>Asegúrate de que la caja que contiene el kit o botiquín mismo sea impermeable e inflamable. <br><ul><li>Un manual de <b>primeros auxilios</b> actualizado</li><li>Una lista de <b>números telefónicos de emergencia, </b>tanto de las autoridades como de familiares y conocidos.</li><li>Almohadillas de <b>gasa</b> estériles de diferentes tamaños</li><li><b>Cinta</b> adhesiva médica</li><li><b>Curas</b> (Band-Aids) de varios tamaños</li><li>Una <b>banda</b> elástica</li><li>Una <b>férula</b></li><li>Toallitas antisépticas</li><li>Jabón</li><li>Ungüento <b>antibiótico</b></li><li>Solución antiséptica (como el agua oxigenada, o <i>hydrogen peroxide</i> en inglés)</li><li>Crema de hidrocortisona (1%)</li><li>Paracetamol e ibuprofeno</li><li><b>Medicamentos</b> recetados adicionales</li><li>Pinzas</li><li>Tijeras afiladas</li><li>Ganchos de seguridad</li><li><b>Compresas</b> desechables instantáneas</li><li>Toallitas con alcohol o alcohol etílico</li><li>Termómetro</li><li><b>Guantes</b> de plástico sin látex (al menos 2 pares)</li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Una manta</span></li></ul></p>","url":"https://www.univision.com/test/el-botiquin-de-primeros-auxilios","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/18","path":"/desastres-naturales/1/18","context":{"slug":"desastres-naturales/1/18","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"18","card":"¿Cómo sé si debo evacuar?","text":"<p>Debes consultar periódicamente con tus <b>autoridades</b> locales. </p><p>Ellos tendrán mapas e información actualizada de qué zonas deben <b>evacuar inmediatamente</b>, cuáles están en <b>riesgo</b> y cuáles se encuentran a <b>salvo</b>. </p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">También proveerán las </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">rutas</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> seguras de evacuación.</span></p>","url":"https://www.univision.com/test/evacuacion-en-caso-de-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/19","path":"/desastres-naturales/1/19","context":{"slug":"desastres-naturales/1/19","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"19","card":"¿Qué debo hacer si los semáforos no funcionan desúés de un huracán?","text":"<li>Si las luces de señalización no funcionan para nada (se cayeron o salieron volando), debes hacer una <b>parada de 4 vías. </b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si hay luz roja intermitente se debe tratar como un </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">'Pare' o <i>Stop.</i></b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si hay luz amarilla intermitente debes </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">seguir</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> con precaución. </span></li>","url":"https://www.univision.com/test/conducir-sin-semaforos-despues-de-un-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/20","path":"/desastres-naturales/1/20","context":{"slug":"desastres-naturales/1/20","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"20","card":"¿Qué debo hacer con los aparatos electrónicos después de un huracán?","text":"<li><b>No enciendas </b>los generadores eléctricos después del huracán en zonas que estén <b>inundadas</b>.</li><li><b>Desconecta</b> todos los equipos eléctricos que no necesites. </li><li>Evita pasar (a pie, bicicleta, carro) por aguas <b>estancadas</b> ya que podría haber <b>cables con electricidad sueltos</b>. </li>","url":"https://www.univision.com/test/los-aparatos-electronicos-despues-del-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/21","path":"/desastres-naturales/1/21","context":{"slug":"desastres-naturales/1/21","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"21","card":"¿Qué hago si mi casa se inunda con un huracán?","text":"<li>Ponte <b>botas</b> o zapatos (ojalá impermeables). No andes <b>descalzo</b>. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Desconecta</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> todos los aparatos electrónicos antes de que el agua alcance el nivel de los </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">enchufes</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> o interruptores. Si crees que eso va a suceder, lo mejor es <b>apagar</b> la electricidad completamente en tu casa. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Pon los objetos más importantes y tus documentos personales en bolsas impermeables la parte </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">más alta de la casa. </b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Mantén las puertas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">cerradas</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">. </span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">No bebas agua de la tubería </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">a menos de que los equipos de socorro indiquen que es seguro tomarla y no está contaminada. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asigna un lugar donde la familia pueda hacer sus necesidades en caso de que </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">los inodoros no funcionen. </b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Ve al punto </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">más alto de la casa.</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> Si tienes </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">ático</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> resguárdate ahí. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asegúrate de tener un </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">hacha</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> u objeto con el que puedas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">romper el techo </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">en caso de que las aguas te alcancen. Así los equipos de socorro te pueden </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">rescatar</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> cuando los esperes desde el techo. </span></li>","url":"https://www.univision.com/test/las-inundaciones-despues-del-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/22","path":"/desastres-naturales/1/22","context":{"slug":"desastres-naturales/1/22","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"22","card":"¿Qué debo llevar a un refugio?","text":"<li><b>Medicamentos</b> y prescripciones (recetas) médicas. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Papeles</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> importantes en bolsas plásticas <b>impermeables</b>. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Lleva tu comida si tienes una dieta especial.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si tienes bebés lleva </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">pañales</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">, </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">medicamentos</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> y comida para bebés. </span></li><li>Varias mudas de <b>ropa</b>. </li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si tienes, puedes llevar: </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">mantas, colchón inflable</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">, bolsas para dormir o almohadas. Estos artículos pueden ser escasos en los refugios. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Juegos de mesa o cartas. </span></li>","url":"https://www.univision.com/test/los-refugios-contra-huracanes","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/23","path":"/desastres-naturales/1/23","context":{"slug":"desastres-naturales/1/23","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"23","card":"¿Qué hago si me quedo atrapado en un carro que está flotando en una inundación?","text":"<li>Mantén la <b>calma</b>. Aunque es difícil, es vital no desesperarse para <b>no gastar energía</b>, poder <b>pensar bien </b>y encontrar la <b>solución</b> que te mantenga a salvo. </li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Desabrocha tu </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">cinturón</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Baja las ventanas para</span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> salir y nadar.</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> Si el agua ya cubrió las ventanas pero no estás completamente sumergido por dentro, las ventanas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">no se abrirán</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> por la presión desigual. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">En ese caso, tienes que esperar a que </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">el agua llene el carro </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">completamente. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Entonces, </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">toma aire </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">y cuando esté lleno de agua el carro abre la ventana o rómpela con un objeto </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">afilado</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> para poder salir nadando. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si no tienes un objeto, puedes sacar <b>el reposacabezas (</b></span><i style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"><b>headrest) </b></i><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">de su posición y usar las puntas para pegarle con fuerza al vidrio y romperlo.</span></li>","url":"https://www.univision.com/test/atrapado-en-mi-carro-despues-de-un-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/24","path":"/desastres-naturales/1/24","context":{"slug":"desastres-naturales/1/24","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"24","card":"¿Qué debo hacer durante un huracán?","text":"<li><b>Resguárdate</b> antes de que lleguen los vientos más agresivos. </li><li>En casa, mantente siempre <b>lejos de las ventanas. </b></li><li>Mantén las cortinas o persianas completamente <b>cerradas</b> (en caso de romperse un vidrio te <b>protegerán</b> de los restos que salen <b>volando</b>, al menos en primera instancia).</li><li>Enciérrate en una habitación segura (<b>baño, dormitorio, incluso un armario</b>) con el <b>agua</b> suficiente para no tener que salir de ella mientras pasa lo peor.</li><li><b>Desconecta</b> todos los electrodomésticos para evitar que se dañen y que ocasionen un <b>cortocircuito</b>. Si la lluvia es demasiado fuerte o hay riesgo de <b>inundación</b> lo mejor es dejar sin energía eléctrica a toda la casa desde la <b>fusilera</b>.</li><li><b>NO salgas de la casa. </b>Durante el paso de los vientos más fuertes habrán <b>escombros volando</b> y pueden golpear, derribar o cortar a quien se asome.</li><li><b>Muy importante: </b>Durante la tormenta habrá un <b>breve período de calma</b> que puede hacer parecer como que ya acabado, pero ese en realidad es <b>el centro de la tormenta</b>. Una vez llegue el otro lado, <b>se acabará la calma</b> y regresará el viento. </li><li><b>No salgas</b> de casa hasta que <b>las autoridades anuncien</b> que es seguro.</li>","url":"https://www.univision.com/test/que-hacer-durante-el-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/25","path":"/desastres-naturales/1/25","context":{"slug":"desastres-naturales/1/25","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"25","card":"¿Qué debo hacer después de un huracán?","text":"<p><ul><li>Una vez pase el ciclón, el peligro no habrá terminado. </li><li>Este momento puede ser incluso <b>peor</b> debido a que las calles son un <b>caos</b>, pueden haber <b>derrumbes</b> y cableados eléctricos cortados que pueden <b>electrocutar</b> a un transeúnte. </li><li><b>No salgas</b> de casa hasta que las autoridades anuncien que el peligro ha pasado.</li><li><b>No uses teléfonos ni celulares</b> a menos que sea una <b>emergencia</b>. Es ideal mantener las líneas telefónicas sin colapsar para que las autoridades puedan hacer su trabajo y atender heridos o llamadas de emergencia.</li><li>Al salir de casa (después de la orden oficial de las autoridades) <b>no toques ningún tipo de cable</b> y aléjate lo más posible de los postes de la calle. Muchos están defectuosos y pueden electrocutar a quien los toque.</li><li>Mantente <b>alejado de árboles</b> o estructuras que parezcan inestables.</li><li><b>No tomes agua del grifo</b> ni la uses para cocinar hasta que las autoridades anuncien que es seguro.</li></ul></p>","url":"https://www.univision.com/test/que-hacer-despues-del-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/26","path":"/desastres-naturales/1/26","context":{"slug":"desastres-naturales/1/26","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"26","card":"¿Qué hago si estoy bajo una zona de advertencia de huracán?","text":"<p><ul><li>Escucha frecuentemente la <b>radio</b>, TV o la Radio de '<i>NOAA All Hazards</i>' para <b>boletines oficiales</b> sobre el trayecto de la tormenta. <a href=\"https://www.nws.noaa.gov/nwr/coverage/station_listing.html\">Aquí puedes buscar la estación de NOAA de tu área.</a></li><li>Llena el <b>tanque</b> de gasolina e inspecciona tu vehículo.</li><li>Si vives en una casa móvil, inspecciónala y asegúrate de que esté bien<b> anclada al suelo</b>, pero <b>no te quedes</b> en ella.</li><li>Sigue las instrucciones de las <b>autoridades </b>oficiales. <b>Evacúa</b> inmediatamente si se te ordena.</li><li>Quédate con amigos o familiares en un hotel de planta baja <b>lejos de la costa</b> o en un refugio público designado, que esté<b> fuera de la zona inundable</b>.</li><li>Notifica a tus vecinos o familiares que vivan fuera de la zona bajo aviso de tus <b>planes de evacuación</b>.</li><li>Lleva a tus mascotas contigo, pero recuerda que <b>la mayoría de los centros de refugio no permiten mascotas</b> que no sean de asistencia para personas con impedimentos (<i>service pets)</i>. </li></ul></p>","url":"https://www.univision.com/test/que-hago-si-estoy-bajo-una-zona-de-advertencia-de-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/1/27","path":"/desastres-naturales/1/27","context":{"slug":"desastres-naturales/1/27","node":{"idbaraja":"1","baraja":"¿Cómo me preparo para un huracán?","idcard":"27","card":"¿Debo evacuar si viene un huracán?","text":"<p>Siempre debes revisar con tus <b>autoridades locales </b>para conseguir la información más <b>actualizada</b>, pero en general debes evacuar si:</p><p><ul><li>Vives en una <b>casa móvil</b>. Estas casas no son seguras cuando se presentan vientos fuertes, no importa si están bien atadas al suelo.</li><li>Vives en <b>la costa</b>, en una <b>isla</b> cerca de la costa, cerca de un <b>río</b> o de un área llana <b>inundable</b>.</li><li>Vives en lo <b>alto de un edificio</b>. Los vientos de huracán son más fuertes y peligrosos a mayor altura. </li></ul></p>","url":"https://www.univision.com/test/evacuar-si-viene-un-huracan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/1","path":"/desastres-naturales/2/1","context":{"slug":"desastres-naturales/2/1","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"1","card":"¿Que puedo hacer antes de una inundación para prepararme?","text":"<p>Algunas veces las inundaciones se desarrollan <b>lentamente</b> y los pronosticadores pueden anticipar dónde ocurrirán <b>días o semanas</b> antes de que ocurran. </p><p>Pero a menudo, las inundaciones <b>repentinas</b> (<i>flash floods</i>) pueden ocurrir en cuestión de <b>minutos</b> y, a veces, <b>sin ningún signo de lluvia. </b></p><p>Estar preparado puede salvar tu vida y darte paz mental.</p><p>Estos son los pasos a seguir antes de una inundación:</p><li>Crea un plan de comunicaciones con tu familia </li><li>Arma un kit de emergencia</li><li>Investiga cuál es tu grado de riesgo</li><li>Suscríbete para recibir notificaciones del gobierno</li><li>Prepara tu casa</li><li>Prepara a tu familia / mascotas</li><li>Carga tus dispositivos electrónicos esenciales (celular, iPads, etc).</li><li>Evacúa: vete de tu hogar</li></br><p>En las siguientes tarjetas te explicaremos cada uno de estos pasos.</p>","url":"https://www.univision.com/test/que-hacer-antes-de-una-inundacion-para-prepararme","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/2","path":"/desastres-naturales/2/2","context":{"slug":"desastres-naturales/2/2","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"2","card":"¿Cómo armo un plan de comunicaciones con mi familia para un desastre natural?","text":"<p>Es importante poder comunicarte con tu <b>familia y amigos</b> en caso de un desastre. <br></p><p>Ya sea que haya una persona específica identificada para contactar para recibir <b>actualizaciones</b> de cómo están todos o un <b>lugar seguro</b> para reunirse con los miembros de la familia. <br><ul><li>Ten una <b>lista de teléfonos</b> de la familia y amigos cercanos con nombres <b>completos</b>. </li><li>Dale una copia de la lista a <b>cada uno </b>de los miembros de la familia. </li><li>Ten una copia <b>plastificada</b> en un sitio seguro en la casa donde no se pueda <b>mojar</b> o <b>dañar</b> fácilmente.</li></ul></p>","url":"https://www.univision.com/test/armar-un-plan-de-comunicaciones-con-mi-familia-para-un-desastre-natural","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/3","path":"/desastres-naturales/2/3","context":{"slug":"desastres-naturales/2/3","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"3","card":"¿Qué debo empacar en un kit de supervivencia?","text":"<p><ul><li>Asegúrate de que la caja que contiene el kit o botiquín mismo sea <b>impermeable e inflamable</b>. </li><li><b>Agua</b>: Un galón por día por persona o mascota. Calcula para <b>3 días. </b></li><li><b>Comida</b>: Compra alimentos que no necesiten refrigerarse, como <b>enlatados</b>. </li><li><b>Linternas</b>: Guarda una por persona y compra<b> baterías extra. </b></li><li><b>Celulares</b>: Cárgalo al 100% todo lo que puedas y ten un cargador inalámbrico extra. </li><li><b>Dinero</b>: Ten <b>efectivo</b> a la mano para cuando no haya luz. </li><li><b>Radio</b>: Asegúrate que funcione con <b>baterías</b>. </li><li><b>Medicinas</b>: Guarda suministros para<b> 7 días. </b></li><li><b>Documentos</b>: Saca fotocopias y guarda los originales en bolsas <b>plásticas sellables. </b></li><li><b>Kit de primeros auxilios: </b>Asegúrate que tenga todo lo necesario. Lee la siguiente tarjeta para saber qué debe tener un<b> botiquín completo. </b></li></ul></p>","url":"https://www.univision.com/test/que-empacar-en-un-kit-de-supervivencia","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/4","path":"/desastres-naturales/2/4","context":{"slug":"desastres-naturales/2/4","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"4","card":"¿Cómo sé cuál es mi grado de riesgo?","text":"<p>Estas son las preguntas que te debes hacer con anticipación. Saberlas a tiempo puede salvar tu vida:</p><p><ul><li>¿Tu casa, negocio o escuela están en una llanura de inundación (<i>flood plain</i>)? Si no sabes, pregúntale al dueño de tu propiedad. </li><li>¿Dónde es probable que se acumule agua en las carreteras por las que viajas con mayor frecuencia? </li><li>¿Cuál es la manera más rápida de llegar a un terreno más alto? </li></ul></p>","url":"https://www.univision.com/test/como-saber-cual-es-mi-grado-de-riesgo","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/5","path":"/desastres-naturales/2/5","context":{"slug":"desastres-naturales/2/5","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"5","card":"¿Cómo me suscribo para recibir notificaciones del gobierno?","text":"<p>Puedes hacerlo a través de las redes sociales como Facebook, Twitter o Instagram. Puedes ir a la configuración de tu teléfono para que te llegue una notificación con sonido cada vez que estas agencias publiquen actualizaciones en sus cuentas. </p><p>Aquí algunos ejemplos y enlaces.</p><p>En Twitter:</p><ul><li><a href=\"https://twitter.com/NOAA\">NOAA</a> (La Asociación Nacional Oceánica y Atmosférica)</li><li><a href=\"https://twitter.com/nws?lang=en\">NWS</a> (Servicio del Clima Nacional)</li><li><a href=\"https://twitter.com/fema?lang=en\">FEMA</a> (Agencia Federal de Manejo de Emergencias)</li></ul><div><font face=\"Roboto Slab, sans-serif\"><span style=\"font-size: 18px;\">En Facebook:</span></font></div><div><ul><li><font face=\"Roboto Slab, sans-serif\"><span style=\"font-size: 18px;\"><a href=\"https://www.facebook.com/NOAA/\">NOAA</a> </span></font></li><li><font face=\"Roboto Slab, sans-serif\"><span style=\"font-size: 18px;\"><a href=\"https://www.facebook.com/NWS/\">NWS</a></span></font></li><li><font face=\"Roboto Slab, sans-serif\"><a href=\"https://www.facebook.com/FEMA/?ref=br_rs\">FEMA</a></font></li></ul></div><div><font face=\"Roboto Slab, sans-serif\"><span style=\"font-size: 18px;\">Cada una de estas agencias tendrán oficinas a nivel local en tu área que puedes encontrar online buscando en tu buscador. </span></font></div><p></p>","url":"https://www.univision.com/test/como-me-suscribo-para-recibir-notificaciones-del-gobierno","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/6","path":"/desastres-naturales/2/6","context":{"slug":"desastres-naturales/2/6","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"6","card":"¿Cómo preparo mi casa para una inundación?","text":"<p><ol><li>Si tienes acceso a <b>bolsas de arena</b> u otros materiales, utilízalos para proteger tu hogar de las aguas de las inundaciones (si tienes tiempo suficiente para hacerlo). Llenar bolsas de arena puede llevarte <b>más tiempo de lo que piensas.</b></li><li>Haz que un profesional instale <b>válvulas de retención en las tuberías</b> para evitar que las aguas retrocedan hacia los desagües de tu casa. </li><li>Asegúrate de que la <b>caja de fusibles esté claramente marcada </b>para cada área de tu hogar para saber cuál apagar de ser necesario.</li><li>Dado que el seguro estándar para propietarios de viviendas <b>no cubre las inundaciones, </b>asegúrate que tienes cobertura <b>llamando a tu compañía de seguros</b> o agente para comprar un seguro contra inundaciones. </li><li>Esto debe hacerse <b>antes</b> de que exista una amenaza de inundación, ya que las compañías de seguros <b>dejan de emitir pólizas si existe una amenaza de inundación</b> (es decir, cuando un huracán se aproxima). </li><li>Muchas pólizas de seguro contra inundaciones tardan <b>al menos 30 días</b> en entrar en vigencia, así que incluso si puedes comprarla cuando se aproxima una tormenta, es posible que <b>no proteja tu casa</b>.</li></ol></p>","url":"https://www.univision.com/test/como-preparo-mi-casa-para-una-inundacion","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/7","path":"/desastres-naturales/2/7","context":{"slug":"desastres-naturales/2/7","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"7","card":"¿Cómo preparo a mi familia y mascotas para una inundación?","text":"<ul><li>Puede que te toque <b>evacuar</b>, así que empaca con varios días de <b>anticipación</b> si es posible. </li> <li>Prepara <b>ropa</b> y artículos de <b>higiene</b> (cepillo de dientes, crema dental, etc.) para<b> 3 días</b>.</li> <li>No esperes hasta el último momento para reunir lo <b>esencial</b> para ti, tu familia y / o tus mascotas.</li> <li>Asegúrate de que tu <b>teléfono celular y radios portátiles</b> estén <b>cargados</b> en caso de que pierdas energía o necesites <b>evacuar</b>.</li> <li>Empaca en tu maleta los <b>cargadores</b> para estos dispositivos.</li><li>También asegúrate de tener <b><b>pilas</b> de reserva</b> a mano.</li></ul>","url":"https://www.univision.com/test/como-preparar-a-mi-familia-y-mascotas-para-una-inundacion","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/8","path":"/desastres-naturales/2/8","context":{"slug":"desastres-naturales/2/8","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"8","card":"¿Qué debo hacer si debo evacuar por una inundación?","text":"<p><ul><li>Si es probable que tu casa se inunde, no esperes a que te ordenen irte; evacúa tú mismo </li><li>Haz planes alternativos y encuentra un lugar donde quedarte. </li><li>Si tiene mascotas, llévalas contigo o haz arreglos para alojarlas en una instalación lejos del peligro de inundación.</li></ul></p>","url":"https://www.univision.com/test/que-debo-hacer-si-debo-evacuar-por-una-inundacion","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/9","path":"/desastres-naturales/2/9","context":{"slug":"desastres-naturales/2/9","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"9","card":"¿Qué debe incluir un botiquín de primeros auxilios?","text":"<p><ul><li>Asegúrate de que la caja que contiene el kit o botiquín mismo sea <b>impermeable e inflamable. </b></li><li>Un <b>manual</b> de primeros auxilios actualizado</li><li>Una lista de <b>números telefónicos de emergencia, </b>tanto de las autoridades como de familiares y conocidos.</li><li>Almohadillas de <b>gasa</b> estériles de diferentes tamaños</li><li>Cinta adhesiva médica</li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Curas</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> (Band-Aids) de varios tamaños</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Una banda elastica</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Una férula</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Toallitas antisépticas</span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Jabón</b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Ungüento </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">antibiótico</b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Solución </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">antiséptica</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> (como el agua oxigenada, o </span><i style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">hydrogen peroxide</i><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> en inglés)</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Crema de hidrocortisona (1%)</span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Aspirina</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">, acetaminofén o ibuprofeno</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Medicamentos recetados adicionales</span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Pinzas</b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Tijeras afiladas</span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Pasadores</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> de seguridad</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Compresas desechables instantáneas</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Toallitas con </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">alcohol</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> o alcohol etílico</span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Termómetro</b></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Guantes</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> de plástico sin látex (al menos 2 pares)</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Una manta</span></li></ul></p>","url":"https://www.univision.com/test/lo-que-debe-incluir-un-botiquin-de-primeros-auxilios","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/10","path":"/desastres-naturales/2/10","context":{"slug":"desastres-naturales/2/10","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"10","card":"¿Cómo sé si debo evacuar?","text":"<p>Debes consultar con tus <b>autoridades locales: la policía, la alcaldía, la oficina del Sheriff.</b> </p><p>Todas estas tienen cuentas de redes sociales en Facebook, Twitter e Instagram donde puedes recibir sus actualizaciones. </p><p>También tienen páginas web donde publicarán la última información con <b>listados</b>, <b>números</b> y <b>mapas</b> de qué zonas deben <b>evacuar</b> inmediatamente, cuáles están en <b>riesgo</b> y cuáles se encuentran a <b>salvo</b>.</p><p>También proveerán las <b>rutas de evacuación</b> que debes tratar de seguir al pie de la letra en lo posible.</p>","url":"https://www.univision.com/test/como-se-si-debo-evacuar","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/11","path":"/desastres-naturales/2/11","context":{"slug":"desastres-naturales/2/11","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"11","card":"¿Qué debo hacer si los semáforos no funcionan durante una inundación?","text":"<p><ul><li>Si las luces de señalización no funcionan para <b>nada</b> (se han caído o han salido volando), debes hacer una <b>parada de</b> <b>4 vías.</b></li><b></b><li>Si hay luz <b>roja</b> <b>intermitente</b> se debe tratar como un <b>'Pare' o <i>Stop</i>.</b></li><b></b><li>Si hay luz <b>amarilla intermitente</b> debes seguir con <b>precaución</b>. </li></ul></p>","url":"https://www.univision.com/test/que-debo-hacer-si-los-semaforos-no-funcionan","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/12","path":"/desastres-naturales/2/12","context":{"slug":"desastres-naturales/2/12","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"12","card":"¿Qué debo hacer con los aparatos electrónicos?","text":"<p><ul><li><b>No enciendas </b>los generadores eléctricos después del huracán en zonas que estén inundadas.</li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Desconecta</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> todos los equipos eléctricos que no necesites. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Evita pasar (a pie, bicicleta, carro) por </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">aguas estancadas </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">ya que podría haber </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">cables</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> con electricidad sueltos. </span></li></ul></p>","url":"https://www.univision.com/test/que-debo-hacer-con-los-aparatos-electronicos","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/13","path":"/desastres-naturales/2/13","context":{"slug":"desastres-naturales/2/13","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"13","card":"¿Qué hago si mi casa se inunda?","text":"<p><ul><li>Ponte <b>botas</b> o zapatos (ojalá <b>impermeables</b>). No andes <b>descalzo</b>. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Desconecta</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> todos los aparatos electrónicos antes de que el agua alcance el</span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> nivel de los enchufes </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">o interruptores. Si crees que eso va a suceder, lo mejor es </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">apagar la electricidad </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">completamente</span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">en tu casa. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Pon los objetos más importantes y tus </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">documentos personales </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">en la parte más <b>alta</b> de la casa. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Mantén las puertas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">cerradas</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">. </span></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">No bebas agua de la tubería</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> a menos de que los equipos de socorro indiquen que es <b>seguro</b> tomarla y no está contaminada. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asigna un lugar donde la familia pueda hacer sus necesidades en caso de que </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">los inodoros no funcionen. </b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Ve al punto </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">más alto de la casa. </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si tienes <b>ático</b> resguárdate ahí. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asegúrate de tener un </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">hacha</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> u objeto con el que puedas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">romper el techo</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> en caso de que las aguas te alcancen. Así los equipos de socorro te pueden rescatar cuando </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">los esperes desde el techo. </b></li></ul></p>","url":"https://www.univision.com/test/que-hago-si-mi-casa-se-inunda","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/14","path":"/desastres-naturales/2/14","context":{"slug":"desastres-naturales/2/14","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"14","card":"¿Qué debo llevar a un refugio?","text":"<p><ul><li><b>Medicamentos</b> y prescripciones (recetas) médicas. </li><li>Papeles importantes en bolsas <b>plásticas impermeables. </b></li><li>Lleva tu comida si tienes una <b>dieta especial.</b></li><li>Si tienes bebés lleva <b>pañales</b>, <b>medicamentos</b> y comida especial. </li><li>Varias mudas de <b>ropa</b>. </li><li>Si tienes, puedes llevar: <b>mantas</b>, colchón inflable, bolsas para dormir o <b>almohadas</b>. Estos artículos pueden ser escasos en los refugios. </li><li><b>Juegos de mesa </b>o cartas para entretenerse sin electricidad. </li></ul></p>","url":"https://www.univision.com/test/que-debo-llevar-a-un-refugio","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/2/15","path":"/desastres-naturales/2/15","context":{"slug":"desastres-naturales/2/15","node":{"idbaraja":"2","baraja":"¿Cómo me preparo para una inundación?","idcard":"15","card":"¿Qué hago si me quedo atrapado en un carro que está flotando en una inundación?","text":"<p><ol><li>Mantén la <b>calma</b>. Aunque es difícil, es vital no desesperarse para <b>no gastar energía</b>, poder <b>pensar bien </b>y encontrar la <b>solución</b> que te mantenga a salvo. </li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Desabrocha tu </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">cinturón</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Baja las ventanas para</span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> salir y nadar.</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> Si el agua ya cubrió las ventanas pero no estás completamente sumergido por dentro, las ventanas </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">no se abrirán</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> por la presión desigual. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">En ese caso, tienes que esperar a que </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">el agua llene el carro </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">completamente. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Entonces, </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">toma aire </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">y cuando esté lleno de agua el carro abre la ventana o rómpela con un objeto </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">afilado</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> para poder salir nadando. </span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si no tienes un objeto, puedes sacar <b>el reposacabezas (</b></span><i style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"><b>headrest) </b></i><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">de su posición y usar las puntas para pegarle con fuerza al vidrio y romperlo.</span></li></ol></p>","url":"https://www.univision.com/test/que-debo-hacer-si-me-quedo-atrapado-en-un-carro-flotando-en-una-inundacion","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/1","path":"/desastres-naturales/3/1","context":{"slug":"desastres-naturales/3/1","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"1","card":"¿Que puedo hacer antes de un incendio para prepararme?","text":"<p><li>Inscríbete en las notificaciones de advertencia de tu comunidad. El Sistema de Alerta de Emergencia (EAS, por sus siglas en inglés) y la radio meteorológica de la Administración Nacional Oceánica y Atmosférica (NOAA, por sus siglas en inglés) también proveen alertas de emergencia.</li><li>Conoce los planes de evacuación de tu comunidad y averigua varias formas de abandonar el área. Aprende las rutas de evacuación por auto y encuentra los refugios. Haz planes para las mascotas.</li><li>Prepara un kit de emergencia. Incluye mascarillas para no inhalar partículas del aire. Ten presente las necesidades específicas de cada persona, como medicamentos para el asma. No te olvides de las necesidades de las mascotas.</li><li>Designa una habitación que pueda sellarse para impedir la entrada del aire exterior. Cierra todas las puertas y ventanas. </li><li>Si hay humo, instala un filtro de aire portátil para mantener bajo el nivel de contaminación interior.</li><li>Guarda los documentos importantes en un lugar seguro a prueba de fuego. Crea copias digitales protegidas con contraseña.</li><li>Usa materiales resistentes al fuego para construir, renovar o hacer reparaciones.</li><li>Encuentra un suministro de agua que esté al aire libre con una manguera que pueda llegar a todas las áreas de tu propiedad.</li><li>Crea una <a href=\"https://www.fema.gov/media-library-data/20130726-1652-20490-9209/fema_p_737_fs_4.pdf\">zona resistente al fuego </a>que esté libre de hojas, escombros o materiales inflamables, por lo menos a 30 pies de tu casa.</li><li>Revisa la cobertura de tu seguro para asegurarte de que sea suficiente para reemplazar pérdidas de tu propiedad.</li><li>Presta atención a las <a href=\"https://www.airnow.gov/index.cfm?action=topics.smoke_events\">alertas de calidad del aire.</a></li></p>","url":"https://www.univision.com/test/como-prepararse-para-un-incendio-forestal","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/2","path":"/desastres-naturales/3/2","context":{"slug":"desastres-naturales/3/2","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"2","card":"¿Qué debo hacer durante una advertencia de incendio forestal?","text":"<p><li>Abandona tu casa si las autoridades lo indican.</li><li>Si estás atrapado, llama al 9-1-1.</li><li>Escucha la información de emergencia y está atento a las alertas.</li><li>Usa mascarillas para no inhalar humo y partículas en el aire.</li></p>","url":"https://www.univision.com/test/que-debo-hacer-durante-una-advertencia-de-incendio-forestal","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/3","path":"/desastres-naturales/3/3","context":{"slug":"desastres-naturales/3/3","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"3","card":"¿Qué debo empacar en un kit de supervivencia para incendios?","text":"<p><ul><li><b>Agua</b>: Un galón por día por persona o mascota. Calcula para <b>3 días</b>. </li><li><b>Comida</b>: Compra alimentos que no necesiten refrigerarse, como <b>enlatados</b>. </li><li><b>Linternas</b>: Guarda una por persona y compra <b>baterías</b> extra. </li><li><b>Celulares</b>: Cárgalo al 100% todo lo que puedas y ten un <b>cargador</b> inalámbrico extra. </li><li><b>Dinero</b>: Ten <b>efectivo</b> a la mano para cuando no haya luz. </li><li><b>Radio</b>: Asegúrate que funcione con <b>baterías</b>. </li><li><b>Medicinas</b>: Guarda suministros para <b>7 días</b>. </li><li><b>Documentos</b>: Saca fotocopias y guarda los originales en bolsas plásticas <b>sellables</b>. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Kit de primeros auxilios: </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asegúrate que tenga todo lo necesario. Lee la siguiente tarjeta para saber qué debe tener un <b>botiquín</b> completo. </span></li></ul></p>","url":"https://www.univision.com/test/que-debo-empacar-en-un-kit-de-supervivencia-para-incendios","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/4","path":"/desastres-naturales/3/4","context":{"slug":"desastres-naturales/3/4","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"4","card":"¿Qué debe incluir un botiquín de primeros auxilios?","text":"<p></p><ul><li>Un <b>manual</b> de primeros auxilios actualizado</li><li>Una lista de números <b>telefónicos</b> de emergencia, tanto de las autoridades como de <b>familiares</b> y conocidos.</li><li>Almohadillas de gasa <b>estériles</b> de diferentes tamaños</li><li>Cinta adhesiva médica</li><li><b>Curas</b> (Band-Aids) de varios tamaños</li><li>Una banda <b>elastica</b></li><li>Una <b>férula</b></li><li>Toallitas antisépticas</li><li><b>Jabón</b></li><li>Ungüento antibiótico</li><li>Solución <b>antiséptica</b> (como el agua oxigenada, o <i>hydrogen peroxide</i> en inglés)</li><li>Crema de hidrocortisona (1%)</li><li>Paracetamol e <b>ibuprofeno</b></li><li>Medicamentos recetados adicionales</li><li>Pinzas</li><li><b>Tijeras</b> afiladas</li><li>Pasadores de seguridad</li><li><b>Compresas</b> desechables instantáneas</li><li>Toallitas con alcohol o alcohol etílico</li><li><b>Termómetro</b></li><li>Guantes de plástico sin látex (al menos 2 pares)</li><li><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Una <b>manta</b></span></li></ul>","url":"https://www.univision.com/test/que-debe-incluir-un-botiquin-de-primeros-auxilios","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/5","path":"/desastres-naturales/3/5","context":{"slug":"desastres-naturales/3/5","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"5","card":"¿Cómo sé si debo evacuar?","text":"<p>Debes consultar con tus <b>autoridades</b> locales. </p><p>Ellos tendrán <b>mapas e información actualizada</b> de qué zonas deben evacuar <b>inmediatamente</b>, cuáles están en <b>riesgo</b> y cuáles se encuentran a <b>salvo</b>. </p><p>También proveerán las <b>rutas</b> de evacuación.</p>","url":"https://www.univision.com/test/como-se-si-debo-evacuar-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/6","path":"/desastres-naturales/3/6","context":{"slug":"desastres-naturales/3/6","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"6","card":"¿Qué debo hacer si los semáforos no funcionan?","text":"<p>Si las luces de señalización no funcionan para nada (se han caído o se han quemado), debes hacer una <b>parada de 4 vías</b>.</p><p>Si hay luz <b>roja</b> intermitente se debe tratar como un <b>'Pare' o <i>Stop.</i></b></p><p>Si hay luz <b>amarilla</b> intermitente debes seguir con <b>precaución</b>. </p>","url":"https://www.univision.com/test/que-debo-hacer-si-los-semaforos-no-funcionan-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/3/7","path":"/desastres-naturales/3/7","context":{"slug":"desastres-naturales/3/7","node":{"idbaraja":"3","baraja":"¿Cómo me preparo para un incendio forestal?","idcard":"7","card":"¿Qué debo llevar a un refugio?","text":"<p><ul><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Medicamentos y prescripciones (recetas) médicas.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Juegos de mesa o cartas.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Papeles importantes en bolsas plásticas impermeables.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Lleva tu comida si tienes una dieta especial.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si tienes bebés lleva pañales, medicamentos y comida especial.</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Varias mudas de ropa.</span></li></ul></p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si tienes, puedes llevar: </span></p><p><ul><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Mantas</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Colchón inflable</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Bolsas para dormir</span></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Almohadas</span></li></ul></p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Estos artículos pueden ser escasos en los refugios. </span><br></p>","url":"https://www.univision.com/test/que-debo-llevar-a-un-refugio-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/1","path":"/desastres-naturales/4/1","context":{"slug":"desastres-naturales/4/1","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"1","card":"¿Qué es un terremoto?","text":"<p>Para entender un terremoto hay que entender que la tierra tiene cuatro capas principales: <b>el núcleo interno, el núcleo externo, el manto y la corteza. </b>La corteza y la parte superior del manto forman una piel delgada en la superficie de la Tierra. </p><p>Pero esta piel no es una sola pieza, está formada por muchas piezas, como un <b>rompecabezas</b>. Estas piezas se <b>mueven</b> muy lentamente, se <b>deslizan</b> una sobre la otra y se <b>topan</b> unas con otras. Estas piezas se llaman <i>placas tectónicas. </i></p><p>Como los bordes de las placas son ásperos, se <b>atascan</b> mientras el resto de la placa se mueve. Cuando la placa se ha movido lo suficiente, los bordes se <b>desprenden</b> y se produce un <b>terremoto</b>.</p>","url":"https://www.univision.com/test/que-es-un-terremoto","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/2","path":"/desastres-naturales/4/2","context":{"slug":"desastres-naturales/4/2","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"2","card":"¿Se puede predecir un terremoto?","text":"<p><b>No</b>, y es poco probable que los científicos vayan a poder predecirlos. Han intentado muchas formas, sin éxito. </p><p>En algunos casos en particular, los científicos pueden saber que <b>habrá otro terremoto en el futuro</b> sobre una falla tectónica (pueden dar un rango de <b>meses, años o décadas</b>), pero no tienen forma de saber <b>cuándo</b> ocurrirá ese sismo. </p><p>Lo que sí sabemos es que después de un terremoto suelen haber otros, iguales o más pequeños, llamados <b>réplicas. </b>Estos pueden ser igual o <b>más destructivos. </b>Por eso es importante hacer caso a las autoridades tras un primer sismo y <b>resguardarse o evacuar</b> según lo que aconsejen. </p><p>A veces, un temblor puede ser un sismo previo a un <b>terremoto más fuerte.</b></p>","url":"https://www.univision.com/test/se-puede-o-no-predecir-un-terremoto","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/3","path":"/desastres-naturales/4/3","context":{"slug":"desastres-naturales/4/3","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"3","card":"¿Cómo sé si vivo en una zona de terremotos?","text":"<p>Las zonas más propensas a terremotos están en la <b>costa oeste y el Pacífico</b>, en los estados de:</p><p><ul><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">California</span></li><li>Alaska</li><li>Hawaii</li><li>Oregon</li><li>Washington</li><li>Nevada</li><li>Utah</li><li>Idaho</li><li>Montana</li><li>Wyoming</li></ul></p><p>Otro foco <b>menos conocido</b> de actividad sísmica es el nudo entre los estados de: </p><p><ul><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Missouri</span></li><li>Illinois</li><li>Kentucky</li><li>Tennessee</li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Arkansas</span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> </b></li></ul></p>","url":"https://www.univision.com/test/como-se-si-vivo-en-una-zona-de-terremotos-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/4","path":"/desastres-naturales/4/4","context":{"slug":"desastres-naturales/4/4","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"4","card":"¿Cómo puedo prepararme si vivo en una zona de terremotos?","text":"<p><ul><li>Guarda copias <b>electrónicas</b> de tus documentos importantes en la <b>nube</b>.</li><li>Compra <b>baterías</b> adicionales o <b>cargadores</b> portátiles.</li><li>Puedes comprar un <b>generador</b> eléctrico. Aunque son costosos te pueden sacar de un apuro.</li><li>Ten a la mano en tu casa dinero en <b>efectivo</b>. Muchas tiendas pueden perder electricidad y no tomarán pagos electrónicos. </li></ul></p>","url":"https://www.univision.com/test/como-puedo-prepararme-si-vivo-en-una-zona-de-terremotos","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/5","path":"/desastres-naturales/4/5","context":{"slug":"desastres-naturales/4/5","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"5","card":"¿Qué debo empacar en un kit de supervivencia para terremotos?","text":"<p><ul><li><b>Agua</b>: Un galón por día por persona o mascota. Calcula para 3 días. </li><li><b>Comida</b>: Compra alimentos que no necesiten refrigerarse, como enlatados. </li><li><b>Linternas</b>: Guarda una por <b>persona</b> y compra <b>baterías</b> extra. </li><li><b>Celulares</b>: Cárgalo al 100% todo lo que puedas y ten un <b>cargador</b> inalámbrico extra. </li><li><b>Un silbato: </b>Te ayudará si estás <b>atrapado</b> entre escombros, así los socorristas te pueden <b>oír</b> y rescatar.</li><li><b>Dinero</b>: Ten <b>efectivo</b> a la mano para cuando no haya luz. </li><li><b>Radio</b>: Asegúrate que funcione con <b>baterías</b>. </li><li><b>Medicinas</b>: Guarda suministros para <b>7 días. </b></li><li><b>Documentos</b>: Saca fotocopias y guarda los originales en bolsas <b>plásticas sellables. </b></li><li><b>Kit de primeros auxilios: </b>Asegúrate que tenga todo lo necesario. Lee la siguiente tarjeta para saber qué debe tener un botiquín completo. </li></ul></p>","url":"https://www.univision.com/test/que-debo-empacar-en-un-kit-de-supervivencia-para-terremotos","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/6","path":"/desastres-naturales/4/6","context":{"slug":"desastres-naturales/4/6","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"6","card":"¿Qué debe incluir un botiquín de primeros auxilios?","text":"<p><ul><li>Un manual de <b>primeros auxilios</b> actualizado</li><li>Una lista de números <b>telefónicos</b> de emergencia, tanto de las <b>autoridades</b> como de <b>familiares</b> y conocidos.</li><li>Almohadillas de <b>gasa</b> estériles de diferentes tamaños</li><li><b>Cinta</b> adhesiva médica</li><li><b>Curas</b> (Band-Aids) de varios tamaños</li><li>Una banda elastica</li><li>Una <b>férula</b></li><li>Toallitas antisépticas</li><li><b>Jabón</b></li><li>Ungüento antibiótico</li><li>Solución <b>antiséptica</b> (como el agua oxigenada, o <i>hydrogen peroxide</i> en inglés)</li><li>Crema de hidrocortisona (1%)</li><li>Paracetamol e ibuprofeno</li><li><b>Medicamentos</b> recetados adicionales</li><li>Pinzas</li><li>Tijeras afiladas</li><li>Pasadores de seguridad</li><li>Compresas desechables instantáneas</li><li><b>Toallitas</b> con alcohol o alcohol etílico</li><li>Termómetro</li><li><b>Guantes</b> de plástico sin látex (al menos 2 pares)</li><li>Una manta</li></ul></p>","url":"https://www.univision.com/test/que-debe-incluir-un-botiquin-de-primeros-auxilios-1","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/7","path":"/desastres-naturales/4/7","context":{"slug":"desastres-naturales/4/7","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"7","card":"¿Qué debo hacer si los semáforos no funcionan?","text":"<p><ul><li>Si las luces de señalización no funcionan para nada (se han caído o han salido volando), debes hacer una <b>parada de 4 vías. </b></li><li>Si hay luz roja intermitente se debe tratar como un 'Pare' o <b><i>Stop</i></b><i>.</i></li><li>Si hay luz amarilla intermitente debes <b>seguir con precaución</b>. </li></ul></p>","url":"https://www.univision.com/test/que-debo-hacer-si-los-semaforos-no-funcionan-2","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/8","path":"/desastres-naturales/4/8","context":{"slug":"desastres-naturales/4/8","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"8","card":"¿Qué hago después del terremoto?","text":"<p>Sal al aire libre, a una zona<b> lo más lejos posible </b>de edificios, casas o estructuras que pudieran <b>desplomarse</b>. </p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Ponte </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">botas</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> o zapatos (ojalá impermeables). No andes descalzo. </span><br></p><p>Si es seguro quedarte en tu vivienda <b>desconecta</b> todos los aparatos electrónicos. Puede que haya <b>réplicas</b>. </p><p><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">No bebas agua de la tubería</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> a menos de que los equipos de socorro indiquen que es seguro tomarla y no está </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">contaminada</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">. Puede que las tuberías se hayan </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">roto</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> bajo la tierra. </span><br></p>","url":"https://www.univision.com/test/que-hago-despues-del-terremoto","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/9","path":"/desastres-naturales/4/9","context":{"slug":"desastres-naturales/4/9","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"9","card":"¿Qué debo llevar a un refugio?","text":"<p><ul><li><b>Medicamentos</b> y prescripciones (recetas) médicas. </li><li>Papeles importantes en<b> bolsas plásticas impermeables. </b></li><li><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Lleva tu comida si tienes una </span><b style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">dieta</b><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> especial.</span></li><li>Si tienes bebés lleva <b>pañales</b>, medicamentos y comida especial. </li><li><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Varias mudas de </span><b style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">ropa</b><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">. </span></li><li>Si tienes, puedes llevar: <b>mantas</b>, colchón inflable, bolsas para dormir o <b>almohadas</b>. Estos artículos pueden ser escasos en los refugios. </li><li><b style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\">Juegos de mesa</b><span style=\"font-family: \" roboto=\"\" slab\",=\"\" sans-serif;=\"\" font-size:=\"\" 18px;\"=\"\"> o cartas. </span></li></ul></p>","url":"https://www.univision.com/test/que-debo-llevar-a-un-refugio-2","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/10","path":"/desastres-naturales/4/10","context":{"slug":"desastres-naturales/4/10","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"10","card":"¿Qué debo preguntar al dueño de mi edificio si vivo en una zona propensa a terremotos?","text":"<p><ol><li><b>¿Cuándo fue construido este edificio? </b>Los cambios que se han hecho a los códigos de construcción antiterremoto <b>no son retroactivos</b>, por lo que es muy importante saber <b>cuándo se construyó tu edificio</b>.</li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Ha sido adaptado (<i>retrofitted)</i>? </b>Si sí, ¿<b>cuándo</b>? ¿De qué manera? ¿Puedo ver la <b>documentación</b>? Si el edificio no se ha modernizado y se construyó <b>antes de 1994</b> (el año del terremoto de Northridge), pregúntale al propietario <b>cuándo planean hacerle <i>retrofitting</i></b>.</li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Hay problemas con la fundación?</b>¿Se realizó una <b>inspección</b> de la fundación? ¿Cuáles fueron los <b>resultados</b>? Si hubo problemas con los cimientos, <b>¿dónde y qué hicieron para solucionarlos?</b> Si no te dan respuestas, puedes buscar esa información en el registro de ventas del edificio en sitios web como <b>Zillow, Redfin o Trulia.</b></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Qué tipo de suelo hay debajo del edificio? </b>Ciertas viviendas están sobre zonas que pueden sufrir de <b>liquefacción</b>, que es cuando el suelo se convierte en <b>arena movediza. </b>Busca en esta herramienta si tu zipcode está sobre una zona de liquefacción.  </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Estamos sobre una línea de falla?</b></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Este edificio ha sido afectado en un desastre anterior? </b>Si tu edificio sufrió daños en un incendio, terremoto u otro desastre, puede ser más vulnerable cuando llegue un gran terremoto. ¿Los dueños hicieron las reparaciones necesarias después del último gran desastre?</li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Qué pasa si mi vivienda se vuelve inhabitable después del terremoto?</b></li><li><b>¿A quién vas a llamar? </b>Si hay daños a la propiedad después de un desastre, debes reportarlos. Prepárate ahora y asegúrate de tener un contacto directo con el gerente y el propietario del edificio. ¿Quién está de respaldo si no puedes comunicarte con ellos? Guarda copias de su información de contacto.</li><li><b>¿Este edificio está asegurado por daños causados por terremotos?</b></li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">¿Dónde y cómo se apaga el gas? </b>Existe un gran peligro de incendio después del terremoto. En algunas unidades las válvulas de gas se cierran automaticamente después de un terremoto. Pregunta si las tienen en tu vivienda o si es manual y pregunta dónde está la válvula.</li></ol></p>","url":"https://www.univision.com/test/que-debo-preguntar-al-dueno-de-mi-edificio-si-vivo-en-una-zona-propensa-a-terremotos","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/4/11","path":"/desastres-naturales/4/11","context":{"slug":"desastres-naturales/4/11","node":{"idbaraja":"4","baraja":"¿Cómo me preparo para un terremoto?","idcard":"11","card":"¿Qué pasa si mi vivienda se vuelve inhabitable después del terremoto?","text":"<p>Tu edificio debe cumplir ciertos requisitos <b>en todo momento </b>para que pueda considerarse <b>habitable</b>. Asegúrate de que las siguientes cosas funcionen:</p><p><ul><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Electricidad</b></li><li><b>Agua</b> corriente fría y caliente.</li><li>Desagües e <b>inodoros</b> que funcionen.</li><li>Calefacción y aire acondicionado.</li><li>Las <b>ventanas</b> </li><li>Las puertas</li><li><b>Electrodomésticos</b>, como estufa y refrigerador.</li><li>Pisos, techos y paredes en buen estado. </li><li>Que no haya <b>infestaciones</b></li></ul></p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Documenta todos los daños con </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">fotos y video. </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Lo puedes presentar al propietario o a la asociación de vivienda y podrías ser elegible para </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">no pagar renta si tu vivienda se considera inhabitable.</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> </span><br></p>","url":"https://www.univision.com/test/que-pasa-si-mi-vivienda-se-vuelve-inhabitable-despues-del-terremoto","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/1","path":"/desastres-naturales/5/1","context":{"slug":"desastres-naturales/5/1","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"1","card":"¿Que puedo hacer antes de un tornado para prepararme?","text":"<p>Tu edificio debe cumplir ciertos requisitos <b>en todo momento </b>para que pueda considerarse <b>habitable</b>. Asegúrate de que las siguientes cosas funcionen:</p><p><ul><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Electricidad</b></li><li><b>Agua</b> corriente fría y caliente.</li><li>Desagües e <b>inodoros</b> que funcionen.</li><li>Calefacción y aire acondicionado.</li><li>Las <b>ventanas</b> </li><li>Las puertas</li><li><b>Electrodomésticos</b>, como estufa y refrigerador.</li><li>Pisos, techos y paredes en buen estado. </li><li>Que no haya <b>infestaciones</b></li></ul></p><p><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Documenta todos los daños con </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">fotos y video. </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Lo puedes presentar al propietario o a la asociación de vivienda y podrías ser elegible para </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">no pagar renta si tu vivienda se considera inhabitable.</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> </span><br></p>","url":"https://www.univision.com/test/que-puedo-hacer-antes-de-un-tornado-para-prepararme","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/2","path":"/desastres-naturales/5/2","context":{"slug":"desastres-naturales/5/2","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"2","card":"¿Qué debo empacar en un kit de supervivencia para un tornado?","text":"<p><ul><li><b>Agua</b>: Un galón por día por persona o mascota. Calcula para 3 días. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Comida</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">: Compra alimentos que no necesiten refrigerarse, como enlatados. </span></li><li><b>Linternas</b>: Guarda una por persona y compra baterías extra. </li><li><b>Celulares</b>: Cárgalo al 100% todo lo que puedas y ten un cargador inalámbrico extra. </li><li><b>Dinero</b>: Ten efectivo a la mano para cuando no haya luz. </li><li><b>Radio</b>: Asegúrate que funcione con baterías. </li><li><b>Medicinas</b>: Guarda suministros para 7 días. </li><li><b>Documentos</b>: Saca fotocopias y guarda los originales en bolsas plásticas sellables. </li><li><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Kit de primeros auxilios: </b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Asegúrate que tenga todo lo necesario. Lee la siguiente tarjeta para saber qué debe tener un botiquín completo. </span></li></ul></p>","url":"https://www.univision.com/test/que-debo-empacar-en-un-kit-de-supervivencia-para-un-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/3","path":"/desastres-naturales/5/3","context":{"slug":"desastres-naturales/5/3","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"3","card":"¿Qué debe incluir un botiquín de primeros auxilios?","text":"<p>Asegúrate de que la caja que contiene el kit o botiquín mismo sea impermeable e inflamable. <br><ul><li>Un manual de <b>primeros auxilios</b> actualizado</li><li>Una lista de <b>números telefónicos de emergencia, </b>tanto de las autoridades como de familiares y conocidos.</li><li>Almohadillas de <b>gasa</b> estériles de diferentes tamaños</li><li><b>Cinta</b> adhesiva médica</li><li><b>Curas</b> (Band-Aids) de varios tamaños</li><li>Una <b>banda</b> elástica</li><li>Una <b>férula</b></li><li>Toallitas antisépticas</li><li>Jabón</li><li>Ungüento <b>antibiótico</b></li><li>Solución antiséptica (como el agua oxigenada, o <i>hydrogen peroxide</i> en inglés)</li><li>Crema de hidrocortisona (1%)</li><li>Paracetamol e ibuprofeno</li><li><b>Medicamentos</b> recetados adicionales</li><li>Pinzas</li><li>Tijeras afiladas</li><li>Ganchos de seguridad</li><li><b>Compresas</b> desechables instantáneas</li><li>Toallitas con alcohol o alcohol etílico</li><li>Termómetro</li><li><b>Guantes</b> de plástico sin látex (al menos 2 pares)</li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Una manta</span></li></ul></p>","url":"https://www.univision.com/test/que-debe-incluir-un-botiquin-de-primeros-auxilios-para-un-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/4","path":"/desastres-naturales/5/4","context":{"slug":"desastres-naturales/5/4","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"4","card":"¿Cómo sé si debo evacuar para un tornado?","text":"<p>Debes consultar con tus autoridades <b>locales</b>. </p><p>Ellos tendrán <b>mapas</b> e información actualizada de qué zonas deben evacuar <b>inmediatamente</b>, cuáles están en <b>riesgo</b> y cuáles se encuentran a <b>salvo</b>. </p><p>También proveerán las <b>rutas</b> de evacuación.</p>","url":"https://www.univision.com/test/como-se-si-debo-evacuar-para-un-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/5","path":"/desastres-naturales/5/5","context":{"slug":"desastres-naturales/5/5","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"5","card":"¿Qué debo hacer si los semáforos no funcionan tras un tornado?","text":"<li>Si las luces de señalización no funcionan para nada (se cayeron o salieron volando), debes hacer una <b>parada de 4 vías. </b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si hay luz roja intermitente se debe tratar como un </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">'Pare' o <i>Stop.</i></b></li><li><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">Si hay luz amarilla intermitente debes </span><b style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\">seguir</b><span style=\"font-family: \"Roboto Slab\", sans-serif; font-size: 18px;\"> con precaución. </span></li>","url":"https://www.univision.com/test/que-debo-hacer-si-los-semaforos-no-funcionan-tras-un-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/6","path":"/desastres-naturales/5/6","context":{"slug":"desastres-naturales/5/6","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"6","card":"¿Qué debo hacer con los aparatos electrónicos?","text":"<li><b>No enciendas </b>los generadores eléctricos después del huracán en zonas que estén <b>inundadas</b>.</li><li><b>Desconecta</b> todos los equipos eléctricos que no necesites. </li><li>Evita pasar (a pie, bicicleta, carro) por aguas <b>estancadas</b> ya que podría haber <b>cables con electricidad sueltos</b>. </li>","url":"https://www.univision.com/test/que-debo-hacer-con-los-aparatos-electronicos-cuando-llega-un-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/7","path":"/desastres-naturales/5/7","context":{"slug":"desastres-naturales/5/7","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"7","card":"¿Qué hago después de que pase el tornado?","text":"<p><ul><li>Ponte <b>botas</b> o zapatos (ojalá impermeables). No andes descalzo. </li><li>Desconecta todos los aparatos electrónicos. </li><li>Pon los objetos más importantes y tus <b>documentos personales</b> en la parte más resguardada de la casa, en un <b>gabinete de un closet</b>, por ejemplo. </li><li><b>No bebas agua de la tubería</b> a menos de que los equipos de socorro indiquen que es seguro tomarla y no está contaminada. </li><li>Asigna un lugar donde la familia pueda hacer sus necesidades en caso de que los <b>inodoros</b> no funcionen. </li></ul></p>","url":"https://www.univision.com/test/que-hago-despues-de-que-pase-el-tornado","sheet":"Desastres naturales"}}}},{"node":{"id":"SitePage /desastres-naturales/5/8","path":"/desastres-naturales/5/8","context":{"slug":"desastres-naturales/5/8","node":{"idbaraja":"5","baraja":"¿Cómo me preparo para un tornado?","idcard":"8","card":"¿Qué debo llevar a un refugio?","text":"<p><ul><li><b>Medicamentos</b> y prescripciones (recetas) médicas. </li><li>Papeles importantes en bolsas <b>plásticas impermeables. </b></li><li>Lleva tu comida si tienes una <b>dieta especial.</b></li><li>Si tienes bebés lleva <b>pañales</b>, <b>medicamentos</b> y comida especial. </li><li>Varias mudas de <b>ropa</b>. </li><li>Si tienes, puedes llevar: <b>mantas</b>, colchón inflable, bolsas para dormir o <b>almohadas</b>. Estos artículos pueden ser escasos en los refugios. </li><li><b>Juegos de mesa </b>o cartas para entretenerse sin electricidad. </li></ul></p>","url":"https://www.univision.com/test/que-debo-llevar-a-un-refugio-3","sheet":"Desastres naturales"}}}}]}},"layoutContext":{}}

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _internal = __webpack_require__(231);
	
	var _internal2 = _interopRequireDefault(_internal);
	
	var _layoutInternal = __webpack_require__(105);
	
	var _layoutInternal2 = _interopRequireDefault(_layoutInternal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_internal2.default, _extends({}, props, _layoutInternal2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(205);

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var settle = __webpack_require__(211);
	var buildURL = __webpack_require__(214);
	var parseHeaders = __webpack_require__(220);
	var isURLSameOrigin = __webpack_require__(218);
	var createError = __webpack_require__(134);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(213);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(216);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var bind = __webpack_require__(135);
	var Axios = __webpack_require__(207);
	var defaults = __webpack_require__(69);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(132);
	axios.CancelToken = __webpack_require__(206);
	axios.isCancel = __webpack_require__(133);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(221);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(132);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(69);
	var utils = __webpack_require__(12);
	var InterceptorManager = __webpack_require__(208);
	var dispatchRequest = __webpack_require__(209);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(210);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var transformData = __webpack_require__(212);
	var isCancel = __webpack_require__(133);
	var defaults = __webpack_require__(69);
	var isAbsoluteURL = __webpack_require__(217);
	var combineURLs = __webpack_require__(215);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(134);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(12);
	var normalizeHeaderName = __webpack_require__(219);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(131);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(131);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 215:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(135);
	var isBuffer = __webpack_require__(527);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(98);
	var isArguments = __webpack_require__(97);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 527:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.10';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(130)(module)))

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(128);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(96);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(123);
	
	var _HelmetConstants = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(100);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(129);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	    module.exports['default'] = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  /* eslint-disable */
	  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
	  /* eslint-enable */
	
	  function replace (string, options) {
	    if (typeof string !== 'string') {
	      throw new Error('slugify: string argument expected')
	    }
	
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    var slug = string.split('')
	      .reduce(function (result, ch) {
	        return result + (charMap[ch] || ch)
	          // allowed
	          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	      }, '')
	      // trim leading/trailing spaces
	      .replace(/^\s+|\s+$/g, '')
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? slug.toLowerCase() : slug
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.set_content_type = set_content_type;
	exports.track_click = track_click;
	exports.track_social_click = track_social_click;
	exports.getTrackingObject = getTrackingObject;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	String.prototype.sanitize = function () {
	    return this === undefined || this === null ? '' : this.replace(/'/gi, "\\\'").normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
	};
	function set_content_type() {
	    try {
	        // TODO
	    } catch (errr) {}
	}
	function track_click($tag_name) {
	    window.dataLayer && window.dataLayer.push({
	        event: 'other',
	        promo_type: 'other',
	        promo_loc: 'https://www.univision.com' + ("/especial/noticias/te-explicamos/public"),
	        promo_name: $tag_name
	    });
	}
	function track_social_click(data) {
	    var tracking_data = getTrackingObject();
	    typeof window !== 'undefined' && window.dataLayer && dataLayer.push({
	        event_action: data.social_name,
	        event_label: tracking_data.content_id + ' - ' + data.title.sanitize(),
	        event: 'social_share',
	        promo_type: 'link',
	        promo_loc: tracking_data.permalink,
	        environment_name: 'production'
	    });
	}
	function getTrackingObject() {
	    var tracking_data = window._get("tracking");
	    return tracking_data ? JSON.parse(tracking_data) : {};
	}
	
	var Tracking = function (_React$Component) {
	    _inherits(Tracking, _React$Component);
	
	    function Tracking() {
	        _classCallCheck(this, Tracking);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Tracking.prototype.track_event = function track_event(text) {
	        console.log("hola hola " + text);
	    };
	
	    Tracking.prototype.init_track = function init_track(w, d, s, l, i) {
	        w[l] = w[l] || [];w[l].push(window.utag_data);w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
	            j = d.createElement(s),
	            dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
	    };
	
	    Tracking.prototype.track = function track(tracking_data) {
	        if (tracking_data !== undefined) {
	            tracking_data.title = 'Te explicamos - ' + this.props.trackTitle;
	
	            (function (w, d, s, l, i) {
	                w[l] = w[l] || [];w[l].push(window.tracking_data);w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
	                    j = d.createElement(s),
	                    dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
	            })(window, document, 'script', 'dataLayer', 'GTM-TDVV9BR');
	        }
	    };
	
	    Tracking.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        setTimeout(function () {
	            var tracking_data = window._get("tracking");
	            window.tracking_data = tracking_data ? JSON.parse(tracking_data) : {};+_this2.track(window.tracking_data);
	        }, 600);
	    };
	
	    Tracking.prototype.render = function render() {
	        return _react2.default.createElement('div', { id: 'tracking-utag' });
	    };
	
	    return Tracking;
	}(_react2.default.Component);
	
	exports.default = Tracking;

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAABGdBTUEAALGPC/xhBQAAAGdJREFUOBFjYKA3+P//fyEQS5NlL1BjKxCDwDUgZiHJEKAGmObfQHboqGYCITA8AiyMgC9RpdH8TEfNQHcwobqFTB5FXoDZOWoILCQQ9GiYIMICxqJ2mICKdVaY4STRQI3kVyzYbAIArCZgOKg0zaYAAAAASUVORK5CYII="

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/te-explicamos-white-logo.d4bee0ab.svg";

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(122);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(311);
	
	var _tracking = __webpack_require__(71);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _educacion = __webpack_require__(827);
	
	var _educacion2 = _interopRequireDefault(_educacion);
	
	var _inmigracion = __webpack_require__(828);
	
	var _inmigracion2 = _interopRequireDefault(_inmigracion);
	
	var _desastresNaturales = __webpack_require__(826);
	
	var _desastresNaturales2 = _interopRequireDefault(_desastresNaturales);
	
	var _arrow_right = __webpack_require__(825);
	
	var _arrow_right2 = _interopRequireDefault(_arrow_right);
	
	var _teExplicamosWhiteLogo = __webpack_require__(830);
	
	var _teExplicamosWhiteLogo2 = _interopRequireDefault(_teExplicamosWhiteLogo);
	
	var _teExplicamosWhiteLogoMobile = __webpack_require__(829);
	
	var _teExplicamosWhiteLogoMobile2 = _interopRequireDefault(_teExplicamosWhiteLogoMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ = __webpack_require__(722);
	var slugify = __webpack_require__(824);
	
	var axios = __webpack_require__(204);
	
	var Internal = function (_React$Component) {
	  _inherits(Internal, _React$Component);
	
	  function Internal(props) {
	    _classCallCheck(this, Internal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      shortURL: undefined
	    };
	    return _this;
	  }
	
	  Internal.prototype.sanitize = function sanitize(str) {
	    return str === undefined || str === null ? '' : str.replace(/'/gi, "\\\'").normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
	  };
	
	  Internal.prototype.render = function render() {
	    var _CUSTOMNAMESHEETS,
	        _SHEETIMAGE,
	        _this2 = this;
	
	    var data = this.props.data;
	    var location = this.props.location.pathname;
	    var filter = data.allSitePage.edges.filter(function (pag) {
	      var currentLoc = typeof window !== 'undefined' ? '' + ("/especial/noticias/te-explicamos/public") + pag.node.path + (location.endsWith('/') ? '/' : '') : pag.node.path;
	      return location === currentLoc;
	    });
	    var val = filter.length > 0 ? filter[0].node.context.node : {};
	    var trackTitle = val.sheet + ' - ' + this.sanitize(val.baraja) + ' - ' + this.sanitize(val.card);
	
	    var SHEETS = {
	      EDUCACION: 'Educación',
	      INMIGRACION: 'Inmigración',
	      DESASTRES_NATURALES: 'Desastres naturales'
	    };
	    var CUSTOMNAMESHEETS = (_CUSTOMNAMESHEETS = {}, _CUSTOMNAMESHEETS[SHEETS.EDUCACION] = 'Educación', _CUSTOMNAMESHEETS[SHEETS.DESASTRES_NATURALES] = 'Fenómenos naturales', _CUSTOMNAMESHEETS[SHEETS.INMIGRACION] = 'Inmigración', _CUSTOMNAMESHEETS);
	    var SHEETIMAGE = (_SHEETIMAGE = {}, _SHEETIMAGE[SHEETS.EDUCACION] = _educacion2.default, _SHEETIMAGE[SHEETS.DESASTRES_NATURALES] = _desastresNaturales2.default, _SHEETIMAGE[SHEETS.INMIGRACION] = _inmigracion2.default, _SHEETIMAGE);
	
	    var title = val.card;
	    var titleEscaped = title.replace(/'/gi, "\\\'");
	    var linkString = slugify(_.toLower(title));
	
	    if (this.state.shortURL === undefined) {
	      axios({
	        method: 'get',
	        url: 'https://syndicator.univision.com/web-api/content?url=' + val.url
	      }).then(function (result) {
	        if (result.status == 200 && result.data.data.code === undefined) {
	          _this2.setState({
	            shortURL: result.data.data.sharing.options.facebook.url
	          });
	        }
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: val.card },
	        _react2.default.createElement('link', { rel: 'canonical', href: val.url }),
	        _react2.default.createElement('script', { type: 'text/javascript', src: '//static.univision.com/external-content/uvn-iframe-resize.js' }),
	        _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Roboto:400,500,700', rel: 'stylesheet' }),
	        _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'contiene_internal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'containerInternal' },
	          _react2.default.createElement('h1', { className: 'titleBaraja' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'te-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'header-top' },
	              _react2.default.createElement('h1', { className: 'title-baraja' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'share-links-head' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Compartir'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    { onClick: function onClick() {
	                        return (0, _tracking.track_social_click)({ social_name: 'facebook', title: 'Te explicamos educación home' });
	                      } },
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://www.facebook.com/sharer.php?u=https://www.univision.com/noticias/educacion/te-explicamos', target: '_blank' },
	                      _react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { onClick: function onClick() {
	                        return (0, _tracking.track_social_click)({ social_name: 'twitter', title: 'Te explicamos educación home' });
	                      } },
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://twitter.com/share?url=https://www.univision.com/noticias/educacion/te-explicamos&text=Aprenda c\xF3mo hacer diferentes tr\xE1mites en Estados Unidos', target: '_blank' },
	                      _react2.default.createElement('i', { className: 'fa fa-twitter', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { onClick: function onClick() {
	                        return (0, _tracking.track_social_click)({ social_name: 'whatsapp', title: 'Te explicamos educación home' });
	                      }, className: 'hide-mobile' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'whatsapp://send?text=Te explicamos:Aprenda c\xF3mo hacer diferentes tr\xE1mites en Estados Unidos, Visita: https://www.univision.com/noticias/educacion/te-explicamos' },
	                      _react2.default.createElement('i', { className: 'whatsapp', 'aria-hidden': 'true' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { onClick: function onClick() {
	                        return (0, _tracking.track_social_click)({ social_name: 'mail', title: 'Te explicamos educación home' });
	                      } },
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:?&subject=Te explicamos:&body=Aprenda c\xF3mo hacer diferentes tr\xE1mites en Estados Unidos' },
	                      _react2.default.createElement('i', { className: 'email', 'aria-hidden': 'true' })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'feed' }),
	            _react2.default.createElement(
	              'section',
	              { className: 'cards-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'items', id: linkString },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-item' },
	                  _react2.default.createElement(
	                    'header',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon' },
	                      _react2.default.createElement('img', { src: SHEETIMAGE[val.sheet] })
	                    ),
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      CUSTOMNAMESHEETS[val.sheet]
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    title
	                  ),
	                  _react2.default.createElement('div', { className: 'card-content', id: val.idcard, dangerouslySetInnerHTML: { __html: val.text || '' } }),
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'source', target: '_blank', href: val.urlfuente !== undefined ? val.urlfuente : 'javascript:void(0);' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'source' },
	                      val.fuentes ? 'Fuente: ' + val.fuentes : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'share-links share-links-' + val.idcard },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Comparte'
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        { onClick: function onClick() {
	                            return (0, _tracking.track_social_click)({ social_name: 'facebook', title: titleEscaped });
	                          } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'https://www.facebook.com/sharer.php?u=' + val.url, target: '_blank' },
	                          _react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { onClick: function onClick() {
	                            return (0, _tracking.track_social_click)({ social_name: 'twitter', title: titleEscaped });
	                          } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'https://twitter.com/share?url=' + (this.state.shortURL || val.url) + '&text=' + (titleEscaped + ' ' + encodeURIComponent('#TeExplicamos')) + '&via=uninoticias', target: '_blank' },
	                          _react2.default.createElement('i', { className: 'fa fa-twitter', 'aria-hidden': 'true' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { onClick: function onClick() {
	                            return (0, _tracking.track_social_click)({ social_name: 'whatsapp', title: titleEscaped });
	                          }, className: 'hide-mobile' },
	                        _react2.default.createElement('a', { href: 'whatsapp://send?text=Te explicamos: ' + titleEscaped + '. Visita: ' + decodeURIComponent(this.state.shortURL || val.url), 'data-action': 'share/whatsapp/share', className: 'whatsapp' })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { onClick: function onClick() {
	                            return (0, _tracking.track_social_click)({ social_name: 'mail', title: titleEscaped });
	                          } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'mailto:?&subject=Te explicamos:' + titleEscaped + '&body=Visita: ' + (this.state.shortURL || val.url) },
	                          _react2.default.createElement('i', { className: 'email', 'aria-hidden': 'true' })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'moreAnswers' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'javascript:gatsby_redirect(\'' + decodeURIComponent(val.url) + '\');' },
	                    _react2.default.createElement('img', { src: _arrow_right2.default }),
	                    'M\xC1S RESPUESTAS'
	                  ),
	                  _react2.default.createElement('img', { src: _teExplicamosWhiteLogo2.default, className: 'onlyDesktop' }),
	                  _react2.default.createElement('img', { src: _teExplicamosWhiteLogoMobile2.default, className: 'onlyMobile' })
	                ),
	                _react2.default.createElement('div', { className: 'disclaimer', dangerouslySetInnerHTML: { __html: val.disclaimer } })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_tracking2.default, { trackTitle: trackTitle, currentSheet: val.sheet })
	    );
	  };
	
	  return Internal;
	}(_react2.default.Component);
	
	exports.default = Internal;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-internal-js-40203b50d957f010b0b4.js